webpackJsonp([1],Array(178).concat([
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(727);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_persistedstate__ = __webpack_require__(726);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__trial__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__enrollment__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__location__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__indication__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__investigator__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__coordinator__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__alert__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__user__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__shared__ = __webpack_require__(305);














__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  modules: {
    trial: __WEBPACK_IMPORTED_MODULE_3__trial__["a" /* default */],
    enrollment: __WEBPACK_IMPORTED_MODULE_4__enrollment__["a" /* default */],
    location: __WEBPACK_IMPORTED_MODULE_5__location__["a" /* default */],
    indication: __WEBPACK_IMPORTED_MODULE_6__indication__["a" /* default */],
    investigator: __WEBPACK_IMPORTED_MODULE_7__investigator__["a" /* default */],
    coordinator: __WEBPACK_IMPORTED_MODULE_8__coordinator__["a" /* default */],
    alert: __WEBPACK_IMPORTED_MODULE_9__alert__["a" /* default */],
    user: __WEBPACK_IMPORTED_MODULE_10__user__["a" /* default */],
    shared: __WEBPACK_IMPORTED_MODULE_11__shared__["a" /* default */]
  },
  plugins: [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex_persistedstate__["a" /* default */])()]
});

/***/ }),
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(322),
  /* template */
  __webpack_require__(694),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(356),
  /* template */
  __webpack_require__(669),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify__ = __webpack_require__(725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetify_dist_vuetify_css__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetify_dist_vuetify_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuetify_dist_vuetify_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_material_design_icons_styles_css__ = __webpack_require__(589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_material_design_icons_styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_material_design_icons_styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App__ = __webpack_require__(610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_firebase__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__filters_date__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Shared_Alert_vue__ = __webpack_require__(635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Shared_Alert_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_Shared_Alert_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_User_SignIn_vue__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_User_SignIn_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_User_SignIn_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_User_MenuSignIn_vue__ = __webpack_require__(656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_User_MenuSignIn_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_User_MenuSignIn_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Trials_Edit_EditTrialDetailsDialog_vue__ = __webpack_require__(641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Trials_Edit_EditTrialDetailsDialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_Trials_Edit_EditTrialDetailsDialog_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Trials_Edit_EditTrialEnrollmentsDialog_vue__ = __webpack_require__(642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Trials_Edit_EditTrialEnrollmentsDialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_Trials_Edit_EditTrialEnrollmentsDialog_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Trials_Edit_EditTrialLocationsDialog_vue__ = __webpack_require__(645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Trials_Edit_EditTrialLocationsDialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_Trials_Edit_EditTrialLocationsDialog_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Trials_Edit_EditTrialIndicationsDialog_vue__ = __webpack_require__(643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Trials_Edit_EditTrialIndicationsDialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_Trials_Edit_EditTrialIndicationsDialog_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Trials_Edit_EditTrialInvestigatorsDialog_vue__ = __webpack_require__(644);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Trials_Edit_EditTrialInvestigatorsDialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_Trials_Edit_EditTrialInvestigatorsDialog_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Trials_Edit_EditTrialCoordinatorsDialog_vue__ = __webpack_require__(640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Trials_Edit_EditTrialCoordinatorsDialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_Trials_Edit_EditTrialCoordinatorsDialog_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Enrollments_Edit_EditEnrollmentsDialog_vue__ = __webpack_require__(620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Enrollments_Edit_EditEnrollmentsDialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_Enrollments_Edit_EditEnrollmentsDialog_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_Locations_Edit_EditLocationsDialog_vue__ = __webpack_require__(632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_Locations_Edit_EditLocationsDialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_Locations_Edit_EditLocationsDialog_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_Indications_Edit_EditIndicationsDialog_vue__ = __webpack_require__(624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_Indications_Edit_EditIndicationsDialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_Indications_Edit_EditIndicationsDialog_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_Indications_CreateIndication_vue__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_Indications_CreateIndication_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_Indications_CreateIndication_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_Investigators_Edit_EditInvestigatorsDialog_vue__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_Investigators_Edit_EditInvestigatorsDialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_Investigators_Edit_EditInvestigatorsDialog_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_Coordinators_Edit_EditCoordinatorsDialog_vue__ = __webpack_require__(618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_Coordinators_Edit_EditCoordinatorsDialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__components_Coordinators_Edit_EditCoordinatorsDialog_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_Alert_Edit_EditAlertsDialog_vue__ = __webpack_require__(614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_Alert_Edit_EditAlertsDialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__components_Alert_Edit_EditAlertsDialog_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__assets_close_svg__ = __webpack_require__(712);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__assets_close_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__assets_close_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__assets_edit_svg__ = __webpack_require__(714);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__assets_edit_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__assets_edit_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__assets_email_svg__ = __webpack_require__(715);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__assets_email_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__assets_email_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__assets_home_svg__ = __webpack_require__(716);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__assets_home_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__assets_home_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__assets_indication_svg__ = __webpack_require__(717);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__assets_indication_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__assets_indication_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__assets_investigator_svg__ = __webpack_require__(718);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__assets_investigator_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__assets_investigator_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__assets_person_svg__ = __webpack_require__(720);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__assets_person_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__assets_person_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__assets_phone_svg__ = __webpack_require__(721);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__assets_phone_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__assets_phone_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__assets_trash_svg__ = __webpack_require__(723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__assets_trash_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__assets_trash_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__assets_trial_svg__ = __webpack_require__(724);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__assets_trial_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__assets_trial_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__assets_map_svg__ = __webpack_require__(719);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__assets_map_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__assets_map_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__assets_document_svg__ = __webpack_require__(713);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__assets_document_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__assets_document_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__assets_right_chevron_svg__ = __webpack_require__(722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__assets_right_chevron_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37__assets_right_chevron_svg__);











// Material Design Lite Icons
// import MapMarker from 'vue-material-design-icons/map-marker-outline.vue'

// Edit Components

















__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('date', __WEBPACK_IMPORTED_MODULE_8__filters_date__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('app-alert', __WEBPACK_IMPORTED_MODULE_9__components_Shared_Alert_vue___default.a);

// Material Design Lite Icons
// Vue.component('map-marker-icon', MapMarker)

// Custom SVG Icon Import














// Custom SVG Icon Import
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('close-icon', __WEBPACK_IMPORTED_MODULE_25__assets_close_svg___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('edit-icon', __WEBPACK_IMPORTED_MODULE_26__assets_edit_svg___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('emailIcon', __WEBPACK_IMPORTED_MODULE_27__assets_email_svg___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('home-icon', __WEBPACK_IMPORTED_MODULE_28__assets_home_svg___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('indication-icon', __WEBPACK_IMPORTED_MODULE_29__assets_indication_svg___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('investigator-icon', __WEBPACK_IMPORTED_MODULE_30__assets_investigator_svg___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('person-icon', __WEBPACK_IMPORTED_MODULE_31__assets_person_svg___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('phoneIcon', __WEBPACK_IMPORTED_MODULE_32__assets_phone_svg___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('trash-icon', __WEBPACK_IMPORTED_MODULE_33__assets_trash_svg___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('trial-icon', __WEBPACK_IMPORTED_MODULE_34__assets_trial_svg___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('map-icon', __WEBPACK_IMPORTED_MODULE_35__assets_map_svg___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('document-icon', __WEBPACK_IMPORTED_MODULE_36__assets_document_svg___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('right-icon', __WEBPACK_IMPORTED_MODULE_37__assets_right_chevron_svg___default.a);

// Trial Edit Components
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('app-edit-login-dialog', __WEBPACK_IMPORTED_MODULE_10__components_User_SignIn_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('app-edit-menu-login-dialog', __WEBPACK_IMPORTED_MODULE_11__components_User_MenuSignIn_vue___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('app-edit-trial-details-dialog', __WEBPACK_IMPORTED_MODULE_12__components_Trials_Edit_EditTrialDetailsDialog_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('app-edit-trial-enrollments-dialog', __WEBPACK_IMPORTED_MODULE_13__components_Trials_Edit_EditTrialEnrollmentsDialog_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('app-edit-trial-locations-dialog', __WEBPACK_IMPORTED_MODULE_14__components_Trials_Edit_EditTrialLocationsDialog_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('app-edit-trial-indications-dialog', __WEBPACK_IMPORTED_MODULE_15__components_Trials_Edit_EditTrialIndicationsDialog_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('app-edit-trial-investigators-dialog', __WEBPACK_IMPORTED_MODULE_16__components_Trials_Edit_EditTrialInvestigatorsDialog_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('app-edit-trial-coordinators-dialog', __WEBPACK_IMPORTED_MODULE_17__components_Trials_Edit_EditTrialCoordinatorsDialog_vue___default.a);
// Alert Edit Components
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('app-edit-alert-dialog', __WEBPACK_IMPORTED_MODULE_24__components_Alert_Edit_EditAlertsDialog_vue___default.a);
// Enrollment Edit Components
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('app-edit-enrollment-dialog', __WEBPACK_IMPORTED_MODULE_18__components_Enrollments_Edit_EditEnrollmentsDialog_vue___default.a);
// Location Edit Components
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('app-edit-location-dialog', __WEBPACK_IMPORTED_MODULE_19__components_Locations_Edit_EditLocationsDialog_vue___default.a);
// Indication Edit Components
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('app-edit-indication-dialog', __WEBPACK_IMPORTED_MODULE_20__components_Indications_Edit_EditIndicationsDialog_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('app-create-indication-dialog', __WEBPACK_IMPORTED_MODULE_21__components_Indications_CreateIndication_vue___default.a);
// Investigator Edit Components
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('app-edit-investigator-dialog', __WEBPACK_IMPORTED_MODULE_22__components_Investigators_Edit_EditInvestigatorsDialog_vue___default.a);
// Coordinator Edit Components
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('app-edit-coordinator-dialog', __WEBPACK_IMPORTED_MODULE_23__components_Coordinators_Edit_EditCoordinatorsDialog_vue___default.a);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_7__store__["a" /* store */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_4__App___default.a);
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_5_firebase__["initializeApp"]({
      apiKey: 'AIzaSyAtrRjTdzRvTDvqjdxX0h_cvLNdRad17Gg',
      authDomain: 'vip-trials-app.firebaseapp.com',
      databaseURL: 'https://vip-trials-app.firebaseio.com/',
      projectId: 'vip-trials-app',
      storageBucket: 'gs://vip-trials-app.appspot.com'
    });
    __WEBPACK_IMPORTED_MODULE_5_firebase__["auth"]().onAuthStateChanged(function (user) {
      if (user) {
        _this.$store.dispatch('autoSignIn', user);
      }
    });
    this.$store.dispatch('loadTrials');
    this.$store.dispatch('loadEnrollments');
    this.$store.dispatch('loadLocations');
    this.$store.dispatch('loadIndications');
    this.$store.dispatch('loadInvestigators');
    this.$store.dispatch('loadCoordinators');
    this.$store.dispatch('loadedNotice');
  }
});

/***/ }),
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (value) {
  var date = new Date(value);
  return date.toLocaleString(['en-US'], { month: 'short', day: '2-digit', yead: 'numeric', hour: '2-digit', minute: '2-digit' });
});

/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(178);


/* harmony default export */ __webpack_exports__["a"] = (function (to, from, next) {
  if (__WEBPACK_IMPORTED_MODULE_0__store__["a" /* store */].getters.user) {
    next();
  } else {
    next('/signin');
  }
});

/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(710);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home__ = __webpack_require__(623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Trials_Enrollments_Archive__ = __webpack_require__(646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Trials_Enrollments_Archive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Trials_Enrollments_Archive__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Trials_Enrollments_Singular__ = __webpack_require__(647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Trials_Enrollments_Singular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Trials_Enrollments_Singular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Trials_Locations_Archive__ = __webpack_require__(652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Trials_Locations_Archive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Trials_Locations_Archive__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Trials_Locations_Singular__ = __webpack_require__(653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Trials_Locations_Singular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Trials_Locations_Singular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Trials_Indications_Archive__ = __webpack_require__(648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Trials_Indications_Archive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Trials_Indications_Archive__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Trials_Indications_Singular__ = __webpack_require__(649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Trials_Indications_Singular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Trials_Indications_Singular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Trials_Investigators_Archive__ = __webpack_require__(650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Trials_Investigators_Archive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_Trials_Investigators_Archive__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Trials_Investigators_Singular__ = __webpack_require__(651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Trials_Investigators_Singular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_Trials_Investigators_Singular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Trials_Coordinators_Archive__ = __webpack_require__(636);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Trials_Coordinators_Archive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_Trials_Coordinators_Archive__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Trials_Coordinators_Singular__ = __webpack_require__(637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Trials_Coordinators_Singular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_Trials_Coordinators_Singular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Trials_Trial__ = __webpack_require__(654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Trials_Trial___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_Trials_Trial__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Trials_Edit_EditTrial__ = __webpack_require__(639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Trials_Edit_EditTrial___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_Trials_Edit_EditTrial__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Trials_Trials__ = __webpack_require__(655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Trials_Trials___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_Trials_Trials__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Trials_CreateTrial__ = __webpack_require__(638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Trials_CreateTrial___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_Trials_CreateTrial__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Enrollments_Enrollment__ = __webpack_require__(621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Enrollments_Enrollment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_Enrollments_Enrollment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Enrollments_Enrollments__ = __webpack_require__(622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Enrollments_Enrollments___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_Enrollments_Enrollments__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_Enrollments_CreateEnrollment__ = __webpack_require__(619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_Enrollments_CreateEnrollment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_Enrollments_CreateEnrollment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_Locations_Location__ = __webpack_require__(633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_Locations_Location___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_Locations_Location__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_Locations_Locations__ = __webpack_require__(634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_Locations_Locations___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_Locations_Locations__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_Locations_CreateLocation__ = __webpack_require__(631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_Locations_CreateLocation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_Locations_CreateLocation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_Indications_Indication__ = __webpack_require__(625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_Indications_Indication___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__components_Indications_Indication__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_Indications_Indications__ = __webpack_require__(626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_Indications_Indications___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__components_Indications_Indications__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_Indications_CreateIndication__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_Indications_CreateIndication___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__components_Indications_CreateIndication__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_Investigators_Investigator__ = __webpack_require__(629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_Investigators_Investigator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__components_Investigators_Investigator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_Investigators_Investigators__ = __webpack_require__(630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_Investigators_Investigators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__components_Investigators_Investigators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_Investigators_CreateInvestigator__ = __webpack_require__(627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_Investigators_CreateInvestigator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__components_Investigators_CreateInvestigator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_Coordinators_Coordinator__ = __webpack_require__(615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_Coordinators_Coordinator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__components_Coordinators_Coordinator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_Coordinators_Coordinators__ = __webpack_require__(616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_Coordinators_Coordinators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__components_Coordinators_Coordinators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_Coordinators_CreateCoordinator__ = __webpack_require__(617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_Coordinators_CreateCoordinator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__components_Coordinators_CreateCoordinator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_Alert_Alert__ = __webpack_require__(611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_Alert_Alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__components_Alert_Alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_Alert_Alerts__ = __webpack_require__(612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_Alert_Alerts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__components_Alert_Alerts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_Alert_CreateAlert__ = __webpack_require__(613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_Alert_CreateAlert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__components_Alert_CreateAlert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_User_Profile__ = __webpack_require__(657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_User_Profile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__components_User_Profile__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_User_SignIn__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_User_SignIn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__components_User_SignIn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_User_SignUp__ = __webpack_require__(658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_User_SignUp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37__components_User_SignUp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__auth_guard__ = __webpack_require__(297);








































__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Home___default.a
  }, {
    path: '/Trials/Enrollments',
    name: 'TrialsByEnrollment',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Trials_Enrollments_Archive___default.a
  }, {
    path: '/Trials/enrollments/:enrollmentId',
    name: 'TrialsByEnrollmentSpecific',
    props: true,
    component: __WEBPACK_IMPORTED_MODULE_4__components_Trials_Enrollments_Singular___default.a
  }, {
    path: '/Trials/Locations',
    name: 'TrialsByLocation',
    component: __WEBPACK_IMPORTED_MODULE_5__components_Trials_Locations_Archive___default.a
  }, {
    path: '/Trials/locations/:locationId',
    name: 'TrialsByLocationSpecific',
    props: true,
    component: __WEBPACK_IMPORTED_MODULE_6__components_Trials_Locations_Singular___default.a
  }, {
    path: '/Trials/Indications',
    name: 'TrialsByIndication',
    component: __WEBPACK_IMPORTED_MODULE_7__components_Trials_Indications_Archive___default.a
  }, {
    path: '/Trials/indications/:indicationId',
    name: 'TrialsByIndicationSpecific',
    props: true,
    component: __WEBPACK_IMPORTED_MODULE_8__components_Trials_Indications_Singular___default.a
  }, {
    path: '/Trials/Investigators',
    name: 'TrialsByInvestigator',
    component: __WEBPACK_IMPORTED_MODULE_9__components_Trials_Investigators_Archive___default.a
  }, {
    path: '/Trials/investigators/:investigatorId',
    name: 'TrialsByInvestigatorSpecific',
    props: true,
    component: __WEBPACK_IMPORTED_MODULE_10__components_Trials_Investigators_Singular___default.a
  }, {
    path: '/Trials/Coordinators',
    name: 'TrialsByCoordinator',
    component: __WEBPACK_IMPORTED_MODULE_11__components_Trials_Coordinators_Archive___default.a
  }, {
    path: '/Trials/coordinators/:coordinatorId',
    name: 'TrialsByCoordinatorSpecific',
    props: true,
    component: __WEBPACK_IMPORTED_MODULE_12__components_Trials_Coordinators_Singular___default.a
  }, {
    path: '/trials',
    name: 'Trials',
    component: __WEBPACK_IMPORTED_MODULE_15__components_Trials_Trials___default.a
  }, {
    path: '/trial/new',
    name: 'CreateTrial',
    component: __WEBPACK_IMPORTED_MODULE_16__components_Trials_CreateTrial___default.a,
    beforeEnter: __WEBPACK_IMPORTED_MODULE_38__auth_guard__["a" /* default */]
  }, {
    path: '/trials/:id',
    name: 'Trial',
    props: true,
    component: __WEBPACK_IMPORTED_MODULE_13__components_Trials_Trial___default.a
  }, {
    path: '/trials/:id/edit',
    name: 'EditTrial',
    props: true,
    component: __WEBPACK_IMPORTED_MODULE_14__components_Trials_Edit_EditTrial___default.a
  }, {
    path: '/enrollments',
    name: 'Enrollments',
    component: __WEBPACK_IMPORTED_MODULE_18__components_Enrollments_Enrollments___default.a
  }, {
    path: '/enrollment/new',
    name: 'CreateEnrollment',
    component: __WEBPACK_IMPORTED_MODULE_19__components_Enrollments_CreateEnrollment___default.a,
    beforeEnter: __WEBPACK_IMPORTED_MODULE_38__auth_guard__["a" /* default */]
  }, {
    path: '/Enrollments/:id',
    name: 'Enrollment',
    props: true,
    component: __WEBPACK_IMPORTED_MODULE_17__components_Enrollments_Enrollment___default.a
  }, {
    path: '/locations',
    name: 'Locations',
    component: __WEBPACK_IMPORTED_MODULE_21__components_Locations_Locations___default.a
  }, {
    path: '/location/new',
    name: 'CreateLocation',
    component: __WEBPACK_IMPORTED_MODULE_22__components_Locations_CreateLocation___default.a,
    beforeEnter: __WEBPACK_IMPORTED_MODULE_38__auth_guard__["a" /* default */]
  }, {
    path: '/Locations/:id',
    name: 'Location',
    props: true,
    component: __WEBPACK_IMPORTED_MODULE_20__components_Locations_Location___default.a
  }, {
    path: '/indications',
    name: 'Indications',
    component: __WEBPACK_IMPORTED_MODULE_24__components_Indications_Indications___default.a
  }, {
    path: '/indication/new',
    name: 'CreateIndication',
    component: __WEBPACK_IMPORTED_MODULE_25__components_Indications_CreateIndication___default.a,
    beforeEnter: __WEBPACK_IMPORTED_MODULE_38__auth_guard__["a" /* default */]
  }, {
    path: '/indications/:id',
    name: 'Indication',
    props: true,
    component: __WEBPACK_IMPORTED_MODULE_23__components_Indications_Indication___default.a
  }, {
    path: '/investigators',
    name: 'Investigators',
    component: __WEBPACK_IMPORTED_MODULE_27__components_Investigators_Investigators___default.a
  }, {
    path: '/investigator/new',
    name: 'CreateInvestigator',
    component: __WEBPACK_IMPORTED_MODULE_28__components_Investigators_CreateInvestigator___default.a,
    beforeEnter: __WEBPACK_IMPORTED_MODULE_38__auth_guard__["a" /* default */]
  }, {
    path: '/investigator/:id',
    name: 'investigator',
    props: true,
    component: __WEBPACK_IMPORTED_MODULE_26__components_Investigators_Investigator___default.a
  }, {
    path: '/coordinators',
    name: 'Coordinators',
    component: __WEBPACK_IMPORTED_MODULE_30__components_Coordinators_Coordinators___default.a
  }, {
    path: '/coordinator/new',
    name: 'CreateCoordinator',
    component: __WEBPACK_IMPORTED_MODULE_31__components_Coordinators_CreateCoordinator___default.a,
    beforeEnter: __WEBPACK_IMPORTED_MODULE_38__auth_guard__["a" /* default */]
  }, {
    path: '/coordinator/:id',
    name: 'coordinator',
    props: true,
    component: __WEBPACK_IMPORTED_MODULE_29__components_Coordinators_Coordinator___default.a
  }, {
    path: '/alerts',
    name: 'Alerts',
    component: __WEBPACK_IMPORTED_MODULE_33__components_Alert_Alerts___default.a
  }, {
    path: '/alert/new',
    name: 'CreateAlert',
    component: __WEBPACK_IMPORTED_MODULE_34__components_Alert_CreateAlert___default.a,
    beforeEnter: __WEBPACK_IMPORTED_MODULE_38__auth_guard__["a" /* default */]
  }, {
    path: '/alert/:id',
    name: 'alert',
    props: true,
    component: __WEBPACK_IMPORTED_MODULE_32__components_Alert_Alert___default.a
  }, {
    path: '/profile',
    name: 'Profile',
    component: __WEBPACK_IMPORTED_MODULE_35__components_User_Profile___default.a,
    beforeEnter: __WEBPACK_IMPORTED_MODULE_38__auth_guard__["a" /* default */]
  }, {
    path: '/signin',
    name: 'SignIn',
    component: __WEBPACK_IMPORTED_MODULE_36__components_User_SignIn___default.a
  }, {
    path: '/signup',
    name: 'Signup',
    component: __WEBPACK_IMPORTED_MODULE_37__components_User_SignUp___default.a
  }],
  mode: 'history'
}));

/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_firebase__);



// import { state } from 'fs/promises';

/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    loadedNotice: ''
  },
  mutations: {
    setLoadedNotice: function setLoadedNotice(state, payload) {
      state.loadedNotice = payload;
    },
    createNotice: function createNotice(state, payload) {
      state.loadedNotice = payload;
    },
    updateNotice: function updateNotice(state, payload) {
      state.loadedNotice = payload.noticeName;
    },
    deleteNotice: function deleteNotice(state, payload) {
      state.loadedNotice = null;
    }
  },
  actions: {
    loadedNotice: function loadedNotice(_ref) {
      var commit = _ref.commit;

      commit('setLoading', true);
      __WEBPACK_IMPORTED_MODULE_2_firebase__["database"]().ref('notice').once('value').then(function (data) {
        var obj = data.val();
        console.log(obj);
        commit('setLoadedNotice', obj);
        commit('setLoading', false);
      }).catch(function (error) {
        console.log(error);
        commit('setLoading', true);
      });
    },
    createNotice: function createNotice(_ref2, payload) {
      var commit = _ref2.commit,
          getters = _ref2.getters;

      var notice = {
        noticeName: payload
        // noticeId: 'alkasjdf', DON'T NEED BECAUSE FIREBASE AUTO GENERATES ID
      };
      __WEBPACK_IMPORTED_MODULE_2_firebase__["database"]().ref('notice').update(notice).then(function () {
        commit('createNotice', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, notice));
      }).catch(function (error) {
        console.log(error);
      });
      // Reach out to firebase and store it
      // commit('createNotice', notice)
    },

    // May have to create a separate Action for each updated item (i.e. updateNoticeNotice, updateNoticeDescription, etc)
    updateNoticeData: function updateNoticeData(_ref3, payload) {
      var commit = _ref3.commit;

      commit('setLoading', true);
      __WEBPACK_IMPORTED_MODULE_2_firebase__["database"]().ref('notice').update(payload).then(function () {
        commit('setLoading', false);
        commit('updateNotice', payload);
      }).catch(function (error) {
        console.log(error);
        commit('setLoading', false);
      });
    },
    deleteNoticeData: function deleteNoticeData(_ref4, payload) {
      var commit = _ref4.commit;

      commit('setLoading', true);
      console.log('Payload: ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(payload));
      __WEBPACK_IMPORTED_MODULE_2_firebase__["database"]().ref('notice').remove().then(function () {
        commit('setLoading', false);
        commit('deleteNotice', payload);
      }).catch(function (error) {
        console.log(error);
        commit('setLoading', false);
      });
    }
  },
  getters: {
    loadedNotice: function loadedNotice(state) {
      return state.loadedNotice;
    }
  }
});

/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_firebase__);




/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    loadedCoordinators: [{
      coordinatorId: 'tri',
      coordinatorName: 'Coordinator Sample',
      coordinatorPhone: '123-123-1234',
      coordinatorEmail: 'test@test.com'
    }]
  },
  mutations: {
    setLoadedCoordinators: function setLoadedCoordinators(state, payload) {
      state.loadedCoordinators = payload;
    },
    createCoordinator: function createCoordinator(state, payload) {
      state.loadedCoordinators.push(payload);
    },
    updateCoordinator: function updateCoordinator(state, payload) {
      var coordinator = state.loadedCoordinators.find(function (coordinator) {
        return coordinator.coordinatorId === payload.coordinatorId;
      });
      if (payload.coordinatorName) {
        coordinator.coordinatorName = payload.coordinatorName;
      }
      if (payload.coordinatorPhone) {
        coordinator.coordinatorPhone = payload.coordinatorPhone;
      }
      if (payload.coordinatorEmail) {
        coordinator.coordinatorEmail = payload.coordinatorEmail;
      }
    },
    deleteCoordinator: function deleteCoordinator(state, payload) {
      var coordinator = state.loadedCoordinators.find(function (coordinator) {
        return coordinator.coordinatorId === payload.coordinatorId;
      });
      var todos = state.loadedCoordinators;
      todos.splice(todos.indexOf(coordinator), 1);
    }
  },
  actions: {
    loadCoordinators: function loadCoordinators(_ref) {
      var commit = _ref.commit;

      commit('setLoading', true);
      __WEBPACK_IMPORTED_MODULE_2_firebase__["database"]().ref('coordinators').once('value').then(function (data) {
        var coordinators = [];
        var obj = data.val();
        for (var key in obj) {
          coordinators.push({
            coordinatorId: key,
            coordinatorName: obj[key].coordinatorName,
            coordinatorPhone: obj[key].coordinatorPhone,
            coordinatorEmail: obj[key].coordinatorEmail,
            creatorId: obj[key].creatorId
          });
        }
        console.log(coordinators);
        commit('setLoadedCoordinators', coordinators);
        commit('setLoading', false);
      }).catch(function (error) {
        console.log(error);
        commit('setLoading', true);
      });
    },
    createCoordinator: function createCoordinator(_ref2, payload) {
      var commit = _ref2.commit,
          getters = _ref2.getters;

      var coordinator = {
        coordinatorName: payload.title,
        coordinatorPhone: payload.coordinatorPhone,
        coordinatorEmail: payload.coordinatorEmail,
        // coordinatorId: 'alkasjdf', DON'T NEED BECAUSE FIREBASE AUTO GENERATES ID
        icon: 'coordinator_on',
        creatorId: getters.user.id
      };
      __WEBPACK_IMPORTED_MODULE_2_firebase__["database"]().ref('coordinators').push(coordinator).then(function () {
        commit('createCoordinator', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, coordinator));
      }).catch(function (error) {
        console.log(error);
      });
      // Reach out to firebase and store it
      // commit('createCoordinator', coordinator)
    },

    // May have to create a separate Action for each updated item (i.e. updateCoordinatorCoordinator, updateCoordinatorDescription, etc)
    updateCoordinatorData: function updateCoordinatorData(_ref3, payload) {
      var commit = _ref3.commit;

      commit('setLoading', true);
      var updateObj = {};
      if (payload.coordinatorName) {
        updateObj.coordinatorName = payload.coordinatorName;
      }
      if (payload.coordinatorPhone) {
        updateObj.coordinatorPhone = payload.coordinatorPhone;
      }
      if (payload.coordinatorEmail) {
        updateObj.coordinatorEmail = payload.coordinatorEmail;
      }
      __WEBPACK_IMPORTED_MODULE_2_firebase__["database"]().ref('coordinators').child(payload.coordinatorId).update(updateObj).then(function () {
        commit('setLoading', false);
        commit('updateCoordinator', payload);
      }).catch(function (error) {
        console.log(error);
        commit('setLoading', false);
      });
    },
    deleteCoordinatorData: function deleteCoordinatorData(_ref4, payload) {
      var commit = _ref4.commit;

      commit('setLoading', true);
      console.log('Payload: ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(payload));
      __WEBPACK_IMPORTED_MODULE_2_firebase__["database"]().ref('coordinators').child(payload.coordinatorId).remove().then(function () {
        commit('setLoading', false);
        commit('deleteCoordinator', payload);
      }).catch(function (error) {
        console.log(error);
        commit('setLoading', false);
      });
    }
  },
  getters: {
    loadedCoordinators: function loadedCoordinators(state) {
      return state.loadedCoordinators.sort(function (coordinatorA, coordinatorB) {
        return coordinatorA.date > coordinatorB.date;
      });
    },
    featuredCoordinators: function featuredCoordinators(state, getters) {
      return getters.loadedCoordinators.slice(0, 5);
    },
    loadedCoordinator: function loadedCoordinator(state) {
      return function (someId) {
        return state.loadedCoordinators.find(function (coordinator) {
          return coordinator.coordinatorId === someId;
        });
      };
    }
  }
});

/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_firebase__);




/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    loadedEnrollments: [{
      enrollmentId: 'tri',
      enrollmentName: 'Enrollment Sample',
      enrollmentPriority: '0'
    }]
  },
  mutations: {
    setLoadedEnrollments: function setLoadedEnrollments(state, payload) {
      state.loadedEnrollments = payload;
    },
    createEnrollment: function createEnrollment(state, payload) {
      state.loadedEnrollments.push(payload);
    },
    updateEnrollment: function updateEnrollment(state, payload) {
      var enrollment = state.loadedEnrollments.find(function (enrollment) {
        return enrollment.enrollmentId === payload.enrollmentId;
      });
      if (payload.enrollmentName) {
        enrollment.enrollmentName = payload.enrollmentName;
      }
      if (payload.enrollmentPriority) {
        enrollment.enrollmentPriority = payload.enrollmentPriority;
      }
    },
    deleteEnrollment: function deleteEnrollment(state, payload) {
      var enrollment = state.loadedEnrollments.find(function (enrollment) {
        return enrollment.enrollmentId === payload.enrollmentId;
      });
      var todos = state.loadedEnrollments;
      todos.splice(todos.indexOf(enrollment), 1);
    }
  },
  actions: {
    loadEnrollments: function loadEnrollments(_ref) {
      var commit = _ref.commit;

      commit('setLoading', true);
      __WEBPACK_IMPORTED_MODULE_2_firebase__["database"]().ref('enrollments').once('value').then(function (data) {
        var enrollments = [];
        var obj = data.val();
        for (var key in obj) {
          enrollments.push({
            enrollmentId: key,
            enrollmentName: obj[key].enrollmentName,
            enrollmentPriority: obj[key].enrollmentPriority,
            creatorId: obj[key].creatorId
          });
        }
        console.log(enrollments);
        commit('setLoadedEnrollments', enrollments);
        commit('setLoading', false);
      }).catch(function (error) {
        console.log(error);
        commit('setLoading', true);
      });
    },
    createEnrollment: function createEnrollment(_ref2, payload) {
      var commit = _ref2.commit,
          getters = _ref2.getters;

      var enrollment = {
        enrollmentName: payload.title,
        enrollmentPriority: payload.enrollmentPriority,
        // enrollmentId: 'alkasjdf', DON'T NEED BECAUSE FIREBASE AUTO GENERATES ID
        icon: 'enrollment_on',
        creatorId: getters.user.id
      };
      __WEBPACK_IMPORTED_MODULE_2_firebase__["database"]().ref('enrollments').push(enrollment).then(function () {
        commit('createEnrollment', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, enrollment));
      }).catch(function (error) {
        console.log(error);
      });
      // Reach out to firebase and store it
      // commit('createEnrollment', enrollment)
    },

    // May have to create a separate Action for each updated item (i.e. updateEnrollmentEnrollment, updateEnrollmentDescription, etc)
    updateEnrollmentData: function updateEnrollmentData(_ref3, payload) {
      var commit = _ref3.commit;

      commit('setLoading', true);
      var updateObj = {};
      if (payload.enrollmentName) {
        updateObj.enrollmentName = payload.enrollmentName;
      }
      if (payload.enrollmentPriority) {
        updateObj.enrollmentPriority = payload.enrollmentPriority;
      }
      __WEBPACK_IMPORTED_MODULE_2_firebase__["database"]().ref('enrollments').child(payload.enrollmentId).update(updateObj).then(function () {
        commit('setLoading', false);
        commit('updateEnrollment', payload);
      }).catch(function (error) {
        console.log(error);
        commit('setLoading', false);
      });
    },
    deleteEnrollmentData: function deleteEnrollmentData(_ref4, payload) {
      var commit = _ref4.commit;

      commit('setLoading', true);
      console.log('Payload: ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(payload));
      __WEBPACK_IMPORTED_MODULE_2_firebase__["database"]().ref('enrollments').child(payload.enrollmentId).remove().then(function () {
        commit('setLoading', false);
        commit('deleteEnrollment', payload);
      }).catch(function (error) {
        console.log(error);
        commit('setLoading', false);
      });
    }
  },
  getters: {
    loadedEnrollments: function loadedEnrollments(state) {
      return state.loadedEnrollments.sort(function (enrollmentA, enrollmentB) {
        return enrollmentA.enrollmentPriority > enrollmentB.enrollmentPriority;
      });
    },
    featuredEnrollments: function featuredEnrollments(state, getters) {
      return getters.loadedEnrollments.slice(0, 5);
    },
    loadedEnrollment: function loadedEnrollment(state) {
      return function (someId) {
        return state.loadedEnrollments.find(function (enrollment) {
          return enrollment.enrollmentId === someId;
        });
      };
    }
  }
});

/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_firebase__);




/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    loadedIndications: [{
      indicationId: 'tri',
      indicationName: 'Indication Sample'
    }]
  },
  mutations: {
    setLoadedIndications: function setLoadedIndications(state, payload) {
      state.loadedIndications = payload;
    },
    createIndication: function createIndication(state, payload) {
      state.loadedIndications.push(payload);
    },
    updateIndication: function updateIndication(state, payload) {
      var indication = state.loadedIndications.find(function (indication) {
        return indication.indicationId === payload.indicationId;
      });
      if (payload.indicationName) {
        indication.indicationName = payload.indicationName;
      }
    },
    deleteIndication: function deleteIndication(state, payload) {
      var indication = state.loadedIndications.find(function (indication) {
        return indication.indicationId === payload.indicationId;
      });
      var todos = state.loadedIndications;
      todos.splice(todos.indexOf(indication), 1);
    }
  },
  actions: {
    loadIndications: function loadIndications(_ref) {
      var commit = _ref.commit;

      commit('setLoading', true);
      __WEBPACK_IMPORTED_MODULE_2_firebase__["database"]().ref('indications').once('value').then(function (data) {
        var indications = [];
        var obj = data.val();
        for (var key in obj) {
          indications.push({
            indicationId: key,
            indicationName: obj[key].indicationName,
            creatorId: obj[key].creatorId
          });
        }
        console.log(indications);
        commit('setLoadedIndications', indications);
        commit('setLoading', false);
      }).catch(function (error) {
        console.log(error);
        commit('setLoading', true);
      });
    },
    createIndication: function createIndication(_ref2, payload) {
      var commit = _ref2.commit,
          getters = _ref2.getters;

      var indication = {
        indicationName: payload.title,
        // indicationId: 'alkasjdf', DON'T NEED BECAUSE FIREBASE AUTO GENERATES ID
        icon: 'indication_on',
        creatorId: getters.user.id
      };
      __WEBPACK_IMPORTED_MODULE_2_firebase__["database"]().ref('indications').push(indication).then(function () {
        commit('createIndication', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, indication));
      }).catch(function (error) {
        console.log(error);
      });
      // Reach out to firebase and store it
      // commit('createIndication', indication)
    },

    // May have to create a separate Action for each updated item (i.e. updateIndicationIndication, updateIndicationDescription, etc)
    updateIndicationData: function updateIndicationData(_ref3, payload) {
      var commit = _ref3.commit;

      commit('setLoading', true);
      var updateObj = {};
      if (payload.indicationName) {
        updateObj.indicationName = payload.indicationName;
      }
      __WEBPACK_IMPORTED_MODULE_2_firebase__["database"]().ref('indications').child(payload.indicationId).update(updateObj).then(function () {
        commit('setLoading', false);
        commit('updateIndication', payload);
      }).catch(function (error) {
        console.log(error);
        commit('setLoading', false);
      });
    },
    deleteIndicationData: function deleteIndicationData(_ref4, payload) {
      var commit = _ref4.commit;

      commit('setLoading', true);
      console.log('Payload: ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(payload));
      __WEBPACK_IMPORTED_MODULE_2_firebase__["database"]().ref('indications').child(payload.indicationId).remove().then(function () {
        commit('setLoading', false);
        commit('deleteIndication', payload);
      }).catch(function (error) {
        console.log(error);
        commit('setLoading', false);
      });
    }
  },
  getters: {
    loadedIndications: function loadedIndications(state) {
      return state.loadedIndications.sort(function (indicationA, indicationB) {
        return indicationA.date > indicationB.date;
      });
    },
    featuredIndications: function featuredIndications(state, getters) {
      return getters.loadedIndications.slice(0, 5);
    },
    loadedIndication: function loadedIndication(state) {
      return function (someId) {
        return state.loadedIndications.find(function (indication) {
          return indication.indicationId === someId;
        });
      };
    }
  }
});

/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_firebase__);




/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    loadedInvestigators: [{
      investigatorId: 'tri',
      investigatorName: 'Investigator Sample',
      investigatorPhone: '123-123-1234',
      investigatorEmail: 'test@test.com'
    }]
  },
  mutations: {
    setLoadedInvestigators: function setLoadedInvestigators(state, payload) {
      state.loadedInvestigators = payload;
    },
    createInvestigator: function createInvestigator(state, payload) {
      state.loadedInvestigators.push(payload);
    },
    updateInvestigator: function updateInvestigator(state, payload) {
      var investigator = state.loadedInvestigators.find(function (investigator) {
        return investigator.investigatorId === payload.investigatorId;
      });
      if (payload.investigatorName) {
        investigator.investigatorName = payload.investigatorName;
      }
      if (payload.investigatorPhone) {
        investigator.investigatorPhone = payload.investigatorPhone;
      }
      if (payload.investigatorEmail) {
        investigator.investigatorEmail = payload.investigatorEmail;
      }
    },
    deleteInvestigator: function deleteInvestigator(state, payload) {
      var investigator = state.loadedInvestigators.find(function (investigator) {
        return investigator.investigatorId === payload.investigatorId;
      });
      var todos = state.loadedInvestigators;
      todos.splice(todos.indexOf(investigator), 1);
    }
  },
  actions: {
    loadInvestigators: function loadInvestigators(_ref) {
      var commit = _ref.commit;

      commit('setLoading', true);
      __WEBPACK_IMPORTED_MODULE_2_firebase__["database"]().ref('investigators').once('value').then(function (data) {
        var investigators = [];
        var obj = data.val();
        for (var key in obj) {
          investigators.push({
            investigatorId: key,
            investigatorName: obj[key].investigatorName,
            investigatorPhone: obj[key].investigatorPhone,
            investigatorEmail: obj[key].investigatorEmail,
            creatorId: obj[key].creatorId
          });
        }
        console.log(investigators);
        commit('setLoadedInvestigators', investigators);
        commit('setLoading', false);
      }).catch(function (error) {
        console.log(error);
        commit('setLoading', true);
      });
    },
    createInvestigator: function createInvestigator(_ref2, payload) {
      var commit = _ref2.commit,
          getters = _ref2.getters;

      var investigator = {
        investigatorName: payload.title,
        investigatorPhone: payload.investigatorPhone,
        investigatorEmail: payload.investigatorEmail,
        // investigatorId: 'alkasjdf', DON'T NEED BECAUSE FIREBASE AUTO GENERATES ID
        icon: 'investigator_on',
        creatorId: getters.user.id
      };
      __WEBPACK_IMPORTED_MODULE_2_firebase__["database"]().ref('investigators').push(investigator).then(function () {
        commit('createInvestigator', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, investigator));
      }).catch(function (error) {
        console.log(error);
      });
      // Reach out to firebase and store it
      // commit('createInvestigator', investigator)
    },

    // May have to create a separate Action for each updated item (i.e. updateInvestigatorInvestigator, updateInvestigatorDescription, etc)
    updateInvestigatorData: function updateInvestigatorData(_ref3, payload) {
      var commit = _ref3.commit;

      commit('setLoading', true);
      var updateObj = {};
      if (payload.investigatorName) {
        updateObj.investigatorName = payload.investigatorName;
      }
      if (payload.investigatorPhone) {
        updateObj.investigatorPhone = payload.investigatorPhone;
      }
      if (payload.investigatorEmail) {
        updateObj.investigatorEmail = payload.investigatorEmail;
      }
      __WEBPACK_IMPORTED_MODULE_2_firebase__["database"]().ref('investigators').child(payload.investigatorId).update(updateObj).then(function () {
        commit('setLoading', false);
        commit('updateInvestigator', payload);
      }).catch(function (error) {
        console.log(error);
        commit('setLoading', false);
      });
    },
    deleteInvestigatorData: function deleteInvestigatorData(_ref4, payload) {
      var commit = _ref4.commit;

      commit('setLoading', true);
      console.log('Payload: ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(payload));
      __WEBPACK_IMPORTED_MODULE_2_firebase__["database"]().ref('investigators').child(payload.investigatorId).remove().then(function () {
        commit('setLoading', false);
        commit('deleteInvestigator', payload);
      }).catch(function (error) {
        console.log(error);
        commit('setLoading', false);
      });
    }
  },
  getters: {
    loadedInvestigators: function loadedInvestigators(state) {
      return state.loadedInvestigators.sort(function (investigatorA, investigatorB) {
        return investigatorA.date > investigatorB.date;
      });
    },
    featuredInvestigators: function featuredInvestigators(state, getters) {
      return getters.loadedInvestigators.slice(0, 5);
    },
    loadedInvestigator: function loadedInvestigator(state) {
      return function (someId) {
        return state.loadedInvestigators.find(function (investigator) {
          return investigator.investigatorId === someId;
        });
      };
    }
  }
});

/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_firebase__);




/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    loadedLocations: [{
      locationId: 'tri',
      locationName: 'Location Sample',
      locationStreetAddress: '',
      locationCity: '',
      locationState: '',
      locationZipcode: ''
    }]
  },
  mutations: {
    setLoadedLocations: function setLoadedLocations(state, payload) {
      state.loadedLocations = payload;
    },
    createLocation: function createLocation(state, payload) {
      state.loadedLocations.push(payload);
    },
    updateLocation: function updateLocation(state, payload) {
      var location = state.loadedLocations.find(function (location) {
        return location.locationId === payload.locationId;
      });
      if (payload.locationName) {
        location.locationName = payload.locationName;
      }
      if (payload.locationStreetAddress) {
        location.locationStreetAddress = payload.locationStreetAddress;
      }
      if (payload.locationCity) {
        location.locationCity = payload.locationCity;
      }
      if (payload.locationState) {
        location.locationState = payload.locationState;
      }
      if (payload.locationZipcode) {
        location.locationZipcode = payload.locationZipcode;
      }
    },
    deleteLocation: function deleteLocation(state, payload) {
      var location = state.loadedLocations.find(function (location) {
        return location.locationId === payload.locationId;
      });
      var todos = state.loadedLocations;
      todos.splice(todos.indexOf(location), 1);
    }
  },
  actions: {
    loadLocations: function loadLocations(_ref) {
      var commit = _ref.commit;

      commit('setLoading', true);
      __WEBPACK_IMPORTED_MODULE_2_firebase__["database"]().ref('locations').once('value').then(function (data) {
        var locations = [];
        var obj = data.val();
        for (var key in obj) {
          locations.push({
            locationId: key,
            locationName: obj[key].locationName,
            locationStreetAddress: obj[key].locationStreetAddress,
            locationCity: obj[key].locationCity,
            locationState: obj[key].locationState,
            locationZipcode: obj[key].locationZipcode,
            creatorId: obj[key].creatorId
          });
        }
        console.log(locations);
        commit('setLoadedLocations', locations);
        commit('setLoading', false);
      }).catch(function (error) {
        console.log(error);
        commit('setLoading', true);
      });
    },
    createLocation: function createLocation(_ref2, payload) {
      var commit = _ref2.commit,
          getters = _ref2.getters;

      var location = {
        locationName: payload.title,
        locationStreetAddress: payload.locationStreetAddress,
        locationCity: payload.locationCity,
        locationState: payload.locationState,
        locationZipcode: payload.locationZipcode,
        // locationId: 'alkasjdf', DON'T NEED BECAUSE FIREBASE AUTO GENERATES ID
        icon: 'location_on',
        creatorId: getters.user.id
      };
      __WEBPACK_IMPORTED_MODULE_2_firebase__["database"]().ref('locations').push(location).then(function () {
        commit('createLocation', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, location));
      }).catch(function (error) {
        console.log(error);
      });
      // Reach out to firebase and store it
      // commit('createLocation', location)
    },

    // May have to create a separate Action for each updated item (i.e. updateLocationLocation, updateLocationDescription, etc)
    updateLocationData: function updateLocationData(_ref3, payload) {
      var commit = _ref3.commit;

      commit('setLoading', true);
      console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(payload.locations.locationName));
      var updateObj = {};
      if (payload.locations.locationName) {
        updateObj.locationName = payload.locations.locationName;
      }
      if (payload.locations.locationStreetAddress) {
        updateObj.locationStreetAddress = payload.locations.locationStreetAddress;
      }
      if (payload.locations.locationCity) {
        updateObj.locationCity = payload.locations.locationCity;
      }
      if (payload.locations.locationState) {
        updateObj.locationState = payload.locations.locationState;
      }
      if (payload.locations.locationZipcode) {
        updateObj.locationZipcode = payload.locations.locationZipcode;
      }
      __WEBPACK_IMPORTED_MODULE_2_firebase__["database"]().ref('locations').child(payload.locations.locationId).update(updateObj).then(function () {
        commit('setLoading', false);
        commit('updateLocation', payload);
      }).catch(function (error) {
        console.log(error);
        commit('setLoading', false);
      });
    },
    deleteLocationData: function deleteLocationData(_ref4, payload) {
      var commit = _ref4.commit;

      commit('setLoading', true);
      console.log('Payload: ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(payload));
      __WEBPACK_IMPORTED_MODULE_2_firebase__["database"]().ref('locations').child(payload.locationId).remove().then(function () {
        commit('setLoading', false);
        commit('deleteLocation', payload);
      }).catch(function (error) {
        console.log(error);
        commit('setLoading', false);
      });
    }
  },
  getters: {
    loadedLocations: function loadedLocations(state) {
      return state.loadedLocations.sort(function (locationA, locationB) {
        return locationA.date > locationB.date;
      });
    },
    featuredLocations: function featuredLocations(state, getters) {
      return getters.loadedLocations.slice(0, 5);
    },
    loadedLocation: function loadedLocation(state) {
      return function (someId) {
        return state.loadedLocations.find(function (location) {
          return location.locationId === someId;
        });
      };
    }
  }
});

/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    loading: false,
    error: null
  },
  mutations: {
    setLoading: function setLoading(state, payload) {
      state.loading = payload;
    },
    setError: function setError(state, payload) {
      state.error = payload;
    },
    clearError: function clearError(state) {
      state.error = null;
    }
  },
  actions: {
    clearError: function clearError(_ref) {
      var commit = _ref.commit;

      commit('clearError');
    }
  },
  getters: {
    loading: function loading(state) {
      return state.loading;
    },
    error: function error(state) {
      return state.error;
    }
  }
});

/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_firebase__);




/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    loadedTrials: [{
      trialId: 'tri',
      trialName: 'Trial Sample',
      trialEnrollment: '',
      trialLocations: [],
      trialIndications: [],
      trialInvestigators: [],
      trialCoordinators: [],
      trialDescription: '',
      trialLink: ''
    }]
  },
  mutations: {
    setLoadedTrials: function setLoadedTrials(state, payload) {
      state.loadedTrials = payload;
    },
    createTrial: function createTrial(state, payload) {
      // payload.trialID = key
      console.log('ID: ' + payload.trialId);
      state.loadedTrials.push(payload);
    },
    updateTrial: function updateTrial(state, payload) {
      var trial = state.loadedTrials.find(function (trial) {
        return trial.trialId === payload.trialId;
      });
      if (payload.trialName) {
        trial.trialName = payload.trialName;
      }
      if (payload.trialEnrollment) {
        trial.trialEnrollment = payload.trialEnrollment;
      }
      if (payload.description) {
        trial.trialDescription = payload.description;
      }
      if (payload.trialLocations) {
        trial.trialLocations = payload.trialLocations;
      }
      if (payload.trialIndications) {
        trial.trialIndications = payload.trialIndications;
      }
      if (payload.trialInvestigators) {
        trial.trialInvestigators = payload.trialInvestigators;
      }
      if (payload.trialCoordinators) {
        trial.trialCoordinators = payload.trialCoordinators;
      }
    },
    deleteTrial: function deleteTrial(state, payload) {
      var trial = state.loadedTrials.find(function (trial) {
        return trial.trialId === payload.trialId;
      });
      var todos = state.loadedTrials;
      todos.splice(todos.indexOf(trial), 1);
    }
  },
  actions: {
    loadTrials: function loadTrials(_ref) {
      var commit = _ref.commit;

      commit('setLoading', true);
      __WEBPACK_IMPORTED_MODULE_2_firebase__["database"]().ref('trials').once('value').then(function (data) {
        var trials = [];
        var obj = data.val();
        for (var key in obj) {
          // * END OF FIREBASE TREE DATA SETTING FOR LOCATIONS, INDICATIONS, INVESTIGATORS, AND COORDINATORS *
          // Then, push all data to be set in the setLoadedTrials mutation.
          trials.push({
            trialId: key,
            trialName: obj[key].trialName,
            trialEnrollment: obj[key].trialEnrollment,
            trialDescription: obj[key].trialDescription,
            trialLocations: obj[key].trialLocations,
            trialIndications: obj[key].trialIndications,
            trialInvestigators: obj[key].trialInvestigators,
            trialCoordinators: obj[key].trialCoordinators,
            trialLink: obj[key].trialLink,
            creatorId: obj[key].creatorId
          });
        }
        commit('setLoadedTrials', trials);
        commit('setLoading', false);
      }).catch(function (error) {
        console.log(error);
        commit('setLoading', true);
      });
    },
    createTrial: function createTrial(_ref2, payload) {
      var commit = _ref2.commit,
          getters = _ref2.getters;

      var trial = {
        trialName: payload.title,
        trialEnrollment: payload.trialEnrollment,
        trialDescription: payload.description,
        trialLocations: payload.trialLocations,
        trialIndications: payload.trialIndications,
        trialInvestigators: payload.trialInvestigators,
        trialCoordinators: payload.trialCoordinators,
        trialLink: payload.trialLink,
        // trialId: 'alkasjdf', DON'T NEED BECAUSE FIREBASE AUTO GENERATES ID
        icon: 'location_on',
        creatorId: getters.user.id
      };
      __WEBPACK_IMPORTED_MODULE_2_firebase__["database"]().ref('trials').push(trial).then(function (snap) {
        trial.trialId = snap.key;
        console.log('This Firebase New trial: ' + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(trial));
        console.log('THE SNAP KEY: ' + trial.trialId);
        commit('createTrial', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, trial));
      }).catch(function (error) {
        console.log(error);
      });
      // Reach out to firebase and store it
      // commit('createTrial', trial)
    },

    // May have to create a separate Action for each updated item (i.e. updateTrialLocation, updateTrialDescription, etc)
    updateTrialData: function updateTrialData(_ref3, payload) {
      var commit = _ref3.commit;

      commit('setLoading', true);
      // const updateObj = {}
      if (payload.trialName) {
        var updateObjName = {};
        updateObjName.trialName = payload.trialName;
        __WEBPACK_IMPORTED_MODULE_2_firebase__["database"]().ref('trials').child(payload.trialId).update(updateObjName).then(function () {
          commit('setLoading', false);
          commit('updateTrial', payload);
        }).catch(function (error) {
          console.log(error);
          commit('setLoading', false);
        });
      }
      if (payload.trialEnrollment) {
        var updateObjEnrollment = {};
        updateObjEnrollment.trialEnrollment = payload.trialEnrollment;
        console.log('LOOK: ' + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(updateObjEnrollment));
        __WEBPACK_IMPORTED_MODULE_2_firebase__["database"]().ref('trials').child(payload.trialId).update(updateObjEnrollment).then(function () {
          commit('setLoading', false);
          commit('updateTrial', payload);
        }).catch(function (error) {
          console.log(error);
          commit('setLoading', false);
        });
      }
      if (payload.trialLink) {
        var updateObjLink = {};
        updateObjLink.trialLink = payload.trialLink;
        __WEBPACK_IMPORTED_MODULE_2_firebase__["database"]().ref('trials').child(payload.trialId).update(updateObjLink).then(function () {
          commit('setLoading', false);
          commit('updateTrial', payload);
        }).catch(function (error) {
          console.log(error);
          commit('setLoading', false);
        });
      }
      if (payload.description) {
        var updateObjDescription = {};
        updateObjDescription.trialDescription = payload.description;
        __WEBPACK_IMPORTED_MODULE_2_firebase__["database"]().ref('trials').child(payload.trialId).update(updateObjDescription).then(function () {
          commit('setLoading', false);
          commit('updateTrial', payload);
        }).catch(function (error) {
          console.log(error);
          commit('setLoading', false);
        });
      }
      if (payload.trialLocations) {
        var updateObjLocation = {};
        updateObjLocation.trialLocations = payload.trialLocations;
        __WEBPACK_IMPORTED_MODULE_2_firebase__["database"]().ref('trials').child(payload.trialId).update(updateObjLocation).then(function () {
          commit('setLoading', false);
          commit('updateTrial', payload);
        }).catch(function (error) {
          console.log(error);
          commit('setLoading', false);
        });
      }
      if (payload.trialIndications) {
        var updateObjIndication = {};
        updateObjIndication.trialIndications = payload.trialIndications;
        __WEBPACK_IMPORTED_MODULE_2_firebase__["database"]().ref('trials').child(payload.trialId).update(updateObjIndication).then(function () {
          commit('setLoading', false);
          commit('updateTrial', payload);
        }).catch(function (error) {
          console.log(error);
          commit('setLoading', false);
        });
      }
      if (payload.trialInvestigators) {
        var updateObjInvestigator = {};
        updateObjInvestigator.trialInvestigators = payload.trialInvestigators;
        __WEBPACK_IMPORTED_MODULE_2_firebase__["database"]().ref('trials').child(payload.trialId).update(updateObjInvestigator).then(function () {
          commit('setLoading', false);
          commit('updateTrial', payload);
        }).catch(function (error) {
          console.log(error);
          commit('setLoading', false);
        });
      }
      if (payload.trialCoordinators) {
        var updateObjCoordinator = {};
        updateObjCoordinator.trialCoordinators = payload.trialCoordinators;
        __WEBPACK_IMPORTED_MODULE_2_firebase__["database"]().ref('trials').child(payload.trialId).update(updateObjCoordinator).then(function () {
          commit('setLoading', false);
          commit('updateTrial', payload);
        }).catch(function (error) {
          console.log(error);
          commit('setLoading', false);
        });
      }
    },
    deleteTrialData: function deleteTrialData(_ref4, payload) {
      var commit = _ref4.commit;

      commit('setLoading', true);
      console.log(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(payload));
      __WEBPACK_IMPORTED_MODULE_2_firebase__["database"]().ref('trials').child(payload.trialId).remove().then(function () {
        commit('setLoading', false);
        commit('deleteTrial', payload);
      }).catch(function (error) {
        console.log(error);
        commit('setLoading', false);
      });
    }
  },
  getters: {
    loadedTrials: function loadedTrials(state) {
      return state.loadedTrials.sort(function (trialA, trialB) {
        return trialA.trialEnrollment.enrollmentPriority - trialB.trialEnrollment.enrollmentPriority;
      });
    },
    loadedTrialsByEnrollment: function loadedTrialsByEnrollment(state) {
      return function (someId) {
        var result = state.loadedTrials.filter(function (trial) {
          if (trial.trialEnrollment) {
            console.log('LENGTH: ' + trial.trialEnrollment.length);
            for (var i = 0; i < trial.trialEnrollment.length; i++) {
              return trial.trialEnrollment[i].enrollmentId === someId;
            }
          }
        });
        return result;
      };
    },
    loadedTrialsByLocation: function loadedTrialsByLocation(state) {
      return function (someId) {
        var hold = [];
        state.loadedTrials.filter(function (trial) {
          if (trial.trialLocations) {
            console.log('LENGTH: ' + trial.trialLocations.length);
            for (var i = 0; i < trial.trialLocations.length; i++) {
              console.log('INDIES' + [i] + ': ' + trial.trialLocations[i]);
              if (trial.trialLocations[i] === someId) {
                hold.push(trial);
              }
            }
          }
        });
        return hold;
      };
    },
    loadedTrialsByIndication: function loadedTrialsByIndication(state) {
      return function (someId) {
        var hold = [];
        state.loadedTrials.filter(function (trial) {
          if (trial.trialIndications) {
            console.log('LENGTH: ' + trial.trialIndications.length);
            for (var i = 0; i < trial.trialIndications.length; i++) {
              console.log('INDIES' + [i] + ': ' + trial.trialIndications[i]);
              if (trial.trialIndications[i] === someId) {
                hold.push(trial);
              }
            }
          }
        });
        return hold;
      };
    },
    loadedTrialsByInvestigator: function loadedTrialsByInvestigator(state) {
      return function (someId) {
        var hold = [];
        state.loadedTrials.filter(function (trial) {
          if (trial.trialInvestigators) {
            console.log('LENGTH: ' + trial.trialInvestigators.length);
            for (var i = 0; i < trial.trialInvestigators.length; i++) {
              console.log('INDIES' + [i] + ': ' + trial.trialInvestigators[i]);
              if (trial.trialInvestigators[i] === someId) {
                hold.push(trial);
              }
            }
          }
        });
        return hold;
      };
    },
    loadedTrialsByCoordinator: function loadedTrialsByCoordinator(state) {
      return function (someId) {
        var hold = [];
        state.loadedTrials.filter(function (trial) {
          if (trial.trialCoordinators) {
            console.log('LENGTH: ' + trial.trialCoordinators.length);
            for (var i = 0; i < trial.trialCoordinators.length; i++) {
              console.log('INDIES' + [i] + ': ' + trial.trialCoordinators[i]);
              if (trial.trialCoordinators[i] === someId) {
                hold.push(trial);
              }
            }
          }
        });
        return hold;
      };
    },
    featuredTrials: function featuredTrials(state, getters) {
      return getters.loadedTrials.slice(0, 5);
    },
    loadedTrial: function loadedTrial(state) {
      return function (someId) {
        return state.loadedTrials.find(function (trial) {
          console.log(trial.trialId + ' + ' + someId);
          return trial.trialId === someId;
        });
      };
    }
  }
});

/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);



/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    user: null
  },
  mutations: {
    setUser: function setUser(state, payload) {
      state.user = payload;
    }
  },
  actions: {
    signUserUp: function signUserUp(_ref, payload) {
      var commit = _ref.commit;

      commit('setLoading', true);
      commit('clearError');
      __WEBPACK_IMPORTED_MODULE_0_firebase__["auth"]().createUserWithEmailAndPassword(payload.email, payload.password).then(function (user) {
        commit('setLoading', false);
        var newUser = {
          id: user.uid,
          registeredTrials: [],
          registeredLocations: [],
          registeredIndications: [],
          registeredInvestigators: [],
          registeredCoordinators: []
        };
        commit('setUser', newUser);
      }).catch(function (error) {
        commit('setLoading', false);
        commit('setError', error);
        console.log(error);
      });
    },
    signUserIn: function signUserIn(_ref2, payload) {
      var commit = _ref2.commit;

      commit('setLoading', true);
      commit('clearError');
      __WEBPACK_IMPORTED_MODULE_0_firebase__["auth"]().signInWithEmailAndPassword(payload.email, payload.password).then(function (user) {
        var newUser = {
          id: user.uid,
          registeredTrials: [],
          registeredLocations: [],
          registeredIndications: [],
          registeredInvestigators: [],
          registeredCoordinators: []
        };
        commit('setUser', newUser);
      }).catch(function (error) {
        commit('setLoading', false);
        commit('setError', error);
        console.log(error);
      });
    },
    autoSignIn: function autoSignIn(_ref3, payload) {
      var commit = _ref3.commit;

      commit('setUser', { id: payload.uid, registeredTrials: [], registeredLocations: [], registeredTIndications: [], registeredInvestigators: [] });
    },
    clearError: function clearError(_ref4, payload) {
      var commit = _ref4.commit;

      commit('clearError');
    },
    logout: function logout(_ref5) {
      var commit = _ref5.commit;

      __WEBPACK_IMPORTED_MODULE_0_firebase__["auth"]().signOut();
      commit('setUser', null);
    }
  },
  getters: {
    user: function user(state) {
      return state.user;
    }
  }
});

/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      sideNav: false,
      addNew: false,
      snackbar: false,
      alert: true,
      absolute: false,
      color: 'primary',
      timeout: 6000,
      text: ''
    };
  },

  computed: {
    menuItems: function menuItems() {
      var menuItems = [
      //          { icon: 'navigate_before', title: 'Back', link: '' },
      { icon: 'home', title: 'Home', link: '/' },
      //          { icon: 'lock_open', title: 'Sign In', link: '/signin' },
      { icon: 'view_list', title: 'Trials', link: '/trials' }];
      if (this.userIsAuthenticate) {
        menuItems = [{ icon: 'home', title: 'Home', link: '/' },
        //            { icon: 'person', title: 'Profile', link: '/profile' },
        { icon: 'view_list', title: 'Trials', link: '/trials' },
        //            { icon: 'add', title: 'New Trial', link: '/trial/new' },
        { icon: 'view_list', title: 'Indications', link: '/indications' },
        //            { icon: 'add', title: 'New Indication', link: '/indication/new' },
        { icon: 'view_list', title: 'Locations', link: '/locations' },
        //            { icon: 'add', title: 'New Location', link: '/location/new' },
        { icon: 'view_list', title: 'Investigators', link: '/investigators' },
        //            { icon: 'add', title: 'New Investigator', link: '/investigator/new' },
        { icon: 'view_list', title: 'Coordinator', link: '/coordinators' },
        //            { icon: 'add', title: 'New Coordinator', link: '/coordinator/new' },
        { icon: 'face', title: 'Sign Up', link: '/signup' }];
      }
      return menuItems;
    },
    userIsAuthenticate: function userIsAuthenticate() {
      return this.$store.getters.user !== null && this.$store.getters.user !== undefined;
    },
    checkLocation: function checkLocation() {
      var currentRoute = this.$route.path;
      var singleTrial = '/trials/';
      if (this.$route.path === '/Trials/Locations' || this.$route.path === '/Trials/Indications' || this.$route.path === '/Trials/Coordinators' || this.$route.path === '/Trials/Investigators' || currentRoute.startsWith(singleTrial)) {
        return !this.addnew;
      }
      return;
    },
    checkLocations: function checkLocations() {
      if (this.$route.path === '/') {
        return true;
      }
      return;
    }
  },
  methods: {
    onLogout: function onLogout() {
      this.$store.dispatch('logout');
    },
    pageLocation: function pageLocation() {
      console.log('The path is: ' + this.$route.path);
      var currentRoute = this.$route.path;
      var singleTrial = '/trials/';
      if (currentRoute === '/Trials/Locations') {
        this.$router.push('/location/new');
      }
      if (currentRoute === '/Trials/Locations') {
        this.$router.push('/location/new');
      }
      if (currentRoute === '/Trials/Indications') {
        this.$router.push('/indication/new');
      }
      if (currentRoute === '/Trials/Coordinators') {
        this.$router.push('/coordinator/new');
      }
      if (currentRoute === '/Trials/Investigators') {
        this.$router.push('/investigator/new');
      }
      if (currentRoute.startsWith(singleTrial)) {
        this.$router.push('/trial/new');
      }
    }
  }
});

/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      //  dialog: false
    };
  },

  props: ['id'],
  computed: {
    alert: function alert() {
      console.log('CURRENT ITEM: ' + this.id);
      return this.$store.getters.loadedAlert(this.id);
    },
    userIsAuthenticated: function userIsAuthenticated() {
      return this.$store.getters.user !== null && this.$store.getters.user !== undefined;
    },
    userIsCreator: function userIsCreator() {
      if (!this.userIsAuthenticated) {
        return false;
      }
      return this.$store.getters.user.id === this.alert.creatorId;
    },
    loading: function loading() {
      return this.$store.getters.loading;
    }
  }
});

/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['id'],
  data: function data() {
    return {};
  },

  computed: {
    alerts: function alerts() {
      return this.$store.getters.loadedAlerts;
    },
    userIsAuthenticated: function userIsAuthenticated() {
      return this.$store.getters.user !== null && this.$store.getters.user !== undefined;
    },
    loading: function loading() {
      return this.$store.getters.loading;
    }
  },
  methods: {
    alert: function alert(index) {
      console.log('CURRENT ITEM: ' + this.$store.getters.loadedAlert(this.alerts[index].alertId));
      return this.$store.getters.loadedAlert(this.alerts[index].alertId);
    },
    userIsCreator: function userIsCreator(index) {
      console.dir('THIS: ' + this.alerts[index].creatorId);
      var holder = this.alerts[index].creatorId;
      var holder2 = this.$store.getters.user.id;
      if (!this.userIsAuthenticated) {
        return false;
      }
      return holder2 === holder;
    },
    onDeleteAlert: function onDeleteAlert(alert) {
      console.log('Delete this: ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(alert));
      this.$store.dispatch('deleteAlertData', alert);
      this.$router.push('/alerts');
    }
  }
});

/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['notice'],
  data: function data() {
    return {
      alertName: this.$store.getters.loadedNotice.noticeName,
      dialog: false
    };
  },

  computed: {
    formIsValid: function formIsValid() {
      return this.alertName !== '';
    }
  },
  methods: {
    onCreateAlert: function onCreateAlert() {
      if (!this.formIsValid) {
        return;
      }
      if (this.alertName !== '' || this.alertName !== null) {
        this.$store.dispatch('createNotice', this.alertName);
        // this.$router.push('/alerts')
      } else {}
    },
    onDeleteAlert: function onDeleteAlert() {
      this.$store.dispatch('deleteNoticeData');
      this.$router.push('/');
    }
  }
});

/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['alert'],
  data: function data() {
    return {
      editDialog: false,
      editedAlerts: this.alert,
      editedAlertsName: this.alert.alertName
    };
  },

  computed: {
    loadAlerts: function loadAlerts() {
      return this.$store.getters.loadedAlerts;
    }
  },
  methods: {
    onSaveChanges: function onSaveChanges() {
      this.editDialog = false;
      this.alert = true;
      console.log('ALERT ALERT ALERT:' + alert);
      this.$store.dispatch('updateAlertData', {
        alertId: this.alert.alertId,
        alertName: this.editedAlertsName
      });
    }
  }
});

/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      //  dialog: false
    };
  },

  props: ['id'],
  methods: {
    onDeleteCoordinator: function onDeleteCoordinator(coordinator) {
      console.log('Delete this: ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(coordinator));
      this.$store.dispatch('deleteCoordinatorData', coordinator);
      this.$router.push('/coordinators');
    }
  },
  computed: {
    coordinator: function coordinator() {
      return this.$store.getters.loadedCoordinator(this.id);
    },
    userIsAuthenticated: function userIsAuthenticated() {
      return this.$store.getters.user !== null && this.$store.getters.user !== undefined;
    },
    userIsCreator: function userIsCreator() {
      if (!this.userIsAuthenticated) {
        return false;
      }
      return this.$store.getters.user.id === this.coordinator.creatorId;
    },
    loading: function loading() {
      return this.$store.getters.loading;
    }
  }
});

/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  computed: {
    coordinators: function coordinators() {
      return this.$store.getters.loadedCoordinators;
    },
    userIsAuthenticated: function userIsAuthenticated() {
      return this.$store.getters.user !== null && this.$store.getters.user !== undefined;
    },
    loading: function loading() {
      return this.$store.getters.loading;
    }
  },
  methods: {
    coordinator: function coordinator(index) {
      console.log('CURRENT ITEM: ' + this.$store.getters.loadedCoordinator(this.coordinators[index].coordinatorId));
      return this.$store.getters.loadedCoordinator(this.coordinators[index].coordinatorId);
    },
    onDeleteCoordinator: function onDeleteCoordinator(coordinator) {
      console.log('Delete this: ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(coordinator));
      this.$store.dispatch('deleteCoordinatorData', coordinator);
      this.$router.push('/coordinators');
    }
  }
});

/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      coordinatorName: '',
      coordinatorPhone: '',
      coordinatorEmail: '',
      dialog: false
    };
  },

  props: ['id'],
  computed: {
    coordinator: function coordinator() {
      return this.$store.getters.loadedCoordinator(this.id);
    },
    coordinators: function coordinators() {
      return this.$store.getters.loadedCoordinators;
    },
    formIsValid: function formIsValid() {
      return this.coordinatorName !== '';
    }
  },
  methods: {
    onCreateCoordinator: function onCreateCoordinator() {
      if (!this.formIsValid) {
        return;
      }
      var coordinatorData = {
        title: this.coordinatorName,
        coordinatorPhone: this.coordinatorPhone,
        coordinatorEmail: this.coordinatorEmail
      };
      this.$store.dispatch('createCoordinator', coordinatorData);
      this.$router.push('/coordinators');
    }
  }
});

/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['coordinator'],
  data: function data() {
    return {
      editDialog: false,
      editedCoordinators: this.coordinator.coordinatorName,
      editedCoordinatorsPhone: this.coordinator.coordinatorPhone,
      editedCoordinatorsEmail: this.coordinator.coordinatorEmail
    };
  },

  computed: {
    loadCoordinators: function loadCoordinators() {
      return this.$store.getters.loadedCoordinators;
    }
  },
  methods: {
    onDeleteCoordinator: function onDeleteCoordinator(coordinator) {
      console.log('Delete this: ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(coordinator));
      this.$store.dispatch('deleteCoordinatorData', coordinator);
      this.$router.push('/coordinators');
    },
    onSaveChanges: function onSaveChanges() {
      this.editDialog = false;
      this.$store.dispatch('updateCoordinatorData', {
        coordinatorId: this.coordinator.coordinatorId,
        coordinatorName: this.editedCoordinators,
        coordinatorPhone: this.editedCoordinatorsPhone,
        coordinatorEmail: this.editedCoordinatorsEmail
      });
    }
  }
});

/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      enrollmentName: '',
      enrollmentPriorityHolder: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      editedEnrollmentPriority: '',
      dialog: false
    };
  },

  props: ['id'],
  computed: {
    enrollment: function enrollment() {
      return this.$store.getters.loadedEnrollment(this.id);
    },
    enrollments: function enrollments() {
      return this.$store.getters.loadedEnrollments;
    },
    formIsValid: function formIsValid() {
      return this.enrollmentName !== '';
    }
  },
  methods: {
    onCreateEnrollment: function onCreateEnrollment() {
      if (!this.formIsValid) {
        return;
      }
      var enrollmentData = {
        title: this.enrollmentName,
        enrollmentPriority: this.editedEnrollmentPriority
      };
      this.$store.dispatch('createEnrollment', enrollmentData);
      this.$router.push('/enrollments');
    }
  }
});

/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['enrollment'],
  data: function data() {
    return {
      editDialog: false,
      editedEnrollments: this.enrollment,
      editedEnrollmentsName: this.enrollment.enrollmentName,
      editedEnrollmentsPriorityHolder: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      editedEnrollmentsPriority: this.enrollment.enrollmentPriority
    };
  },

  computed: {
    loadEnrollments: function loadEnrollments() {
      return this.$store.getters.loadedEnrollments;
    }
  },
  methods: {
    onSaveChanges: function onSaveChanges() {
      this.editDialog = false;
      this.$store.dispatch('updateEnrollmentData', {
        enrollmentId: this.enrollment.enrollmentId,
        enrollmentName: this.editedEnrollmentsName,
        enrollmentPriority: this.editedEnrollmentsPriority
      });
    }
  }
});

/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      //  dialog: false
    };
  },

  props: ['id'],
  computed: {
    enrollment: function enrollment() {
      console.log('CURRENT ITEM: ' + this.id);
      return this.$store.getters.loadedEnrollment(this.id);
    },
    userIsAuthenticated: function userIsAuthenticated() {
      return this.$store.getters.user !== null && this.$store.getters.user !== undefined;
    },
    userIsCreator: function userIsCreator() {
      if (!this.userIsAuthenticated) {
        return false;
      }
      return this.$store.getters.user.id === this.enrollment.creatorId;
    },
    loading: function loading() {
      return this.$store.getters.loading;
    }
  }
});

/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['id'],
  data: function data() {
    return {};
  },

  computed: {
    enrollments: function enrollments() {
      return this.$store.getters.loadedEnrollments;
    },
    userIsAuthenticated: function userIsAuthenticated() {
      return this.$store.getters.user !== null && this.$store.getters.user !== undefined;
    },
    loading: function loading() {
      return this.$store.getters.loading;
    }
  },
  methods: {
    enrollment: function enrollment(index) {
      console.log('CURRENT ITEM: ' + this.$store.getters.loadedEnrollment(this.enrollments[index].enrollmentId));
      return this.$store.getters.loadedEnrollment(this.enrollments[index].enrollmentId);
    },
    userIsCreator: function userIsCreator(index) {
      console.dir('THIS: ' + this.enrollments[index].creatorId);
      var holder = this.enrollments[index].creatorId;
      var holder2 = this.$store.getters.user.id;
      if (!this.userIsAuthenticated) {
        return false;
      }
      return holder2 === holder;
    },
    onDeleteEnrollment: function onDeleteEnrollment(enrollment) {
      console.log('Delete this: ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(enrollment));
      this.$store.dispatch('deleteEnrollmentData', enrollment);
      this.$router.push('/enrollments');
    }
  }
});

/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      alert: true,
      timeout: 6000,
      items: [
      // { active: true, title: 'Trials By Location', icon: 'location_on', link: '/Trials/Locations' },
      { active: false, title: 'Trials By Indication', icon: 'bookmark_border', link: '/Trials/Indications' }, { active: true, title: 'Trials By Location', icon: 'location_on', link: '/Trials/Locations' },
      // { active: true, title: 'Trials By Houston', icon: 'location_on', link: '/Trials/locations/-L9cIQfsVcCvP_h_gH6b' },
      { title: 'Trials By Investigator', icon: 'person_pin', link: '/Trials/Investigators' }, { title: 'Trials By Coordinator', icon: 'person_pin', link: '/Trials/Coordinators' }]
    };
  },

  computed: {
    trials: function trials() {
      return this.$store.getters.featuredTrials;
    },
    loading: function loading() {
      return this.$store.getters.loading;
    },
    checkLocations: function checkLocations() {
      if (this.$route.path === '/') {
        return true;
      }
      return;
    },
    loadedNotice: function loadedNotice() {
      if (typeof this.$store.getters.loadedNotice !== 'undefined') {
        return this.$store.getters.loadedNotice;
      }
      return;
    }
  },
  methods: {
    onLoadTrial: function onLoadTrial(id) {
      this.$router.push('/trials/' + id);
    }
  }
});

/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      editDialog: false,
      indicationName: '',
      dialog: false
    };
  },

  props: ['id'],
  computed: {
    indication: function indication() {
      return this.$store.getters.loadedIndication(this.id);
    },
    indications: function indications() {
      return this.$store.getters.loadedIndications;
    },
    formIsValid: function formIsValid() {
      return this.indicationName !== '';
    }
  },
  methods: {
    onCreateIndication: function onCreateIndication() {
      if (!this.formIsValid) {
        return;
      }
      var indicationData = {
        title: this.indicationName
      };
      this.$store.dispatch('createIndication', indicationData);
      this.$router.push('/indications');
    }
  }
});

/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['indication'],
  data: function data() {
    return {
      editDialog: false,
      editedIndications: this.indication,
      editedIndicationsName: this.indication.indicationName
    };
  },

  computed: {
    loadIndications: function loadIndications() {
      return this.$store.getters.loadedIndications;
    }
  },
  methods: {
    onDeleteIndication: function onDeleteIndication(indication) {
      console.log('Delete this: ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(indication));
      this.$store.dispatch('deleteIndicationData', indication);
      this.$router.push('/indications');
    },
    onSaveChanges: function onSaveChanges() {
      this.editDialog = false;
      this.$store.dispatch('updateIndicationData', {
        indicationId: this.indication.indicationId,
        indicationName: this.editedIndicationsName
      });
    }
  }
});

/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      //  dialog: false
    };
  },

  props: ['id'],
  methods: {
    onDeleteIndication: function onDeleteIndication(indication) {
      console.log('Delete this: ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(indication));
      this.$store.dispatch('deleteIndicationData', indication);
      this.$router.push('/indications');
    }
  },
  computed: {
    indication: function indication() {
      console.log('CURRENT ITEM: ' + this.id);
      return this.$store.getters.loadedIndication(this.id);
    },
    userIsAuthenticated: function userIsAuthenticated() {
      return this.$store.getters.user !== null && this.$store.getters.user !== undefined;
    },
    userIsCreator: function userIsCreator() {
      if (!this.userIsAuthenticated) {
        return false;
      }
      return this.$store.getters.user.id === this.indication.creatorId;
    },
    loading: function loading() {
      return this.$store.getters.loading;
    }
  }
});

/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  computed: {
    indications: function indications() {
      return this.$store.getters.loadedIndications;
    },
    userIsAuthenticated: function userIsAuthenticated() {
      return this.$store.getters.user !== null && this.$store.getters.user !== undefined;
    },
    loading: function loading() {
      return this.$store.getters.loading;
    }
  },
  methods: {
    indication: function indication(index) {
      console.log('CURRENT ITEM: ' + this.$store.getters.loadedIndication(this.indications[index].indicationId));
      return this.$store.getters.loadedIndication(this.indications[index].indicationId);
    },
    onDeleteIndication: function onDeleteIndication(indication) {
      console.log('Delete this: ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(indication));
      this.$store.dispatch('deleteIndicationData', indication);
      this.$router.push('/indications');
    }
  }
});

/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      investigatorName: '',
      investigatorPhone: '',
      investigatorEmail: '',
      dialog: false
    };
  },

  props: ['id'],
  computed: {
    investigator: function investigator() {
      return this.$store.getters.loadedInvestigator(this.id);
    },
    investigators: function investigators() {
      return this.$store.getters.loadedInvestigators;
    },
    formIsValid: function formIsValid() {
      return this.investigatorName !== '';
    }
  },
  methods: {
    onCreateInvestigator: function onCreateInvestigator() {
      if (!this.formIsValid) {
        return;
      }
      var investigatorData = {
        title: this.investigatorName,
        investigatorPhone: this.investigatorPhone,
        investigatorEmail: this.investigatorEmail
      };
      this.$store.dispatch('createInvestigator', investigatorData);
      this.$router.push('/investigators');
    }
  }
});

/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['investigator'],
  data: function data() {
    return {
      editDialog: false,
      editedInvestigators: this.investigator.investigatorName,
      editedInvestigatorsPhone: this.investigator.investigatorPhone,
      editedInvestigatorsEmail: this.investigator.investigatorEmail
    };
  },

  computed: {
    loadInvestigators: function loadInvestigators() {
      return this.$store.getters.loadedInvestigators;
    }
  },
  methods: {
    onDeleteInvestigator: function onDeleteInvestigator(investigator) {
      console.log('Delete this: ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(investigator));
      this.$store.dispatch('deleteInvestigatorData', investigator);
      this.$router.push('/investigators');
    },
    onSaveChanges: function onSaveChanges() {
      this.editDialog = false;
      this.$store.dispatch('updateInvestigatorData', {
        investigatorId: this.investigator.investigatorId,
        investigatorName: this.editedInvestigators,
        investigatorPhone: this.editedInvestigatorsPhone,
        investigatorEmail: this.editedInvestigatorsEmail
      });
    }
  }
});

/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      //  dialog: false
    };
  },

  props: ['id'],
  methods: {
    onDeleteInvestigator: function onDeleteInvestigator(investigator) {
      console.log('Delete this: ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(investigator));
      this.$store.dispatch('deleteInvestigatorData', investigator);
      this.$router.push('/investigators');
    }
  },
  computed: {
    investigator: function investigator() {
      return this.$store.getters.loadedInvestigator(this.id);
    },
    userIsAuthenticated: function userIsAuthenticated() {
      return this.$store.getters.user !== null && this.$store.getters.user !== undefined;
    },
    userIsCreator: function userIsCreator() {
      if (!this.userIsAuthenticated) {
        return false;
      }
      return this.$store.getters.user.id === this.investigator.creatorId;
    },
    loading: function loading() {
      return this.$store.getters.loading;
    }
  }
});

/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  computed: {
    investigators: function investigators() {
      return this.$store.getters.loadedInvestigators;
    },
    userIsAuthenticated: function userIsAuthenticated() {
      return this.$store.getters.user !== null && this.$store.getters.user !== undefined;
    },
    loading: function loading() {
      return this.$store.getters.loading;
    }
  },
  methods: {
    investigator: function investigator(index) {
      console.log('CURRENT ITEM: ' + this.$store.getters.loadedInvestigator(this.investigators[index].investigatorId));
      return this.$store.getters.loadedInvestigator(this.investigators[index].investigatorId);
    },
    onDeleteInvestigator: function onDeleteInvestigator(investigator) {
      console.log('Delete this: ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(investigator));
      this.$store.dispatch('deleteInvestigatorData', investigator);
      this.$router.push('/investigators');
    }
  }
});

/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      locationName: '',
      locationStreetAddress: '',
      locationCity: '',
      locationState: '',
      locationZipcode: '',
      dialog: false
    };
  },

  props: ['id'],
  computed: {
    location: function location() {
      return this.$store.getters.loadedLocation(this.id);
    },
    locations: function locations() {
      return this.$store.getters.loadedLocations;
    },
    formIsValid: function formIsValid() {
      return this.locationName !== '';
    }
  },
  methods: {
    onCreateLocation: function onCreateLocation() {
      if (!this.formIsValid) {
        return;
      }
      var locationData = {
        title: this.locationName,
        locationStreetAddress: this.locationStreetAddress,
        locationCity: this.locationCity,
        locationState: this.locationState,
        locationZipcode: this.locationZipcode
      };
      this.$store.dispatch('createLocation', locationData);
      this.$router.push('/locations');
    }
  }
});

/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['location'],
  data: function data() {
    return {
      editDialog: false,
      editedLocations: this.location,
      holder: []
    };
  },

  computed: {
    loadLocations: function loadLocations() {
      return this.$store.getters.loadedLocations;
    }
  },
  methods: {
    onDeleteLocation: function onDeleteLocation(location) {
      console.log('Delete this: ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(location));
      this.$store.dispatch('deleteLocationData', location);
      this.$router.push('/locations');
    },
    onSaveChanges: function onSaveChanges() {
      this.editDialog = false;
      console.log(this.location.locationId);
      this.$store.dispatch('updateLocationData', {
        locationId: this.location.locationId,
        locations: this.editedLocations
      });
    }
  }
});

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      dialog: false
    };
  },

  props: ['id'],
  methods: {
    onDeleteLocation: function onDeleteLocation(location) {
      console.log('Delete this: ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(location));
      this.$store.dispatch('deleteLocationData', location);
      this.$router.push('/locations');
    }
  },
  computed: {
    location: function location() {
      return this.$store.getters.loadedLocation(this.id);
    },
    userIsAuthenticated: function userIsAuthenticated() {
      return this.$store.getters.user !== null && this.$store.getters.user !== undefined;
    },
    userIsCreator: function userIsCreator() {
      if (!this.userIsAuthenticated) {
        return false;
      }
      return this.$store.getters.user.id === this.location.creatorId;
    },
    loading: function loading() {
      return this.$store.getters.loading;
    }
  }
});

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  computed: {
    locations: function locations() {
      return this.$store.getters.loadedLocations;
    },
    userIsAuthenticated: function userIsAuthenticated() {
      return this.$store.getters.user !== null && this.$store.getters.user !== undefined;
    },
    loading: function loading() {
      return this.$store.getters.loading;
    }
  },
  methods: {
    location: function location(index) {
      console.log('CURRENT ITEM: ' + this.$store.getters.loadedLocation(this.locations[index].locationId));
      return this.$store.getters.loadedLocation(this.locations[index].locationId);
    },
    onDeleteLocation: function onDeleteLocation(location) {
      console.log('Delete this: ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(location));
      this.$store.dispatch('deleteLocationData', location);
      this.$router.push('/locations');
    }
  }
});

/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['text'],
  methods: {
    onClose: function onClose() {
      this.$emit('dismissed');
    }
  }
});

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  computed: {
    coordinators: function coordinators() {
      return this.$store.getters.loadedCoordinators;
    },
    userIsAuthenticated: function userIsAuthenticated() {
      return this.$store.getters.user !== null && this.$store.getters.user !== undefined;
    },
    loading: function loading() {
      return this.$store.getters.loading;
    }
  },
  methods: {
    coordinator: function coordinator(index) {
      console.log('CURRENT ITEM: ' + this.$store.getters.loadedCoordinator(this.coordinators[index].coordinatorId));
      return this.$store.getters.loadedCoordinator(this.coordinators[index].coordinatorId);
    },
    onDeleteCoordinator: function onDeleteCoordinator(coordinator) {
      console.log('Delete this: ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(coordinator));
      this.$store.dispatch('deleteCoordinatorData', coordinator);
      this.$router.push('/coordinators');
    }
  }
});

/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['coordinatorId'],
  data: function data() {
    return {};
  },

  computed: {
    trials: function trials() {
      var _this = this;

      var loadedTrialss = this.$store.getters.loadedTrialsByCoordinator(this.coordinatorId);
      return loadedTrialss.sort(function (a, b) {
        var EPa = _this.$store.getters.loadedEnrollment(a.trialEnrollment);
        var EPb = _this.$store.getters.loadedEnrollment(b.trialEnrollment);
        return EPa.enrollmentPriority > EPb.enrollmentPriority ? 1 : EPb.enrollmentPriority > EPa.enrollmentPriority ? -1 : 0;
      });
    },
    userIsAuthenticated: function userIsAuthenticated() {
      return this.$store.getters.user !== null && this.$store.getters.user !== undefined;
    },
    coordinators: function coordinators() {
      if (typeof this.$store.getters.loadedCoordinator(this.coordinatorId) !== 'undefined') {
        var locaName = this.$store.getters.loadedCoordinator(this.coordinatorId);
        return locaName.coordinatorName;
      }
    }
  },
  methods: {
    enrollment: function enrollment(index) {
      console.log('CURRENT loadedEnrollment ITEM: ' + this.$store.getters.loadedEnrollment(this.trials[index].trialId));
      var val = this.$store.getters.loadedEnrollment(this.trials[index].trialEnrollment);
      return val;
    },
    locations: function locations(index) {
      console.log('CURRENT loadedLocation ITEM: ' + this.$store.getters.loadedLocation(this.trials[index].trialLocations));
      var val = this.$store.getters.loadedLocation(this.trials[index].trialLocations[0]);
      return val;
    },
    onDeleteTrial: function onDeleteTrial(trial) {
      this.$store.dispatch('deleteTrialData', trial);
      this.$router.push('/trials');
    }
  }
});

/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      title: '',
      description: '',
      trialEnrollment: '',
      trialLocations: [],
      trialIndications: [],
      trialInvestigators: [],
      trialCoordinators: [],
      trialLink: '',
      dialog: false
    };
  },

  props: ['id'],
  computed: {
    trial: function trial() {
      return this.$store.getters.loadedTrial(this.id);
    },
    enrollments: function enrollments() {
      return this.$store.getters.loadedEnrollments;
    },
    locations: function locations() {
      return this.$store.getters.loadedLocations;
    },
    indications: function indications() {
      return this.$store.getters.loadedIndications;
    },
    investigators: function investigators() {
      return this.$store.getters.loadedInvestigators;
    },
    coordinators: function coordinators() {
      return this.$store.getters.loadedCoordinators;
    },
    formIsValid: function formIsValid() {
      return this.title !== '' && this.location !== '' && this.description !== '';
    }
  },
  methods: {
    onCreateTrial: function onCreateTrial() {
      if (!this.formIsValid) {
        return;
      }
      var trialData = {
        title: this.title,
        description: this.description,
        trialEnrollment: this.trialEnrollment,
        trialLocations: this.trialLocations,
        trialIndications: this.trialIndications,
        trialInvestigators: this.trialInvestigators,
        trialCoordinators: this.trialCoordinators,
        trialLink: this.trialLink
      };
      console.log(trialData.trialIndications);
      this.$store.dispatch('createTrial', trialData);
      this.$router.push('/trials');
    }
  }
});

/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import * as firebase from 'firebase'

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      //  dialog: false
    };
  },

  props: ['id'],
  methods: {
    onDeleteTrial: function onDeleteTrial(trial) {
      this.$store.dispatch('deleteTrialData', trial);
      this.$router.push('/trials');
    }
  },
  computed: {
    trial: function trial() {
      console.log(this.id);
      return this.$store.getters.loadedTrial(this.id);
    },
    enrollments: function enrollments() {
      return this.$store.getters.loadedEnrollments;
    },
    enrollmentsss: function enrollmentsss() {
      if (this.trial.trialEnrollment) {
        var val = [];
        val = this.$store.getters.loadedEnrollment(this.trial.trialEnrollment);
        console.log('enrollmentsss val: ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(val));
        return val;
      } else {
        return null;
      }
    },
    locations: function locations() {
      return this.$store.getters.loadedLocations;
    },
    locationsss: function locationsss() {
      if (this.trial.trialLocations) {
        var indis = [];
        var val = [];
        // var item = []
        this.trial.trialLocations.filter(function (elem) {
          indis.push(elem);
        });
        console.log('Location IDs: ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(indis));
        for (var i = 0; i < indis.length; i++) {
          console.log('SECOND GET INDIS: ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.$store.getters.loadedLocation(indis[i])));
          if (this.$store.getters.loadedLocation(indis[i])) {
            val.push(this.$store.getters.loadedLocation(indis[i]));
          }
        }
        console.log('FINAL val: ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(val));
        return val;
      } else {
        return null;
      }
    },
    indications: function indications() {
      return this.$store.getters.loadedIndications;
    },
    indicationsss: function indicationsss() {
      if (this.trial.trialIndications) {
        var indis = [];
        var val = [];
        // var item = []
        this.trial.trialIndications.filter(function (elem) {
          indis.push(elem);
        });
        console.log('Indication IDs: ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(indis));
        for (var i = 0; i < indis.length; i++) {
          console.log('SECOND GET INDIS: ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.$store.getters.loadedIndication(indis[i])));
          if (this.$store.getters.loadedIndication(indis[i])) {
            val.push(this.$store.getters.loadedIndication(indis[i]));
          }
        }
        console.log('FINAL val: ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(val));
        return val;
      } else {
        return null;
      }
    },
    investigator: function investigator() {
      return this.$store.getters.loadedInvestigators;
    },
    investigatorsGetter: function investigatorsGetter() {
      if (this.trial.trialInvestigators) {
        var indis = [];
        var val = [];
        // var item = []
        this.trial.trialInvestigators.filter(function (elem) {
          indis.push(elem);
        });
        console.log('Investigator IDs: ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(indis));
        for (var i = 0; i < indis.length; i++) {
          console.log('SECOND GET Investigator: ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.$store.getters.loadedInvestigator(indis[i])));
          if (this.$store.getters.loadedInvestigator(indis[i])) {
            val.push(this.$store.getters.loadedInvestigator(indis[i]));
          }
        }
        console.log('FINAL val: ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(val));
        return val;
      } else {
        return null;
      }
    },
    coordinator: function coordinator() {
      return this.$store.getters.loadedCoordinators;
    },
    coordinatorsGetter: function coordinatorsGetter() {
      if (this.trial.trialCoordinators) {
        var indis = [];
        var val = [];
        // var item = []
        this.trial.trialCoordinators.filter(function (elem) {
          indis.push(elem);
        });
        console.log('Coordinator IDs: ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(indis));
        for (var i = 0; i < indis.length; i++) {
          console.log('SECOND GET Coordinator: ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.$store.getters.loadedCoordinator(indis[i])));
          if (this.$store.getters.loadedCoordinator(indis[i])) {
            val.push(this.$store.getters.loadedCoordinator(indis[i]));
          }
        }
        console.log('FINAL val: ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(val));
        return val;
      } else {
        return null;
      }
    },
    userIsAuthenticated: function userIsAuthenticated() {
      return this.$store.getters.user !== null && this.$store.getters.user !== undefined;
    },
    userIsCreator: function userIsCreator() {
      if (!this.userIsAuthenticated) {
        return false;
      }
      return this.$store.getters.user.id === this.trial.creatorId;
    },
    loading: function loading() {
      return this.$store.getters.loading;
    }
  }
});

/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['trial'],
  data: function data() {
    return {
      editDialog: false,
      editedCoordinators: this.trial.trialCoordinators,
      trialCoordinators: [],
      holder: []
    };
  },

  computed: {
    coordinators: function coordinators() {
      return this.$store.getters.loadedCoordinators;
    },
    loadCoordinators: function loadCoordinators() {
      return this.$store.getters.loadedTrials;
    },
    coordinatorsGetter: function coordinatorsGetter() {
      if (this.trial.trialCoordinators) {
        var indis = [];
        var val = [];
        // var item = []
        this.trial.trialCoordinators.filter(function (elem) {
          indis.push(elem);
        });
        console.log('Coordinator IDs: ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(indis));
        for (var i = 0; i < indis.length; i++) {
          console.log('SECOND GET Coordinator: ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.$store.getters.loadedCoordinator(indis[i])));
          if (this.$store.getters.loadedCoordinator(indis[i])) {
            val.push(this.$store.getters.loadedCoordinator(indis[i]));
          }
        }
        console.log('FINAL val: ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(val));
        return val;
      } else {
        return null;
      }
    }
  },
  methods: {
    onSaveChanges: function onSaveChanges() {
      this.trialCoordinators = this.editedCoordinators;
      this.editDialog = false;
      console.log('edit page: ' + this.trialCoordinators);
      this.$store.dispatch('updateTrialData', {
        trialId: this.trial.trialId,
        trialCoordinators: this.trialCoordinators
      });
    }
  }
});

/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['trial'],
  data: function data() {
    return {
      trialEnrollment: '',
      editDialog: false,
      editedTitle: this.trial.trialName,
      editedEnrollment: this.trial.trialEnrollment,
      editedDescription: this.trial.trialDescription,
      editedLink: this.trial.trialLink
    };
  },

  computed: {
    enrollments: function enrollments() {
      return this.$store.getters.loadedEnrollments;
    },
    loadEnrollments: function loadEnrollments() {
      return this.$store.getters.loadedTrials;
    }
  },
  methods: {
    onSaveChanges: function onSaveChanges() {
      if (this.editedTitle.trim() === '' || this.editedDescription.trim() === '') {
        return;
      }
      this.editDialog = false;
      this.$store.dispatch('updateTrialData', {
        trialId: this.trial.trialId,
        trialName: this.editedTitle,
        description: this.editedDescription,
        trialEnrollment: this.editedEnrollment,
        trialLink: this.editedLink
      });
    }
  }
});

/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['trial'],
  data: function data() {
    return {
      editDialog: false,
      editedEnrollments: this.trial.trialEnrollments,
      trialEnrollments: [],
      holder: []
    };
  },

  computed: {
    enrollments: function enrollments() {
      return this.$store.getters.loadedEnrollments;
    },
    loadEnrollments: function loadEnrollments() {
      return this.$store.getters.loadedTrials;
    }
  },
  methods: {
    onSaveChanges: function onSaveChanges() {
      this.trialEnrollments = this.editedEnrollments;
      this.editDialog = false;
      console.log('edit page: ' + this.trialEnrollments);
      this.$store.dispatch('updateTrialData', {
        trialId: this.trial.trialId,
        trialEnrollments: this.trialEnrollments
      });
    }
  }
});

/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['trial'],
  data: function data() {
    return {
      editDialog: false,
      editedIndications: this.trial.trialIndications,
      trialIndications: [],
      holder: []
    };
  },

  computed: {
    indications: function indications() {
      return this.$store.getters.loadedIndications;
    },
    loadIndications: function loadIndications() {
      return this.$store.getters.loadedTrials;
    },
    indicationsss: function indicationsss() {
      if (this.trial.trialIndications) {
        var indis = [];
        var val = [];
        // var item = []
        this.trial.trialIndications.filter(function (elem) {
          indis.push(elem);
        });
        console.log('Indication IDs: ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(indis));
        for (var i = 0; i < indis.length; i++) {
          console.log('SECOND GET INDIS: ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.$store.getters.loadedIndication(indis[i])));
          if (this.$store.getters.loadedIndication(indis[i])) {
            val.push(this.$store.getters.loadedIndication(indis[i]));
          }
        }
        console.log('FINAL val: ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(val));
        return val;
      } else {
        return null;
      }
    }
  },
  methods: {
    onSaveChanges: function onSaveChanges() {
      this.trialIndications = this.editedIndications;
      this.editDialog = false;
      console.log('edit page: ' + this.trialIndications);
      this.$store.dispatch('updateTrialData', {
        trialId: this.trial.trialId,
        trialIndications: this.trialIndications
      });
    }
  }
});

/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['trial'],
  data: function data() {
    return {
      editDialog: false,
      editedInvestigators: this.trial.trialInvestigators,
      trialInvestigators: [],
      holder: []
    };
  },

  computed: {
    investigators: function investigators() {
      return this.$store.getters.loadedInvestigators;
    },
    loadInvestigators: function loadInvestigators() {
      return this.$store.getters.loadedTrials;
    },
    investigatorsGetter: function investigatorsGetter() {
      if (this.trial.trialInvestigators) {
        var indis = [];
        var val = [];
        // var item = []
        this.trial.trialInvestigators.filter(function (elem) {
          indis.push(elem);
        });
        console.log('Investigator IDs: ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(indis));
        for (var i = 0; i < indis.length; i++) {
          console.log('SECOND GET Investigator: ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.$store.getters.loadedInvestigator(indis[i])));
          if (this.$store.getters.loadedInvestigator(indis[i])) {
            val.push(this.$store.getters.loadedInvestigator(indis[i]));
          }
        }
        console.log('FINAL val: ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(val));
        return val;
      } else {
        return null;
      }
    }
  },
  methods: {
    onSaveChanges: function onSaveChanges() {
      this.trialInvestigators = this.editedInvestigators;
      this.editDialog = false;
      console.log('edit page: ' + this.trialInvestigators);
      this.$store.dispatch('updateTrialData', {
        trialId: this.trial.trialId,
        trialInvestigators: this.trialInvestigators
      });
    }
  }
});

/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['trial'],
  data: function data() {
    return {
      editDialog: false,
      editedLocations: this.trial.trialLocations,
      trialLocations: [],
      holder: []
    };
  },

  computed: {
    locations: function locations() {
      return this.$store.getters.loadedLocations;
    },
    loadLocations: function loadLocations() {
      return this.$store.getters.loadedTrials;
    },
    locationsGetter: function locationsGetter() {
      if (this.trial.trialLocations) {
        var indis = [];
        var val = [];
        // var item = []
        this.trial.trialLocations.filter(function (elem) {
          indis.push(elem);
        });
        console.log('Location IDs: ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(indis));
        for (var i = 0; i < indis.length; i++) {
          console.log('SECOND GET Location: ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.$store.getters.loadedLocation(indis[i])));
          if (this.$store.getters.loadedLocation(indis[i])) {
            val.push(this.$store.getters.loadedLocation(indis[i]));
          }
        }
        console.log('FINAL val: ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(val));
        return val;
      } else {
        return null;
      }
    }
  },
  methods: {
    onSaveChanges: function onSaveChanges() {
      this.trialLocations = this.editedLocations;
      this.editDialog = false;
      console.log('edit page: ' + this.trialLocations);
      this.$store.dispatch('updateTrialData', {
        trialId: this.trial.trialId,
        trialLocations: this.trialLocations
      });
    }
  }
});

/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  computed: {
    enrollments: function enrollments() {
      return this.$store.getters.loadedEnrollments;
    },
    userIsAuthenticated: function userIsAuthenticated() {
      return this.$store.getters.user !== null && this.$store.getters.user !== undefined;
    },
    loading: function loading() {
      return this.$store.getters.loading;
    }
  },
  methods: {
    enrollment: function enrollment(index) {
      console.log('CURRENT ITEM: ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.$store.getters.loadedEnrollment(this.enrollments[index].enrollmentId)));
      return this.$store.getters.loadedEnrollment(this.enrollments[index].enrollmentId);
    },
    onDeleteEnrollment: function onDeleteEnrollment(enrollment) {
      console.log('Delete this: ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(enrollment));
      this.$store.dispatch('deleteEnrollmentData', enrollment);
      this.$router.push('/Trials/Enrollments');
    }
  }
});

/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['enrollmentId'],
  data: function data() {
    return {};
  },

  computed: {
    trials: function trials() {
      var _this = this;

      var loadedTrialss = this.$store.getters.loadedTrialsByEnrollment(this.enrollmentId);
      return loadedTrialss.sort(function (a, b) {
        var EPa = _this.$store.getters.loadedEnrollment(a.trialEnrollment);
        var EPb = _this.$store.getters.loadedEnrollment(b.trialEnrollment);
        return EPa.enrollmentPriority > EPb.enrollmentPriority ? 1 : EPb.enrollmentPriority > EPa.enrollmentPriority ? -1 : 0;
      });
    },
    userIsAuthenticated: function userIsAuthenticated() {
      return this.$store.getters.user !== null && this.$store.getters.user !== undefined;
    },
    enrollments: function enrollments() {
      console.log(this.enrollmentId);
      if (typeof this.$store.getters.loadedEnrollment(this.enrollmentId) !== 'undefined') {
        var locaName = this.$store.getters.loadedEnrollment(this.enrollmentId);
        return locaName.enrollmentName;
      }
    }
  },
  methods: {
    onDeleteTrial: function onDeleteTrial(trial) {
      this.$store.dispatch('deleteTrialData', trial);
      this.$router.push('/trials');
    }
  }
});

/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  computed: {
    indications: function indications() {
      return this.$store.getters.loadedIndications;
    },
    userIsAuthenticated: function userIsAuthenticated() {
      return this.$store.getters.user !== null && this.$store.getters.user !== undefined;
    },
    loading: function loading() {
      return this.$store.getters.loading;
    }
  },
  methods: {
    indication: function indication(index) {
      console.log('CURRENT ITEM: ' + this.$store.getters.loadedIndication(this.indications[index].indicationId));
      return this.$store.getters.loadedIndication(this.indications[index].indicationId);
    },
    onDeleteIndication: function onDeleteIndication(indication) {
      console.log('Delete this: ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(indication));
      this.$store.dispatch('deleteIndicationData', indication);
      this.$router.push('/indications');
    }
  }
});

/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['indicationId'],
  data: function data() {
    return {};
  },

  computed: {
    trials: function trials() {
      var _this = this;

      var loadedTrialss = this.$store.getters.loadedTrialsByIndication(this.indicationId);
      return loadedTrialss.sort(function (a, b) {
        var EPa = _this.$store.getters.loadedEnrollment(a.trialEnrollment);
        var EPb = _this.$store.getters.loadedEnrollment(b.trialEnrollment);
        return EPa.enrollmentPriority > EPb.enrollmentPriority ? 1 : EPb.enrollmentPriority > EPa.enrollmentPriority ? -1 : 0;
      });
    },
    userIsAuthenticated: function userIsAuthenticated() {
      return this.$store.getters.user !== null && this.$store.getters.user !== undefined;
    },
    indications: function indications() {
      if (typeof this.$store.getters.loadedIndication(this.indicationId) !== 'undefined') {
        var locaName = this.$store.getters.loadedIndication(this.indicationId);
        return locaName.indicationName;
      }
    }
  },
  methods: {
    enrollment: function enrollment(index) {
      console.log('CURRENT loadedEnrollment ITEM: ' + this.$store.getters.loadedEnrollment(this.trials[index].trialId));
      var val = this.$store.getters.loadedEnrollment(this.trials[index].trialEnrollment);
      return val;
    },
    locations: function locations(index) {
      console.log('CURRENT loadedLocation ITEM: ' + this.$store.getters.loadedLocation(this.trials[index].trialLocations));
      var val = this.$store.getters.loadedLocation(this.trials[index].trialLocations[0]);
      return val;
    },
    onDeleteTrial: function onDeleteTrial(trial) {
      this.$store.dispatch('deleteTrialData', trial);
      this.$router.push('/trials');
    }
  }
});

/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  computed: {
    investigators: function investigators() {
      return this.$store.getters.loadedInvestigators;
    },
    userIsAuthenticated: function userIsAuthenticated() {
      return this.$store.getters.user !== null && this.$store.getters.user !== undefined;
    },
    loading: function loading() {
      return this.$store.getters.loading;
    }
  },
  methods: {
    investigator: function investigator(index) {
      console.log('CURRENT ITEM: ' + this.$store.getters.loadedInvestigator(this.investigators[index].investigatorId));
      return this.$store.getters.loadedInvestigator(this.investigators[index].investigatorId);
    },
    onDeleteInvestigator: function onDeleteInvestigator(investigator) {
      console.log('Delete this: ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(investigator));
      this.$store.dispatch('deleteInvestigatorData', investigator);
      this.$router.push('/investigators');
    }
  }
});

/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['investigatorId'],
  data: function data() {
    return {};
  },

  computed: {
    trials: function trials() {
      var _this = this;

      var loadedTrialss = this.$store.getters.loadedTrialsByInvestigator(this.investigatorId);
      return loadedTrialss.sort(function (a, b) {
        var EPa = _this.$store.getters.loadedEnrollment(a.trialEnrollment);
        var EPb = _this.$store.getters.loadedEnrollment(b.trialEnrollment);
        return EPa.enrollmentPriority > EPb.enrollmentPriority ? 1 : EPb.enrollmentPriority > EPa.enrollmentPriority ? -1 : 0;
      });
    },
    userIsAuthenticated: function userIsAuthenticated() {
      return this.$store.getters.user !== null && this.$store.getters.user !== undefined;
    },
    investigators: function investigators() {
      if (typeof this.$store.getters.loadedInvestigator(this.investigatorId) !== 'undefined') {
        var locaName = this.$store.getters.loadedInvestigator(this.investigatorId);
        return locaName.investigatorName;
      }
    }
  },
  methods: {
    enrollment: function enrollment(index) {
      console.log('CURRENT loadedEnrollment ITEM: ' + this.$store.getters.loadedEnrollment(this.trials[index].trialId));
      var val = this.$store.getters.loadedEnrollment(this.trials[index].trialEnrollment);
      return val;
    },
    locations: function locations(index) {
      console.log('CURRENT loadedLocation ITEM: ' + this.$store.getters.loadedLocation(this.trials[index].trialLocations));
      var val = this.$store.getters.loadedLocation(this.trials[index].trialLocations[0]);
      return val;
    },
    onDeleteTrial: function onDeleteTrial(trial) {
      this.$store.dispatch('deleteTrialData', trial);
      this.$router.push('/trials');
    }
  }
});

/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  computed: {
    locations: function locations() {
      return this.$store.getters.loadedLocations;
    },
    userIsAuthenticated: function userIsAuthenticated() {
      return this.$store.getters.user !== null && this.$store.getters.user !== undefined;
    },
    loading: function loading() {
      return this.$store.getters.loading;
    }
  },
  methods: {
    location: function location(index) {
      console.log('CURRENT ITEM: ' + this.$store.getters.loadedLocation(this.locations[index].locationId));
      return this.$store.getters.loadedLocation(this.locations[index].locationId);
    },
    onDeleteLocation: function onDeleteLocation(location) {
      console.log('Delete this: ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(location));
      this.$store.dispatch('deleteLocationData', location);
      this.$router.push('/locations');
    }
  }
});

/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['locationId'],
  data: function data() {
    return {};
  },

  computed: {
    trials: function trials() {
      var _this = this;

      var loadedTrialss = this.$store.getters.loadedTrialsByLocation(this.locationId);
      return loadedTrialss.sort(function (a, b) {
        var EPa = _this.$store.getters.loadedEnrollment(a.trialEnrollment);
        var EPb = _this.$store.getters.loadedEnrollment(b.trialEnrollment);
        return EPa.enrollmentPriority > EPb.enrollmentPriority ? 1 : EPb.enrollmentPriority > EPa.enrollmentPriority ? -1 : 0;
      });
    },
    userIsAuthenticated: function userIsAuthenticated() {
      return this.$store.getters.user !== null && this.$store.getters.user !== undefined;
    },
    locations: function locations() {
      if (typeof this.$store.getters.loadedLocation(this.locationId) !== 'undefined') {
        var locaName = this.$store.getters.loadedLocation(this.locationId);
        return locaName.locationName;
      }
    }
  },
  methods: {
    enrollment: function enrollment(index) {
      console.log('CURRENT loadedEnrollment ITEM: ' + this.$store.getters.loadedEnrollment(this.trials[index].trialId));
      var val = this.$store.getters.loadedEnrollment(this.trials[index].trialEnrollment);
      return val;
    },
    locationsz: function locationsz(index) {
      console.log('CURRENT loadedLocation ITEM: ' + this.$store.getters.loadedLocation(this.trials[index].trialLocations));
      var val = this.$store.getters.loadedLocation(this.trials[index].trialLocations[0]);
      return val;
    },
    onDeleteTrial: function onDeleteTrial(trial) {
      this.$store.dispatch('deleteTrialData', trial);
      this.$router.push('/trials');
    }
  }
});

/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import * as firebase from 'firebase'

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      //  dialog: false
    };
  },

  props: ['id'],
  computed: {
    trial: function trial() {
      console.log(this.id);
      return this.$store.getters.loadedTrial(this.id);
    },
    enrollments: function enrollments() {
      return this.$store.getters.loadedEnrollments;
    },
    enrollmentsss: function enrollmentsss() {
      if (this.trial.trialEnrollment) {
        var val = [];
        val = this.$store.getters.loadedEnrollment(this.trial.trialEnrollment);
        console.log('enrollmentsss val: ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(val));
        return val;
      } else {
        return null;
      }
    },
    locations: function locations() {
      return this.$store.getters.loadedLocations;
    },
    locationsss: function locationsss() {
      if (this.trial.trialLocations) {
        var indis = [];
        var val = [];
        // var item = []
        this.trial.trialLocations.filter(function (elem) {
          indis.push(elem);
        });
        console.log('Location IDs: ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(indis));
        for (var i = 0; i < indis.length; i++) {
          console.log('SECOND GET INDIS: ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.$store.getters.loadedLocation(indis[i])));
          if (this.$store.getters.loadedLocation(indis[i])) {
            val.push(this.$store.getters.loadedLocation(indis[i]));
          }
        }
        console.log('FINAL val: ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(val));
        return val;
      } else {
        return null;
      }
    },
    indications: function indications() {
      return this.$store.getters.loadedIndications;
    },
    indicationsss: function indicationsss() {
      if (this.trial.trialIndications) {
        var indis = [];
        var val = [];
        // var item = []
        this.trial.trialIndications.filter(function (elem) {
          indis.push(elem);
        });
        console.log('Indication IDs: ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(indis));
        for (var i = 0; i < indis.length; i++) {
          console.log('SECOND GET INDIS: ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.$store.getters.loadedIndication(indis[i])));
          if (this.$store.getters.loadedIndication(indis[i])) {
            val.push(this.$store.getters.loadedIndication(indis[i]));
          }
        }
        console.log('FINAL val: ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(val));
        return val;
      } else {
        return null;
      }
    },
    investigator: function investigator() {
      return this.$store.getters.loadedInvestigators;
    },
    investigatorsGetter: function investigatorsGetter() {
      if (this.trial.trialInvestigators) {
        var indis = [];
        var val = [];
        // var item = []
        this.trial.trialInvestigators.filter(function (elem) {
          indis.push(elem);
        });
        console.log('Investigator IDs: ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(indis));
        for (var i = 0; i < indis.length; i++) {
          console.log('SECOND GET Investigator: ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.$store.getters.loadedInvestigator(indis[i])));
          if (this.$store.getters.loadedInvestigator(indis[i])) {
            val.push(this.$store.getters.loadedInvestigator(indis[i]));
          }
        }
        console.log('FINAL val: ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(val));
        return val;
      } else {
        return null;
      }
    },
    coordinator: function coordinator() {
      return this.$store.getters.loadedCoordinators;
    },
    coordinatorsGetter: function coordinatorsGetter() {
      if (this.trial.trialCoordinators) {
        var indis = [];
        var val = [];
        // var item = []
        this.trial.trialCoordinators.filter(function (elem) {
          indis.push(elem);
        });
        console.log('Coordinator IDs: ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(indis));
        for (var i = 0; i < indis.length; i++) {
          console.log('SECOND GET Coordinator: ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.$store.getters.loadedCoordinator(indis[i])));
          if (this.$store.getters.loadedCoordinator(indis[i])) {
            val.push(this.$store.getters.loadedCoordinator(indis[i]));
          }
        }
        console.log('FINAL val: ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(val));
        return val;
      } else {
        return null;
      }
    },
    userIsAuthenticated: function userIsAuthenticated() {
      return this.$store.getters.user !== null && this.$store.getters.user !== undefined;
    },
    userIsCreator: function userIsCreator() {
      if (!this.userIsAuthenticated) {
        return false;
      }
      return this.$store.getters.user.id === this.trial.creatorId;
    },
    loading: function loading() {
      return this.$store.getters.loading;
    }
  }
});

/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['id'],
  data: function data() {
    return {};
  },

  computed: {
    trials: function trials() {
      var _this = this;

      var loadedTrialss = this.$store.getters.loadedTrials;
      return loadedTrialss.sort(function (a, b) {
        var EPa = _this.$store.getters.loadedEnrollment(a.trialEnrollment);
        var EPb = _this.$store.getters.loadedEnrollment(b.trialEnrollment);
        return EPa.enrollmentPriority > EPb.enrollmentPriority ? 1 : EPb.enrollmentPriority > EPa.enrollmentPriority ? -1 : 0;
      });
    },
    userIsAuthenticated: function userIsAuthenticated() {
      return this.$store.getters.user !== null && this.$store.getters.user !== undefined;
    },
    loading: function loading() {
      return this.$store.getters.loading;
    },
    enrollmentsss: function enrollmentsss() {
      if (this.trial.trialEnrollment) {
        var val = [];
        val = this.$store.getters.loadedEnrollment(this.trial.trialEnrollment);
        return val.enrollmentName;
      } else {
        return null;
      }
    }
  },
  methods: {
    trial: function trial(index) {
      return this.$store.getters.loadedTrial(this.trials[index].trialId);
    },
    enrollment: function enrollment(index) {
      console.log('CURRENT loadedEnrollment ITEM: ' + this.$store.getters.loadedEnrollment(this.trials[index].trialId));
      var val = this.$store.getters.loadedEnrollment(this.trials[index].trialEnrollment);
      return val;
    },
    locations: function locations(index) {
      console.log('CURRENT loadedLocation ITEM: ' + this.$store.getters.loadedLocation(this.trials[index].trialLocations));
      var val = this.$store.getters.loadedLocation(this.trials[index].trialLocations[0]);
      return val;
    },
    onDeleteTrial: function onDeleteTrial(trial) {
      this.$store.dispatch('deleteTrialData', trial);
      this.$router.push('/trials');
    }
  },
  mutations: {
    trials: function trials(newArray) {
      this.$store.dispatch('loadTrials');
    }
  }
});

/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      email: '',
      password: '',
      editDialog: false
    };
  },

  computed: {
    user: function user() {
      return this.$store.getters.user;
    },
    error: function error() {
      return this.$store.getters.error;
    },
    loading: function loading() {
      return this.$store.getters.loading;
    }
  },
  watch: {
    user: function user(value) {
      if (value !== null && value !== undefined) {
        this.$router.push('/');
      }
    }
  },
  methods: {
    onSignin: function onSignin() {
      // Vuex
      this.$store.dispatch('signUserIn', { email: this.email, password: this.password });
      this.$store.dispatch('loadTrials');
      this.$router.push('/');
    },
    onDismissed: function onDismissed() {
      this.$store.dispatch('clearError');
    }
  }
});

/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      email: '',
      password: '',
      editDialog: false
    };
  },

  computed: {
    user: function user() {
      return this.$store.getters.user;
    },
    error: function error() {
      return this.$store.getters.error;
    },
    loading: function loading() {
      return this.$store.getters.loading;
    }
  },
  watch: {
    user: function user(value) {
      if (value !== null && value !== undefined) {
        this.$router.push('/');
      }
    }
  },
  methods: {
    onSignin: function onSignin() {
      // Vuex
      this.$store.dispatch('signUserIn', { email: this.email, password: this.password });
    },
    onDismissed: function onDismissed() {
      this.$store.dispatch('clearError');
    }
  }
});

/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      email: '',
      password: '',
      confirmPassword: ''
    };
  },

  computed: {
    comparePasswords: function comparePasswords() {
      return this.password !== this.confirmPassword ? 'Passwords do not match' : true;
    },
    user: function user() {
      return this.$store.getters.user;
    },
    error: function error() {
      return this.$store.getters.error;
    },
    loading: function loading() {
      return this.$store.getters.loading;
    }
  },
  watch: {
    user: function user(value) {
      if (value !== null && value !== undefined) {
        this.$router.push('/');
      }
    }
  },
  methods: {
    onSignup: function onSignup() {
      // Vuex
      this.$store.dispatch('signUserUp', { email: this.email, password: this.password });
    },
    onDismissed: function onDismissed() {
      this.$store.dispatch('clearError');
    }
  }
});

/***/ }),
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 590 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 591 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 592 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 593 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 594 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 595 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 596 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 597 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 598 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 599 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 600 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 601 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(599)
  __webpack_require__(598)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(308),
  /* template */
  __webpack_require__(689),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(309),
  /* template */
  __webpack_require__(664),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(310),
  /* template */
  __webpack_require__(703),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(311),
  /* template */
  __webpack_require__(695),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(312),
  /* template */
  __webpack_require__(676),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(313),
  /* template */
  __webpack_require__(687),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(314),
  /* template */
  __webpack_require__(704),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(315),
  /* template */
  __webpack_require__(690),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(316),
  /* template */
  __webpack_require__(702),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(317),
  /* template */
  __webpack_require__(672),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(318),
  /* template */
  __webpack_require__(660),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(319),
  /* template */
  __webpack_require__(661),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(320),
  /* template */
  __webpack_require__(708),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(594)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(321),
  /* template */
  __webpack_require__(679),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-498be9ef",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(323),
  /* template */
  __webpack_require__(659),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(324),
  /* template */
  __webpack_require__(663),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(325),
  /* template */
  __webpack_require__(684),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(326),
  /* template */
  __webpack_require__(665),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(327),
  /* template */
  __webpack_require__(705),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(328),
  /* template */
  __webpack_require__(709),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(329),
  /* template */
  __webpack_require__(667),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(330),
  /* template */
  __webpack_require__(688),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(331),
  /* template */
  __webpack_require__(701),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(332),
  /* template */
  __webpack_require__(697),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(333),
  /* template */
  __webpack_require__(685),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(334),
  /* template */
  __webpack_require__(662),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(335),
  /* template */
  __webpack_require__(706),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(600)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(336),
  /* template */
  __webpack_require__(693),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6cfa5d01",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(337),
  /* template */
  __webpack_require__(671),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(593)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(338),
  /* template */
  __webpack_require__(675),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(339),
  /* template */
  __webpack_require__(680),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(340),
  /* template */
  __webpack_require__(670),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(341),
  /* template */
  __webpack_require__(699),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(342),
  /* template */
  __webpack_require__(681),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(343),
  /* template */
  __webpack_require__(707),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(344),
  /* template */
  __webpack_require__(691),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(345),
  /* template */
  __webpack_require__(698),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(346),
  /* template */
  __webpack_require__(696),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(347),
  /* template */
  __webpack_require__(668),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(591)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(348),
  /* template */
  __webpack_require__(666),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2889f0a1",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(349),
  /* template */
  __webpack_require__(674),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(595)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(350),
  /* template */
  __webpack_require__(682),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-514f34a4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(351),
  /* template */
  __webpack_require__(692),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(592)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(352),
  /* template */
  __webpack_require__(673),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3b00fc8c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(601)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(353),
  /* template */
  __webpack_require__(700),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(597)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(354),
  /* template */
  __webpack_require__(686),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5bb19ae2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(596)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(355),
  /* template */
  __webpack_require__(683),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-51fb9bf6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  null,
  /* template */
  __webpack_require__(678),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(357),
  /* template */
  __webpack_require__(677),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 659 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "width": "350px",
      "persistent": ""
    },
    model: {
      value: (_vm.editDialog),
      callback: function($$v) {
        _vm.editDialog = $$v
      },
      expression: "editDialog"
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "icon": ""
    },
    slot: "activator"
  }, [_c('v-icon', {
    staticClass: "text--lighten-1",
    attrs: {
      "small": "",
      "light": ""
    }
  }, [_vm._v("edit")])], 1), _vm._v(" "), _c('v-card', [_c('v-container', {
    staticClass: "mt-0"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "mb-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card-title', {
    staticClass: "justify-center"
  }, [_c('h2', [_vm._v("Edit Indication")])])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_vm._l((_vm.editedIndications), function(item) {
    return _c('v-flex', {
      key: item.objectName,
      attrs: {
        "xs12": ""
      }
    }, [_vm._v("\n          " + _vm._s(item.name) + "\n        ")])
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card-text', [_c('v-text-field', {
    attrs: {
      "name": "editedIndicationsName",
      "label": "Indication",
      "id": "editedIndicationsName"
    },
    model: {
      value: (_vm.editedIndicationsName),
      callback: function($$v) {
        _vm.editedIndicationsName = $$v
      },
      expression: "editedIndicationsName"
    }
  })], 1)], 1)], 2), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card-actions', {
    staticClass: "justify-center"
  }, [_c('v-btn', {
    staticClass: "grey lighten-1 white--text",
    attrs: {
      "depressed": ""
    },
    on: {
      "click": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    staticClass: "white--text primary ",
    attrs: {
      "depressed": ""
    },
    on: {
      "click": _vm.onSaveChanges
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('v-btn', {
    staticClass: "red darken-3",
    attrs: {
      "dark": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.onDeleteIndication(_vm.indication)
      }
    }
  }, [_c('v-icon', {
    staticClass: "text--lighten-1",
    attrs: {
      "small": "",
      "dark": ""
    }
  }, [_vm._v("delete")])], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 660 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "width": "350px",
      "persistent": ""
    },
    model: {
      value: (_vm.editDialog),
      callback: function($$v) {
        _vm.editDialog = $$v
      },
      expression: "editDialog"
    }
  }, [_c('v-btn', {
    staticClass: "orange darken-3",
    attrs: {
      "slot": "activator",
      "dark": "",
      "flat": ""
    },
    slot: "activator"
  }, [_c('v-icon', {
    staticClass: "text--lighten-1",
    attrs: {
      "small": "",
      "dark": ""
    }
  }, [_vm._v("edit")])], 1), _vm._v(" "), _c('v-card', [_c('v-container', {
    staticClass: "mt-0"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "mb-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card-title', {
    staticClass: "justify-center"
  }, [_c('h2', [_vm._v("Edit Enrollment")])])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_vm._l((_vm.editedEnrollments), function(item) {
    return _c('v-flex', {
      key: item.objectName,
      attrs: {
        "xs12": ""
      }
    }, [_vm._v("\n          " + _vm._s(item.name) + "\n        ")])
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card-text', [_c('v-text-field', {
    attrs: {
      "name": "editedEnrollmentsName",
      "label": "Enrollment",
      "id": "editedEnrollmentsName"
    },
    model: {
      value: (_vm.editedEnrollmentsName),
      callback: function($$v) {
        _vm.editedEnrollmentsName = $$v
      },
      expression: "editedEnrollmentsName"
    }
  })], 1)], 1)], 2), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_vm._l((_vm.editedEnrollments), function(item) {
    return _c('v-flex', {
      key: item.objectName,
      attrs: {
        "xs12": ""
      }
    }, [_vm._v("\n          " + _vm._s(item.name) + "\n        ")])
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card-text', [_c('v-select', {
    attrs: {
      "name": "editedEnrollmentsPriority",
      "items": _vm.editedEnrollmentsPriorityHolder,
      "label": "Enrollment Priority",
      "id": "editedEnrollmentsPriority"
    },
    model: {
      value: (_vm.editedEnrollmentsPriority),
      callback: function($$v) {
        _vm.editedEnrollmentsPriority = $$v
      },
      expression: "editedEnrollmentsPriority"
    }
  })], 1)], 1)], 2), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card-actions', {
    staticClass: "justify-center"
  }, [_c('v-btn', {
    staticClass: "grey lighten-1 white--text",
    attrs: {
      "depressed": ""
    },
    on: {
      "click": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    staticClass: "white--text primary ",
    attrs: {
      "depressed": ""
    },
    on: {
      "click": _vm.onSaveChanges
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 661 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', [(_vm.loading) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": "",
      "sm8": "",
      "md6": ""
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary",
      "width": 7,
      "size": 70
    }
  })], 1)], 1) : _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": "",
      "sm6": "",
      "offset-sm3": ""
    }
  }, [_c('h1', {
    staticClass: "mt-3 text-xs-center"
  }, [_vm._v(_vm._s(_vm.enrollment.enrollmentName))]), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.userIsCreator) ? [_c('v-spacer'), _vm._v(" "), _c('app-edit-enrollment-dialog', {
    attrs: {
      "enrollment": _vm.enrollment
    }
  })] : _vm._e()], 2)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 662 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-alert', {
    attrs: {
      "color": "error",
      "icon": "error",
      "dismissible": "",
      "value": true
    },
    on: {
      "input": _vm.onClose
    }
  }, [_vm._v("\n      " + _vm._s(_vm.text) + "\n")])
},staticRenderFns: []}

/***/ }),
/* 663 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "mt-0"
  }, [(_vm.loading) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": "",
      "sm8": "",
      "md6": ""
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary",
      "width": 7,
      "size": 70
    }
  })], 1)], 1) : _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": "",
      "sm6": "",
      "offset-sm3": ""
    }
  }, [_c('h1', {
    staticClass: "mt-3 text-xs-center"
  }, [_vm._v(_vm._s(_vm.indication.indicationName))]), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.userIsCreator) ? [_c('v-spacer'), _vm._v(" "), _c('app-edit-indication-dialog', {
    attrs: {
      "indication": _vm.indication
    }
  })] : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "red darken-3",
    attrs: {
      "dark": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.onDeleteIndication(_vm.indication)
      }
    }
  }, [_c('v-icon', {
    staticClass: "text--lighten-1",
    attrs: {
      "small": "",
      "dark": ""
    }
  }, [_vm._v("delete")])], 1)], 2)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 664 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "mt-0"
  }, [(_vm.loading) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": "",
      "sm8": "",
      "md6": ""
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary",
      "width": 7,
      "size": 70
    }
  })], 1)], 1) : _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": "",
      "sm6": "",
      "offset-sm3": ""
    }
  }, [_c('h1', {
    staticClass: "mt-3 text-xs-center"
  }, [_vm._v(_vm._s(_vm.alert.alertName))]), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.userIsCreator) ? [_c('v-spacer'), _vm._v(" "), _c('app-edit-alert-dialog', {
    attrs: {
      "alert": _vm.alert
    }
  })] : _vm._e()], 2)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 665 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "mt-0"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "offset-sm3": ""
    }
  }, [_c('h4', [_vm._v("Create a new Investigator")])])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "offset-sm3": ""
    }
  }, [_c('form', {
    attrs: {
      "action": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onCreateInvestigator($event)
      }
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "investigatorName",
      "label": "Name",
      "id": "investigatorName",
      "single-line": "",
      "required": ""
    },
    model: {
      value: (_vm.investigatorName),
      callback: function($$v) {
        _vm.investigatorName = $$v
      },
      expression: "investigatorName"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "name": "investigatorPhone",
      "label": "Phone Number",
      "id": "investigatorPhone",
      "single-line": ""
    },
    model: {
      value: (_vm.investigatorPhone),
      callback: function($$v) {
        _vm.investigatorPhone = $$v
      },
      expression: "investigatorPhone"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "name": "investigatorEmail",
      "label": "Email Address",
      "id": "investigatorEmail",
      "single-line": "",
      "required": ""
    },
    model: {
      value: (_vm.investigatorEmail),
      callback: function($$v) {
        _vm.investigatorEmail = $$v
      },
      expression: "investigatorEmail"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-btn', {
    staticClass: "primary",
    attrs: {
      "disabled": !_vm.formIsValid,
      "type": "submit"
    }
  }, [_vm._v("\n              Create Investigator\n            ")])], 1)], 1)], 1)])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 666 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "mt-0"
  }, [_c('v-layout', {
    staticClass: "mt-3",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('h1', [_vm._v("Trials By " + _vm._s(_vm.indications))]), _vm._v(" "), (_vm.trials == false) ? _c('v-alert', {
    attrs: {
      "color": "info",
      "icon": "new_releases",
      "value": true
    }
  }, [_vm._v("\n          There are no trials for the " + _vm._s(_vm.indications) + " indication.\n        ")]) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "align-content-space-between": "",
      "mt-4": "",
      "mb-0": "",
      "ml-0": "",
      "mr-0": ""
    }
  }, _vm._l((_vm.trials), function(item, index) {
    return _c('v-card', {
      key: item.trialId,
      staticClass: "info",
      attrs: {
        "to": '/trials/' + item.trialId
      }
    }, [_c('v-list', {
      staticClass: "listItems"
    }, [_c('v-list-tile', {
      staticClass: "pl-2",
      attrs: {
        "avatar": ""
      }
    }, [_c('v-list-tile-avatar', [_c('span', {
      staticClass: "status"
    }, [_c('span', {
      class: _vm.enrollment(index).enrollmentName
    }), _c('br')])]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n                  " + _vm._s(item.trialName) + "\n                ")]), _vm._v(" "), _c('v-list-tile-sub-title', [_c('span', [_vm._v(_vm._s(_vm.enrollment(index).enrollmentName))]), _c('span', [_vm._v(" - " + _vm._s(_vm.locations(index).locationName))])])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "light": "",
        "flat": "",
        "icon": "",
        "right": "",
        "ripple": "",
        "to": '/trials/' + item.trialId
      }
    }, [_c('right-icon', {
      staticClass: "icon",
      attrs: {
        "small": "",
        "color": item.active ? 'primary' : 'grey'
      }
    })], 1)], 1), _vm._v(" "), (_vm.userIsAuthenticated) ? _c('v-list-tile-action', {}, [_c('v-btn', {
      attrs: {
        "light": "",
        "icon": "",
        "right": "",
        "flat": "",
        "to": '/trials/' + item.trialId + '/edit'
      }
    }, [_c('v-icon', {
      staticClass: "text--lighten-2",
      attrs: {
        "small": "",
        "light": ""
      }
    }, [_vm._v("edit")])], 1)], 1) : _vm._e()], 1)], 1)], 1)
  })), _vm._v(" "), (_vm.userIsAuthenticated) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "mb-4": ""
    }
  }, [_c('v-card', {
    attrs: {
      "to": '/trial/new'
    }
  }, [(_vm.userIsAuthenticated) ? _c('v-card-text', {
    staticClass: "cyanLight editDialogsRow"
  }, [_vm._v("\n          Add Trial\n          "), _c('v-icon', {
    staticClass: "text-xs-right"
  }, [_vm._v("add")])], 1) : _vm._e()], 1)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 667 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "mt-0"
  }, [_c('v-layout', {
    staticClass: "mt-3",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center mb-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('h1', [_vm._v("All Investigators")]), _vm._v(" "), (_vm.investigators == false) ? _c('v-alert', {
    attrs: {
      "color": "info",
      "icon": "new_releases",
      "value": true
    }
  }, [_vm._v("\n          There are no investigators.\n        ")]) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs10": "",
      "sm11": "",
      "md11": "",
      "align-content-space-between": "",
      "mt-4": "",
      "mb-0": "",
      "ml-0": "",
      "mr-0": ""
    }
  }, _vm._l((_vm.investigators), function(item, index) {
    return _c('v-card', {
      key: item.investigatorId,
      staticClass: "info",
      attrs: {
        "to": '/investigator/' + item.investigatorId
      }
    }, [_c('v-list', {
      staticClass: "listItems"
    }, [_c('v-list-tile', {
      staticClass: "pb-2 pt-2 pl-2"
    }, [_c('v-list-tile-avatar', [_c('v-icon', {
      attrs: {
        "left": ""
      }
    }, [_vm._v("person_pin")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(item.investigatorName)
      }
    })], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "light": "",
        "flat": "",
        "ripple": ""
      }
    }, [_c('v-icon', {
      attrs: {
        "color": item.active ? 'primary' : 'grey'
      }
    }, [_vm._v("navigate_next")])], 1)], 1)], 1)], 1)], 1)
  })), _vm._v(" "), (_vm.userIsAuthenticated) ? _c('v-flex', {
    attrs: {
      "xs2": "",
      "sm1": "",
      "md1": "",
      "ml-0": "",
      "mr-0": "",
      "mb-0": "",
      "mt-4": "",
      "justify-center": ""
    }
  }, _vm._l((_vm.investigators), function(item2, index2) {
    return _c('v-card', {
      key: item2.investigatorId,
      staticClass: "info"
    }, [_c('v-list', {
      staticClass: "listItems pa-0"
    }, [_c('v-list-tile', {
      staticClass: "pa-2"
    }, [_c('app-edit-investigator-dialog', {
      attrs: {
        "investigator": _vm.investigator(index2)
      }
    })], 1)], 1)], 1)
  })) : _vm._e(), _vm._v(" "), (_vm.userIsAuthenticated) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "mb-4": ""
    }
  }, [_c('v-card', {
    attrs: {
      "to": '/investigator/new'
    }
  }, [(_vm.userIsAuthenticated) ? _c('v-card-text', {
    staticClass: "cyanLight editDialogsRow"
  }, [_vm._v("\n          Add Investigator\n          "), _c('v-icon', {
    staticClass: "text-xs-right"
  }, [_vm._v("add")])], 1) : _vm._e()], 1)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 668 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "mt-0"
  }, [_c('v-layout', {
    staticClass: "mt-3",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center mb-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('h1', [_vm._v("Trials By Indications")]), _vm._v(" "), (_vm.indications == false) ? _c('v-alert', {
    attrs: {
      "color": "info",
      "icon": "new_releases",
      "value": true
    }
  }, [_vm._v("\n          There are no indications.\n        ")]) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs10": "",
      "sm11": "",
      "md11": "",
      "align-content-space-between": "",
      "mt-4": "",
      "mb-0": "",
      "ml-0": "",
      "mr-0": ""
    }
  }, _vm._l((_vm.indications), function(item) {
    return _c('v-card', {
      key: item.indicationId,
      staticClass: "info",
      attrs: {
        "to": '/Trials/indications/' + item.indicationId
      }
    }, [_c('v-list', {
      staticClass: "listItems"
    }, [_c('v-list-tile', {
      staticClass: "pb-2 pt-2 pl-2"
    }, [_c('v-list-tile-avatar', [_c('indication-icon', {
      staticClass: "icon",
      attrs: {
        "left": ""
      }
    })], 1), _vm._v(" "), _c('v-list-tile-content', {
      staticClass: "pl-2"
    }, [_c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(item.indicationName)
      }
    })], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "light": "",
        "flat": "",
        "ripple": ""
      }
    }, [_c('v-icon', {
      attrs: {
        "color": item.active ? 'grey' : 'grey'
      }
    }, [_vm._v("navigate_next")])], 1)], 1)], 1)], 1)], 1)
  })), _vm._v(" "), (_vm.userIsAuthenticated) ? _c('v-flex', {
    attrs: {
      "xs2": "",
      "sm1": "",
      "md1": "",
      "ml-0": "",
      "mr-0": "",
      "mb-0": "",
      "mt-4": "",
      "justify-center": ""
    }
  }, _vm._l((_vm.indications), function(item2, index2) {
    return _c('v-card', {
      key: item2.indicationId,
      staticClass: "info"
    }, [_c('v-list', {
      staticClass: "listItems pa-0"
    }, [_c('v-list-tile', {
      staticClass: "pa-2"
    }, [_c('app-edit-indication-dialog', {
      attrs: {
        "indication": _vm.indication(index2)
      }
    })], 1)], 1)], 1)
  })) : _vm._e(), _vm._v(" "), (_vm.userIsAuthenticated) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "mb-4": ""
    }
  }, [_c('v-card', {
    attrs: {
      "to": '/indication/new'
    }
  }, [(_vm.userIsAuthenticated) ? _c('v-card-text', {
    staticClass: "cyanLight editDialogsRow"
  }, [_vm._v("\n          Add Indications\n          "), _c('v-icon', {
    staticClass: "text-xs-right"
  }, [_vm._v("add")])], 1) : _vm._e()], 1)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 669 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "width": "350px",
      "persistent": ""
    },
    model: {
      value: (_vm.editDialog),
      callback: function($$v) {
        _vm.editDialog = $$v
      },
      expression: "editDialog"
    }
  }, [_c('v-btn', {
    staticClass: "orange pa-2",
    attrs: {
      "slot": "activator",
      "dark": "",
      "flat": ""
    },
    slot: "activator"
  }, [_c('v-icon', {
    staticClass: "white--text text--lighten-1"
  }, [_vm._v("edit")])], 1), _vm._v(" "), _c('v-card', [_c('v-container', [_c('v-layout', {
    attrs: {
      "justify-end": "",
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "mb-2",
    attrs: {
      "xs1": ""
    }
  }, [_c('v-icon', {
    staticClass: "cyan--text",
    attrs: {
      "depressed": ""
    },
    on: {
      "click": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center mb-4",
    attrs: {
      "xs12": ""
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/VIPTrials_Logo_sized.png"
    }
  })])], 1), _vm._v(" "), (_vm.error) ? _c('v-layout', {
    attrs: {
      "row": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('app-alert', {
    attrs: {
      "text": _vm.error.message
    },
    on: {
      "dismissed": _vm.onDismissed
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('p', {
    staticClass: "grey--text"
  }, [_vm._v("Administrator Login")]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSignin($event)
      }
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "email",
      "label": "Email Address",
      "id": "email",
      "type": "email",
      "required": ""
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "password",
      "label": "Password",
      "id": "password",
      "type": "password",
      "required": ""
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    staticClass: "grey lighten-1 white--text",
    attrs: {
      "xs4": "",
      "depressed": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_vm._v("\n                    Cancel\n                  ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "cyan white--text",
    attrs: {
      "xs4": "",
      "type": "submit",
      "disabled": _vm.loading,
      "loading": _vm.loading,
      "depressed": ""
    }
  }, [_vm._v("\n                    Log In\n                    "), _c('span', {
    staticClass: "custom-loader",
    attrs: {
      "slot": "loader"
    },
    slot: "loader"
  }, [_c('v-icon', {
    attrs: {
      "light": ""
    }
  }, [_vm._v("cached")])], 1)])], 1)], 1)], 1)])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 670 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "width": "350px",
      "persistent": ""
    },
    model: {
      value: (_vm.editDialog),
      callback: function($$v) {
        _vm.editDialog = $$v
      },
      expression: "editDialog"
    }
  }, [_c('div', {
    staticClass: "pa-0 pl-2",
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_c('v-icon', {
    staticClass: "text-xs-right"
  }, [_vm._v("edit")])], 1), _vm._v(" "), _c('v-card', [_c('v-container', [_c('v-layout', {
    attrs: {
      "justify-end": "",
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "mb-2",
    attrs: {
      "xs1": ""
    }
  }, [_c('v-icon', {
    staticClass: "primary--text text--lighten-1",
    attrs: {
      "depressed": ""
    },
    on: {
      "click": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_vm._v("close")])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "mb-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card-title', {
    staticClass: "text-xs-center justify-center"
  }, [_c('h2', [_vm._v("Edit " + _vm._s(_vm.trial.trialName))])])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card-text', [_c('v-text-field', {
    attrs: {
      "name": "title",
      "label": "Title",
      "id": "title",
      "required": ""
    },
    model: {
      value: (_vm.editedTitle),
      callback: function($$v) {
        _vm.editedTitle = $$v
      },
      expression: "editedTitle"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "name": "trial.editedDescription",
      "label": "Edit Trial Description",
      "id": "editedDescription",
      "multi-line": "",
      "required": ""
    },
    model: {
      value: (_vm.editedDescription),
      callback: function($$v) {
        _vm.editedDescription = $$v
      },
      expression: "editedDescription"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "name": "trial.editedEnrollment",
      "label": "Edit Trial Status",
      "items": _vm.enrollments,
      "item-value": "enrollmentId",
      "item-text": "enrollmentName",
      "id": "editedEnrollment",
      "max-height": "400",
      "hint": "Pick your enrollment",
      "persistent-hint": ""
    },
    model: {
      value: (_vm.editedEnrollment),
      callback: function($$v) {
        _vm.editedEnrollment = $$v
      },
      expression: "editedEnrollment"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "name": "trialLink",
      "label": "Edit Trial Link",
      "id": "trialLinks",
      "required": ""
    },
    model: {
      value: (_vm.editedLink),
      callback: function($$v) {
        _vm.editedLink = $$v
      },
      expression: "editedLink"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card-actions', {
    staticClass: "justify-center"
  }, [_c('v-btn', {
    staticClass: "grey lighten-1 white--text",
    attrs: {
      "depressed": ""
    },
    on: {
      "click": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    staticClass: "white--text primary ",
    attrs: {
      "depressed": ""
    },
    on: {
      "click": _vm.onSaveChanges
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 671 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "mt-0"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "offset-sm2": ""
    }
  }, [_c('h4', [_vm._v("Create a new Trial")])])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "offset-sm2": ""
    }
  }, [_c('form', {
    attrs: {
      "action": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onCreateTrial($event)
      }
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "title",
      "label": "Title",
      "id": "title",
      "required": ""
    },
    model: {
      value: (_vm.title),
      callback: function($$v) {
        _vm.title = $$v
      },
      expression: "title"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "description",
      "label": "Description",
      "id": "description",
      "multi-line": "",
      "required": ""
    },
    model: {
      value: (_vm.description),
      callback: function($$v) {
        _vm.description = $$v
      },
      expression: "description"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": ""
    }
  }, [_c('v-select', {
    attrs: {
      "name": "trialEnrollment",
      "label": "Add Trial Enrollments",
      "items": _vm.enrollments,
      "item-value": "enrollmentId",
      "item-text": "enrollmentName",
      "id": "trialEnrollment",
      "max-height": "400",
      "hint": "Pick your enrollments",
      "persistent-hint": "",
      "required": ""
    },
    model: {
      value: (_vm.trialEnrollment),
      callback: function($$v) {
        _vm.trialEnrollment = $$v
      },
      expression: "trialEnrollment"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": ""
    }
  }, [_c('v-select', {
    attrs: {
      "name": "trialLocations",
      "label": "Add Trial Locations",
      "items": _vm.locations,
      "item-value": "locationId",
      "item-text": "locationName",
      "id": "trialLocations",
      "multiple": "",
      "max-height": "400",
      "hint": "Pick your locations",
      "persistent-hint": ""
    },
    model: {
      value: (_vm.trialLocations),
      callback: function($$v) {
        _vm.trialLocations = $$v
      },
      expression: "trialLocations"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": ""
    }
  }, [_c('v-select', {
    attrs: {
      "name": "trialIndications",
      "label": "Add Trial Indications",
      "items": _vm.indications,
      "item-value": "indicationId",
      "item-text": "indicationName",
      "id": "trialIndications",
      "multiple": "",
      "max-height": "400",
      "hint": "Pick your indications",
      "persistent-hint": ""
    },
    model: {
      value: (_vm.trialIndications),
      callback: function($$v) {
        _vm.trialIndications = $$v
      },
      expression: "trialIndications"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": ""
    }
  }, [_c('v-select', {
    attrs: {
      "name": "trialCoordinators",
      "label": "Add Trial Coordinators",
      "items": _vm.coordinators,
      "item-value": "coordinatorId",
      "item-text": "coordinatorName",
      "id": "trialCoordinators",
      "multiple": "",
      "max-height": "400",
      "hint": "Pick your Coordinators",
      "persistent-hint": ""
    },
    model: {
      value: (_vm.trialCoordinators),
      callback: function($$v) {
        _vm.trialCoordinators = $$v
      },
      expression: "trialCoordinators"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": ""
    }
  }, [_c('v-select', {
    attrs: {
      "name": "trialInvestigators",
      "label": "Add Trial Investigators",
      "items": _vm.investigators,
      "item-value": "investigatorId",
      "item-text": "investigatorName",
      "id": "trialInvestigators",
      "multiple": "",
      "max-height": "400",
      "hint": "Pick your Investigators",
      "persistent-hint": ""
    },
    model: {
      value: (_vm.trialInvestigators),
      callback: function($$v) {
        _vm.trialInvestigators = $$v
      },
      expression: "trialInvestigators"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "trialLink",
      "label": "Link",
      "id": "trialLink",
      "required": ""
    },
    model: {
      value: (_vm.trialLink),
      callback: function($$v) {
        _vm.trialLink = $$v
      },
      expression: "trialLink"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": ""
    }
  }, [_c('v-btn', {
    staticClass: "primary",
    attrs: {
      "disabled": !_vm.formIsValid,
      "type": "submit"
    }
  }, [_vm._v("\n              Create Trial\n            ")])], 1)], 1)], 1)])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 672 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "offset-sm3": ""
    }
  }, [_c('h4', [_vm._v("Create a new Enrollment")])])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "offset-sm3": ""
    }
  }, [_c('form', {
    attrs: {
      "action": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onCreateEnrollment($event)
      }
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "enrollmentName",
      "label": "Name",
      "id": "enrollmentName",
      "single-line": "",
      "required": ""
    },
    model: {
      value: (_vm.enrollmentName),
      callback: function($$v) {
        _vm.enrollmentName = $$v
      },
      expression: "enrollmentName"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "name": "enrollmentPriority",
      "label": "Priority",
      "items": _vm.enrollmentPriorityHolder,
      "id": "enrollmentPriority",
      "single-line": "",
      "required": ""
    },
    model: {
      value: (_vm.editedEnrollmentPriority),
      callback: function($$v) {
        _vm.editedEnrollmentPriority = $$v
      },
      expression: "editedEnrollmentPriority"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-btn', {
    staticClass: "primary",
    attrs: {
      "disabled": !_vm.formIsValid,
      "type": "submit"
    }
  }, [_vm._v("\n              Create Enrollment\n            ")])], 1)], 1)], 1)])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 673 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "mt-0"
  }, [_c('v-layout', {
    staticClass: "mt-3",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('h1', [_vm._v("Trials in " + _vm._s(_vm.locations))]), _vm._v(" "), (_vm.trials == false) ? _c('v-alert', {
    attrs: {
      "color": "info",
      "icon": "new_releases",
      "value": true
    }
  }, [_vm._v("\n          There are no trials for the " + _vm._s(_vm.locations) + " location.\n        ")]) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "align-content-space-between": "",
      "mt-4": "",
      "mb-0": "",
      "ml-0": "",
      "mr-0": ""
    }
  }, _vm._l((_vm.trials), function(item, index) {
    return _c('v-card', {
      key: item.trialId,
      staticClass: "info",
      attrs: {
        "to": '/trials/' + item.trialId
      }
    }, [_c('v-list', {
      staticClass: "listItems"
    }, [_c('v-list-tile', {
      staticClass: "pl-2",
      attrs: {
        "avatar": ""
      }
    }, [_c('v-list-tile-avatar', [_c('span', {
      staticClass: "status"
    }, [_c('span', {
      class: _vm.enrollment(index).enrollmentName
    }), _c('br')])]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n                  " + _vm._s(item.trialName) + "\n                ")]), _vm._v(" "), _c('v-list-tile-sub-title', [_c('span', [_vm._v(_vm._s(_vm.enrollment(index).enrollmentName))]), _c('span', [_vm._v(" - " + _vm._s(_vm.locationsz(index).locationName))])])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "light": "",
        "flat": "",
        "icon": "",
        "right": "",
        "ripple": "",
        "to": '/trials/' + item.trialId
      }
    }, [_c('v-icon', {
      attrs: {
        "color": item.active ? 'grey' : 'grey'
      }
    }, [_vm._v("navigate_next")])], 1)], 1), _vm._v(" "), (_vm.userIsAuthenticated) ? _c('v-list-tile-action', {}, [_c('v-btn', {
      attrs: {
        "light": "",
        "icon": "",
        "right": "",
        "flat": "",
        "to": '/trials/' + item.trialId + '/edit'
      }
    }, [_c('v-icon', {
      staticClass: "text--lighten-2",
      attrs: {
        "small": "",
        "light": ""
      }
    }, [_vm._v("edit")])], 1)], 1) : _vm._e()], 1)], 1)], 1)
  })), _vm._v(" "), (_vm.userIsAuthenticated) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "mb-4": ""
    }
  }, [_c('v-card', {
    attrs: {
      "to": '/trial/new'
    }
  }, [(_vm.userIsAuthenticated) ? _c('v-card-text', {
    staticClass: "cyanLight editDialogsRow"
  }, [_vm._v("\n          Add Trial\n          "), _c('v-icon', {
    staticClass: "text-xs-right"
  }, [_vm._v("add")])], 1) : _vm._e()], 1)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 674 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "mt-0"
  }, [_c('v-layout', {
    staticClass: "mt-3",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center mb-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('h1', [_vm._v("Trials By Investigators")]), _vm._v(" "), (_vm.investigators == false) ? _c('v-alert', {
    attrs: {
      "color": "info",
      "icon": "new_releases",
      "value": true
    }
  }, [_vm._v("\n          There are no investigators.\n        ")]) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs10": "",
      "sm11": "",
      "md11": "",
      "align-content-space-between": "",
      "mt-4": "",
      "mb-0": "",
      "ml-0": "",
      "mr-0": ""
    }
  }, _vm._l((_vm.investigators), function(item) {
    return _c('v-card', {
      key: item.investigatorId,
      staticClass: "info",
      attrs: {
        "to": '/Trials/investigators/' + item.investigatorId
      }
    }, [_c('v-list', {
      staticClass: "listItems"
    }, [_c('v-list-tile', {
      staticClass: "pb-2 pt-2 pl-2"
    }, [_c('v-list-tile-avatar', [_c('person-icon', {
      staticClass: "icon",
      attrs: {
        "left": ""
      }
    })], 1), _vm._v(" "), _c('v-list-tile-content', {
      staticClass: "pl-2"
    }, [_c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(item.investigatorName)
      }
    })], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "light": "",
        "flat": "",
        "ripple": ""
      }
    }, [_c('v-icon', {
      attrs: {
        "color": item.active ? 'grey' : 'grey'
      }
    }, [_vm._v("navigate_next")])], 1)], 1)], 1)], 1)], 1)
  })), _vm._v(" "), (_vm.userIsAuthenticated) ? _c('v-flex', {
    attrs: {
      "xs2": "",
      "sm1": "",
      "md1": "",
      "ml-0": "",
      "mr-0": "",
      "mb-0": "",
      "mt-4": "",
      "justify-center": ""
    }
  }, _vm._l((_vm.investigators), function(item2, index2) {
    return _c('v-card', {
      key: item2.investigatorId,
      staticClass: "info"
    }, [_c('v-list', {
      staticClass: "listItems pa-0"
    }, [_c('v-list-tile', {
      staticClass: "pa-2"
    }, [_c('app-edit-investigator-dialog', {
      attrs: {
        "investigator": _vm.investigator(index2)
      }
    })], 1)], 1)], 1)
  })) : _vm._e(), _vm._v(" "), (_vm.userIsAuthenticated) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "mb-4": ""
    }
  }, [_c('v-card', {
    attrs: {
      "to": '/investigator/new'
    }
  }, [(_vm.userIsAuthenticated) ? _c('v-card-text', {
    staticClass: "cyanLight editDialogsRow"
  }, [_vm._v("\n          Add Investigator\n          "), _c('v-icon', {
    staticClass: "text-xs-right"
  }, [_vm._v("add")])], 1) : _vm._e()], 1)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 675 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "trialPage"
  }, [(_vm.loading) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": "",
      "sm10": "",
      "md10": ""
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary",
      "width": 7,
      "size": 70
    }
  })], 1)], 1) : _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center mb-4",
    attrs: {
      "xs12": "",
      "sm10": "",
      "offset-sm1": "",
      "justify-center": "",
      "align-center": ""
    }
  }, [_c('h1', {
    staticClass: "mt-3 mb-4 text-xs-center trialtitle"
  }, [_c('div', {
    staticClass: "status"
  }, [_c('span', {
    class: _vm.trial.trialEnrollment
  })]), _vm._v(" "), _c('div', {
    staticClass: "status"
  }, [_c('span', {
    class: _vm.enrollmentsss.enrollmentName
  })]), _vm._v(" "), _c('span', [_vm._v("Edit " + _vm._s(_vm.trial.trialName))]), _vm._v(" "), (_vm.userIsAuthenticated) ? [_c('app-edit-trial-details-dialog', {
    attrs: {
      "trial": _vm.trial
    }
  })] : _vm._e()], 2), _vm._v(" "), _c('v-expansion-panel', {
    attrs: {
      "expand": "",
      "ripple": ""
    }
  }, [_c('v-expansion-panel-content', {
    attrs: {
      "lazy": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("location_on")]), _vm._v("Location")], 1), _vm._v(" "), _c('v-card', [_vm._l((_vm.locationsss), function(item) {
    return (_vm.trial.trialLocations) ? _c('v-card-text', {
      key: item.locationID,
      staticClass: "white"
    }, [_vm._v("\n              " + _vm._s(item.locationName)), _c('br')]) : _vm._e()
  }), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.userIsAuthenticated) ? _c('v-card-text', {
    staticClass: "cyanLight editDialogsRow"
  }, [(_vm.userIsAuthenticated) ? [_c('v-spacer'), _vm._v(" "), _c('app-edit-trial-locations-dialog', {
    attrs: {
      "trial": _vm.trial
    }
  })] : _vm._e()], 2) : _vm._e()], 2)], 1)], 1), _vm._v(" "), _c('v-expansion-panel', {
    attrs: {
      "expand": ""
    }
  }, [_c('v-expansion-panel-content', {
    attrs: {
      "lazy": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("loyalty")]), _vm._v("Indications")], 1), _vm._v(" "), _c('v-card', [_vm._l((_vm.indicationsss), function(item, index) {
    return _c('v-card-text', {
      key: ("item-" + index),
      staticClass: "white"
    }, [_vm._v("\n              " + _vm._s(item.indicationName)), _c('br')])
  }), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.userIsAuthenticated) ? _c('v-card-text', {
    staticClass: "cyanLight editDialogsRow"
  }, [(_vm.userIsAuthenticated) ? [_c('v-spacer'), _vm._v(" "), _c('app-edit-trial-indications-dialog', {
    attrs: {
      "trial": _vm.trial
    }
  })] : _vm._e()], 2) : _vm._e()], 2)], 1)], 1), _vm._v(" "), _c('v-expansion-panel', {
    attrs: {
      "expand": ""
    }
  }, [_c('v-expansion-panel-content', {
    attrs: {
      "lazy": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("person_outline")]), _vm._v("Coordinators")], 1), _vm._v(" "), _c('v-card', [_c('v-card-text', {
    staticClass: "white"
  }, [_c('v-list', _vm._l((_vm.coordinatorsGetter), function(item, index) {
    return _c('v-list-tile', {
      key: ("item-" + index)
    }, [_c('v-list-tile-content', [_vm._v("\n                    " + _vm._s(item.coordinatorName) + "\n                  ")]), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "icon": "",
        "ripple": "",
        "href": 'tel:' + item.coordinatorPhone
      }
    }, [_c('v-icon', {
      attrs: {
        "color": item.active ? 'primary' : 'grey lighten-2'
      }
    }, [_vm._v("phone")])], 1)], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "icon": "",
        "ripple": "",
        "href": 'sms:' + item.coordinatorPhone
      }
    }, [_c('v-icon', {
      attrs: {
        "color": item.active ? 'primary' : 'grey lighten-2'
      }
    }, [_vm._v("textsms")])], 1)], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "icon": "",
        "ripple": "",
        "href": 'mailto:' + item.coordinatorEmail
      }
    }, [_c('v-icon', {
      attrs: {
        "color": item.active ? 'primary' : 'grey lighten-2'
      }
    }, [_vm._v("email")])], 1)], 1)], 1)
  }))], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.userIsAuthenticated) ? _c('v-card-text', {
    staticClass: "cyanLight editDialogsRow"
  }, [(_vm.userIsAuthenticated) ? [_c('v-spacer'), _vm._v(" "), _c('app-edit-trial-coordinators-dialog', {
    attrs: {
      "trial": _vm.trial
    }
  })] : _vm._e()], 2) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-expansion-panel', {
    attrs: {
      "expand": ""
    }
  }, [_c('v-expansion-panel-content', {
    attrs: {
      "lazy": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("person_outline")]), _vm._v("Investigators")], 1), _vm._v(" "), _c('v-card', [_c('v-card-text', {
    staticClass: "white"
  }, [_c('v-list', _vm._l((_vm.investigatorsGetter), function(item, index) {
    return _c('v-list-tile', {
      key: ("item-" + index)
    }, [_c('v-list-tile-content', [_vm._v("\n                    " + _vm._s(item.investigatorName) + "\n                  ")]), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "icon": "",
        "ripple": "",
        "href": 'tel:' + item.investigatorPhone
      }
    }, [_c('v-icon', {
      attrs: {
        "color": item.active ? 'primary' : 'grey lighten-2'
      }
    }, [_vm._v("phone")])], 1)], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "icon": "",
        "ripple": "",
        "href": 'sms:' + item.investigatorPhone
      }
    }, [_c('v-icon', {
      attrs: {
        "color": item.active ? 'primary' : 'grey lighten-2'
      }
    }, [_vm._v("textsms")])], 1)], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "icon": "",
        "ripple": "",
        "href": 'mailto:' + item.investigatorEmail
      }
    }, [_c('v-icon', {
      attrs: {
        "color": item.active ? 'primary' : 'grey lighten-2'
      }
    }, [_vm._v("email")])], 1)], 1)], 1)
  }))], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.userIsAuthenticated) ? _c('v-card-text', {
    staticClass: "cyanLight editDialogsRow"
  }, [(_vm.userIsAuthenticated) ? [_c('v-spacer'), _vm._v(" "), _c('app-edit-trial-investigators-dialog', {
    attrs: {
      "trial": _vm.trial
    }
  })] : _vm._e()], 2) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-expansion-panel', {
    attrs: {
      "expand": ""
    }
  }, [_c('v-expansion-panel-content', {
    attrs: {
      "lazy": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("description")]), _vm._v("Description")], 1), _vm._v(" "), _c('v-card', [_c('v-card-text', {
    staticClass: "white"
  }, [_vm._v("\n              " + _vm._s(_vm.trial.trialDescription)), _c('br')]), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.userIsAuthenticated) ? _c('v-card-text', {
    staticClass: "cyanLight editDialogsRow"
  }, [(_vm.userIsAuthenticated) ? [_c('v-spacer'), _vm._v(" "), _c('app-edit-trial-details-dialog', {
    attrs: {
      "trial": _vm.trial
    }
  })] : _vm._e()], 2) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-expansion-panel', {
    attrs: {
      "expand": ""
    }
  }, [_c('v-expansion-panel-content', {
    attrs: {
      "lazy": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("location_on")]), _vm._v("Address")], 1), _vm._v(" "), _c('v-card', [_vm._l((_vm.locationsss), function(item) {
    return _c('v-card-text', {
      key: item.locationID,
      staticClass: "white"
    }, [_c('strong', [_vm._v(_vm._s(item.locationName))]), _c('br'), _vm._v("\n              " + _vm._s(item.locationStreetAddress)), _c('br'), _vm._v("\n              " + _vm._s(item.locationCity) + ", " + _vm._s(item.locationState) + " " + _vm._s(item.locationZipcode) + "\n            ")])
  }), _vm._v(" "), _c('v-divider')], 2)], 1)], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mt-4 alt--text text--darken-3",
    attrs: {
      "depressed": "",
      "color": "alt lighten-5",
      "dark": "",
      "href": _vm.trial.trialLink,
      "target": "_blank"
    }
  }, [_vm._v("ClinicalTrials.gov")]), _vm._v(" "), _c('v-btn', {
    staticClass: "mt-4 red darken-3",
    attrs: {
      "dark": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.onDeleteTrial(_vm.trial)
      }
    }
  }, [_c('v-icon', {
    staticClass: "text--lighten-1",
    attrs: {
      "small": "",
      "dark": ""
    }
  }, [_vm._v("delete")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 676 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "width": "350px",
      "persistent": ""
    },
    model: {
      value: (_vm.editDialog),
      callback: function($$v) {
        _vm.editDialog = $$v
      },
      expression: "editDialog"
    }
  }, [_c('v-btn', {
    staticClass: "orange darken-3",
    attrs: {
      "slot": "activator",
      "dark": "",
      "flat": ""
    },
    slot: "activator"
  }, [_c('v-icon', {
    staticClass: "text--lighten-1",
    attrs: {
      "small": "",
      "dark": ""
    }
  }, [_vm._v("edit")])], 1), _vm._v(" "), _c('v-card', [_c('v-container', {
    staticClass: "mt-0"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "mb-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card-title', {
    staticClass: "justify-center"
  }, [_c('h2', [_vm._v("Edit Alert")])])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_vm._l((_vm.editedAlerts), function(item) {
    return _c('v-flex', {
      key: item.objectName,
      attrs: {
        "xs12": ""
      }
    }, [_vm._v("\n          " + _vm._s(item.name) + "\n        ")])
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card-text', [_c('v-text-field', {
    attrs: {
      "name": "editedAlertsName",
      "label": "Alert",
      "multi-line": "",
      "id": "editedAlertsName"
    },
    model: {
      value: (_vm.editedAlertsName),
      callback: function($$v) {
        _vm.editedAlertsName = $$v
      },
      expression: "editedAlertsName"
    }
  })], 1)], 1)], 2), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card-actions', {
    staticClass: "justify-center"
  }, [_c('v-btn', {
    staticClass: "grey lighten-1 white--text",
    attrs: {
      "depressed": ""
    },
    on: {
      "click": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    staticClass: "white--text cyan ",
    attrs: {
      "depressed": ""
    },
    on: {
      "click": _vm.onSaveChanges
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 677 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', [(_vm.error) ? _c('v-layout', {
    attrs: {
      "row": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('app-alert', {
    attrs: {
      "text": _vm.error.message
    },
    on: {
      "dismissed": _vm.onDismissed
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-card', [_c('v-card-text', [_c('v-container', [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSignup($event)
      }
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "email",
      "label": "Mail",
      "id": "email",
      "type": "email",
      "required": ""
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "password",
      "label": "Password",
      "id": "password",
      "type": "password",
      "required": ""
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "confirmPassword",
      "label": "Confirm Password",
      "id": "confirmPassword",
      "type": "password",
      "rules": [_vm.comparePasswords]
    },
    model: {
      value: (_vm.confirmPassword),
      callback: function($$v) {
        _vm.confirmPassword = $$v
      },
      expression: "confirmPassword"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "type": "submit",
      "disabled": _vm.loading,
      "loading": _vm.loading
    }
  }, [_vm._v("\n                    Sign Up\n                    "), _c('span', {
    staticClass: "custom-loader",
    attrs: {
      "slot": "loader"
    },
    slot: "loader"
  }, [_c('v-icon', {
    attrs: {
      "light": ""
    }
  }, [_vm._v("cached")])], 1)])], 1)], 1)], 1)])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 678 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("The User Page")])])
}]}

/***/ }),
/* 679 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "mt-0"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs10": ""
    }
  }, [(_vm.loadedNotice) ? _c('v-alert', {
    attrs: {
      "type": "warning",
      "dismissible": "",
      "timeout": _vm.timeout
    },
    model: {
      value: (_vm.alert),
      callback: function($$v) {
        _vm.alert = $$v
      },
      expression: "alert"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.loadedNotice.noticeName) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('img', {
    staticClass: "logo",
    attrs: {
      "src": "static/img/VIPTrials_Logo_sized.png"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-4",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm8": "",
      "md6": ""
    }
  }, _vm._l((_vm.items), function(item) {
    return _c('v-card', {
      key: item.title,
      staticClass: "homeInfo",
      attrs: {
        "to": item.link
      }
    }, [_c('v-list', {
      staticClass: "listItems pa-0"
    }, [_c('v-list-tile', {
      staticClass: "pb-2 pt-2 pl-2"
    }, [_c('v-list-tile-avatar', [_c('v-icon', {
      attrs: {
        "left": ""
      }
    }, [_vm._v(_vm._s(item.icon))])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(item.title)
      }
    })], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-icon', {
      attrs: {
        "color": item.active ? 'grey' : 'grey'
      }
    }, [_vm._v("navigate_next")])], 1)], 1)], 1), _vm._v(" "), _c('v-divider')], 1)
  }))], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": "",
      "sm8": "",
      "md6": ""
    }
  }, [(_vm.loading) ? _c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary",
      "width": 7,
      "size": 70
    }
  }) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 680 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    staticClass: "editDialogsRow",
    attrs: {
      "width": "350px",
      "persistent": ""
    },
    model: {
      value: (_vm.editDialog),
      callback: function($$v) {
        _vm.editDialog = $$v
      },
      expression: "editDialog"
    }
  }, [_c('v-card-text', {
    staticClass: "pa-0",
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_vm._v("\n    Add Coordinator\n    "), _c('v-icon', {
    staticClass: "text-xs-right"
  }, [_vm._v("add")])], 1), _vm._v(" "), _c('v-card', [_c('v-container', [_c('v-layout', {
    attrs: {
      "justify-end": "",
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "mb-2",
    attrs: {
      "xs1": ""
    }
  }, [_c('v-icon', {
    staticClass: "primary--text text--lighten-1",
    attrs: {
      "depressed": ""
    },
    on: {
      "click": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_vm._v("close")])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "mb-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card-title', {
    staticClass: "text-xs-center justify-center"
  }, [_c('h2', [_vm._v("Edit " + _vm._s(_vm.trial.trialName) + " Coordinators")])])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_vm._l((_vm.editedCoordinators), function(item) {
    return _c('v-flex', {
      key: item.objectName,
      attrs: {
        "xs12": ""
      }
    }, [_vm._v("\n          " + _vm._s(item.name) + "\n        ")])
  }), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card-text', [_c('h3', [_vm._v("Current Coordinators:")]), _vm._v(" "), _vm._l((_vm.coordinatorsGetter), function(item) {
    return _c('div', {
      key: item.coordinatorID
    }, [_vm._v("\n              " + _vm._s(item.coordinatorName) + "\n            ")])
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "name": "trial.trialCoordinators",
      "label": "Add Trial Coordinators",
      "items": _vm.coordinators,
      "item-value": "coordinatorId",
      "item-text": "coordinatorName",
      "id": "trial.trialCoordinators",
      "multiple": "",
      "max-height": "400",
      "hint": "Pick your coordinators",
      "persistent-hint": ""
    },
    model: {
      value: (_vm.editedCoordinators),
      callback: function($$v) {
        _vm.editedCoordinators = $$v
      },
      expression: "editedCoordinators"
    }
  })], 2), _vm._v(" "), _c('v-btn', {
    staticClass: "grey white--text",
    attrs: {
      "depressed": "",
      "to": "/coordinator/new"
    }
  }, [_vm._v("Create New Coordinator")])], 1)], 2), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card-actions', {
    staticClass: "justify-center"
  }, [_c('v-btn', {
    staticClass: "grey lighten-1 white--text",
    attrs: {
      "depressed": ""
    },
    on: {
      "click": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    staticClass: "white--text primary ",
    attrs: {
      "depressed": ""
    },
    on: {
      "click": _vm.onSaveChanges
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 681 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    staticClass: "editDialogsRow",
    attrs: {
      "width": "350px",
      "persistent": ""
    },
    model: {
      value: (_vm.editDialog),
      callback: function($$v) {
        _vm.editDialog = $$v
      },
      expression: "editDialog"
    }
  }, [_c('v-card-text', {
    staticClass: "pa-0",
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_vm._v("\n    Add Indication\n    "), _c('v-icon', {
    staticClass: "text-xs-right"
  }, [_vm._v("add")])], 1), _vm._v(" "), _c('v-card', [_c('v-container', [_c('v-layout', {
    attrs: {
      "justify-end": "",
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "mb-2",
    attrs: {
      "xs1": ""
    }
  }, [_c('v-icon', {
    staticClass: "primary--text text--lighten-1",
    attrs: {
      "depressed": ""
    },
    on: {
      "click": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_vm._v("close")])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "mb-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card-title', {
    staticClass: "text-xs-center justify-center"
  }, [_c('h2', [_vm._v("Edit " + _vm._s(_vm.trial.trialName) + " Indications")])])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_vm._l((_vm.editedIndications), function(item) {
    return _c('v-flex', {
      key: item.objectName,
      attrs: {
        "xs12": ""
      }
    }, [_vm._v("\n          " + _vm._s(item.name) + "\n        ")])
  }), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card-text', [_c('h3', [_vm._v("Current Indications:")]), _vm._v(" "), _vm._l((_vm.indicationsss), function(item) {
    return _c('div', {
      key: item.indicationID
    }, [_vm._v("\n              " + _vm._s(item.indicationName) + "\n            ")])
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "name": "trial.trialIndications",
      "label": "Add Trial Indications",
      "items": _vm.indications,
      "item-value": "indicationId",
      "item-text": "indicationName",
      "id": "trial.trialIndications",
      "multiple": "",
      "max-height": "400",
      "hint": "Pick your indications",
      "persistent-hint": ""
    },
    model: {
      value: (_vm.editedIndications),
      callback: function($$v) {
        _vm.editedIndications = $$v
      },
      expression: "editedIndications"
    }
  })], 2), _vm._v(" "), _c('v-btn', {
    staticClass: "grey white--text",
    attrs: {
      "depressed": "",
      "to": "/indication/new"
    }
  }, [_vm._v("Create New Indication")])], 1)], 2), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card-actions', {
    staticClass: "justify-center"
  }, [_c('v-btn', {
    staticClass: "grey lighten-1 white--text",
    attrs: {
      "depressed": ""
    },
    on: {
      "click": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    staticClass: "white--text primary ",
    attrs: {
      "depressed": ""
    },
    on: {
      "click": _vm.onSaveChanges
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 682 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "mt-0"
  }, [_c('v-layout', {
    staticClass: "mt-3",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('h1', [_vm._v("Trials By " + _vm._s(_vm.investigators))]), _vm._v(" "), (_vm.trials == false) ? _c('v-alert', {
    attrs: {
      "color": "info",
      "icon": "new_releases",
      "value": true
    }
  }, [_vm._v("\n          There are no trials for the " + _vm._s(_vm.investigators) + " investigator.\n        ")]) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "align-content-space-between": "",
      "mt-4": "",
      "mb-0": "",
      "ml-0": "",
      "mr-0": ""
    }
  }, _vm._l((_vm.trials), function(item, index) {
    return _c('v-card', {
      key: item.trialId,
      staticClass: "info",
      attrs: {
        "to": '/trials/' + item.trialId
      }
    }, [_c('v-list', {
      staticClass: "listItems"
    }, [_c('v-list-tile', {
      staticClass: "pl-2",
      attrs: {
        "avatar": ""
      }
    }, [_c('v-list-tile-avatar', [_c('span', {
      staticClass: "status"
    }, [_c('span', {
      class: _vm.enrollment(index).enrollmentName
    }), _c('br')])]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n                  " + _vm._s(item.trialName) + "\n                ")]), _vm._v(" "), _c('v-list-tile-sub-title', [_c('span', [_vm._v(_vm._s(_vm.enrollment(index).enrollmentName))]), _c('span', [_vm._v(" - " + _vm._s(_vm.locations(index).locationName))])])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "light": "",
        "flat": "",
        "icon": "",
        "right": "",
        "ripple": "",
        "to": '/trials/' + item.trialId
      }
    }, [_c('right-icon', {
      staticClass: "icon",
      attrs: {
        "small": "",
        "color": item.active ? 'primary' : 'grey'
      }
    })], 1)], 1), _vm._v(" "), (_vm.userIsAuthenticated) ? _c('v-list-tile-action', {}, [_c('v-btn', {
      attrs: {
        "light": "",
        "icon": "",
        "right": "",
        "flat": "",
        "to": '/trials/' + item.trialId + '/edit'
      }
    }, [_c('v-icon', {
      staticClass: "text--lighten-2",
      attrs: {
        "small": "",
        "light": ""
      }
    }, [_vm._v("edit")])], 1)], 1) : _vm._e()], 1)], 1)], 1)
  })), _vm._v(" "), (_vm.userIsAuthenticated) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "mb-4": ""
    }
  }, [_c('v-card', {
    attrs: {
      "to": '/trial/new'
    }
  }, [(_vm.userIsAuthenticated) ? _c('v-card-text', {
    staticClass: "cyanLight editDialogsRow"
  }, [_vm._v("\n          Add Trial\n          "), _c('v-icon', {
    staticClass: "text-xs-right"
  }, [_vm._v("add")])], 1) : _vm._e()], 1)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 683 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    staticClass: "signIn",
    attrs: {
      "width": "350px",
      "persistent": ""
    },
    model: {
      value: (_vm.editDialog),
      callback: function($$v) {
        _vm.editDialog = $$v
      },
      expression: "editDialog"
    }
  }, [_c('v-list-tile', {
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("lock_open")])], 1), _vm._v(" "), _c('v-list-tile-content', [_vm._v("\n        Sign In\n      ")])], 1), _vm._v(" "), _c('v-card', [_c('v-container', [_c('v-layout', {
    attrs: {
      "justify-end": "",
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "mb-2",
    attrs: {
      "xs1": ""
    }
  }, [_c('v-icon', {
    staticClass: "grey--text",
    attrs: {
      "depressed": ""
    },
    on: {
      "click": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center mb-4",
    attrs: {
      "xs12": ""
    }
  }, [_c('img', {
    attrs: {
      "width": "224",
      "src": "/static/img/VIPTrials_Logo_sized.png"
    }
  })])], 1), _vm._v(" "), (_vm.error) ? _c('v-layout', {
    attrs: {
      "row": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('app-alert', {
    attrs: {
      "text": _vm.error.message
    },
    on: {
      "dismissed": _vm.onDismissed
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('p', {
    staticClass: "grey--text"
  }, [_vm._v("Administrator Login")]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSignin($event)
      }
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "email",
      "label": "Email Address",
      "id": "email",
      "type": "email",
      "required": ""
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "password",
      "label": "Password",
      "id": "password",
      "type": "password",
      "required": ""
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    staticClass: "grey lighten-1 white--text",
    attrs: {
      "xs4": "",
      "depressed": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_vm._v("\n                  Cancel\n                ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "primary white--text",
    attrs: {
      "xs4": "",
      "type": "submit",
      "disabled": _vm.loading,
      "loading": _vm.loading,
      "depressed": ""
    }
  }, [_vm._v("\n                  Log In\n                  "), _c('span', {
    staticClass: "custom-loader",
    attrs: {
      "slot": "loader"
    },
    slot: "loader"
  }, [_c('v-icon', {
    attrs: {
      "light": ""
    }
  }, [_vm._v("cached")])], 1)])], 1)], 1)], 1)])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 684 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "mt-0"
  }, [_c('v-layout', {
    staticClass: "mt-3",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center mb-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('h1', [_vm._v("All Indications")]), _vm._v(" "), (_vm.indications == false) ? _c('v-alert', {
    attrs: {
      "color": "info",
      "icon": "new_releases",
      "value": true
    }
  }, [_vm._v("\n          There are no indications.\n        ")]) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs10": "",
      "sm11": "",
      "md11": "",
      "align-content-space-between": "",
      "mt-4": "",
      "mb-0": "",
      "ml-0": "",
      "mr-0": ""
    }
  }, _vm._l((_vm.indications), function(item, index) {
    return _c('v-card', {
      key: item.indicationId,
      staticClass: "info",
      attrs: {
        "to": '/indications/' + item.indicationId
      }
    }, [_c('v-list', {
      staticClass: "listItems"
    }, [_c('v-list-tile', {
      staticClass: "pb-2 pt-2 pl-2"
    }, [_c('v-list-tile-avatar', [_c('v-icon', {
      attrs: {
        "left": ""
      }
    }, [_vm._v("person_pin")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(item.indicationName)
      }
    })], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "light": "",
        "flat": "",
        "ripple": ""
      }
    }, [_c('v-icon', {
      attrs: {
        "color": item.active ? 'primary' : 'grey'
      }
    }, [_vm._v("navigate_next")])], 1)], 1)], 1)], 1)], 1)
  })), _vm._v(" "), (_vm.userIsAuthenticated) ? _c('v-flex', {
    attrs: {
      "xs2": "",
      "sm1": "",
      "md1": "",
      "ml-0": "",
      "mr-0": "",
      "mb-0": "",
      "mt-4": "",
      "justify-center": ""
    }
  }, _vm._l((_vm.indications), function(item2, index2) {
    return _c('v-card', {
      key: item2.indicationId,
      staticClass: "info"
    }, [_c('v-list', {
      staticClass: "listItems pa-0"
    }, [_c('v-list-tile', {
      staticClass: "pa-2"
    }, [_c('app-edit-indication-dialog', {
      attrs: {
        "indication": _vm.indication(index2)
      }
    })], 1)], 1)], 1)
  })) : _vm._e(), _vm._v(" "), (_vm.userIsAuthenticated) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "mb-4": ""
    }
  }, [_c('v-card', {
    attrs: {
      "to": '/indication/new'
    }
  }, [(_vm.userIsAuthenticated) ? _c('v-card-text', {
    staticClass: "cyanLight editDialogsRow"
  }, [_vm._v("\n          Add Indication\n          "), _c('v-icon', {
    staticClass: "text-xs-right"
  }, [_vm._v("add")])], 1) : _vm._e()], 1)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 685 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "mt-0"
  }, [_c('v-layout', {
    staticClass: "mt-3",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center mb-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('h1', [_vm._v("All Locations")]), _vm._v(" "), (_vm.locations == false) ? _c('v-alert', {
    attrs: {
      "color": "info",
      "icon": "new_releases",
      "value": true
    }
  }, [_vm._v("\n          There are no locations.\n        ")]) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs10": "",
      "sm11": "",
      "md11": "",
      "align-content-space-between": "",
      "mt-4": "",
      "mb-0": "",
      "ml-0": "",
      "mr-0": ""
    }
  }, _vm._l((_vm.locations), function(item, index) {
    return _c('v-card', {
      key: item.locationId,
      staticClass: "info",
      attrs: {
        "to": '/locations/' + item.locationId
      }
    }, [_c('v-list', {
      staticClass: "listItems"
    }, [_c('v-list-tile', {
      staticClass: "pb-2 pt-2 pl-2"
    }, [_c('v-list-tile-avatar', [_c('v-icon', {
      attrs: {
        "left": ""
      }
    }, [_vm._v("location_on")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(item.locationName)
      }
    })], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "light": "",
        "flat": "",
        "ripple": ""
      }
    }, [_c('v-icon', {
      attrs: {
        "color": item.active ? 'grey' : 'grey'
      }
    }, [_vm._v("navigate_next")])], 1)], 1)], 1)], 1)], 1)
  })), _vm._v(" "), (_vm.userIsAuthenticated) ? _c('v-flex', {
    attrs: {
      "xs2": "",
      "sm1": "",
      "md1": "",
      "ml-0": "",
      "mr-0": "",
      "mb-0": "",
      "mt-4": "",
      "justify-center": ""
    }
  }, _vm._l((_vm.locations), function(item2, index2) {
    return _c('v-card', {
      key: item2.locationId,
      staticClass: "info"
    }, [_c('v-list', {
      staticClass: "listItems pa-0"
    }, [_c('v-list-tile', {
      staticClass: "pa-2"
    }, [_c('app-edit-location-dialog', {
      attrs: {
        "location": _vm.location(index2)
      }
    })], 1)], 1)], 1)
  })) : _vm._e(), _vm._v(" "), (_vm.userIsAuthenticated) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "mb-4": ""
    }
  }, [_c('v-card', {
    attrs: {
      "to": '/location/new'
    }
  }, [(_vm.userIsAuthenticated) ? _c('v-card-text', {
    staticClass: "cyanLight editDialogsRow"
  }, [_vm._v("\n          Add Location\n          "), _c('v-icon', {
    staticClass: "text-xs-right"
  }, [_vm._v("add")])], 1) : _vm._e()], 1)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 686 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "mt-0"
  }, [_c('v-layout', {
    staticClass: "mt-3",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center mb-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('h1', [_vm._v("All Trials")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "align-content-space-between": "",
      "mt-4": "",
      "mb-0": "",
      "ml-0": "",
      "mr-0": ""
    }
  }, _vm._l((_vm.trials), function(item, index) {
    return _c('v-card', {
      key: item.trialId,
      staticClass: "info",
      attrs: {
        "to": '/trials/' + item.trialId
      }
    }, [_c('v-list', {
      staticClass: "listItems"
    }, [_c('v-list-tile', {
      staticClass: "pl-2",
      attrs: {
        "avatar": ""
      }
    }, [_c('v-list-tile-avatar', [_c('span', {
      staticClass: "status"
    }, [_c('span', {
      class: _vm.enrollment(index).enrollmentName
    }), _c('br')])]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n                  " + _vm._s(item.trialName) + "\n                ")]), _vm._v(" "), _c('v-list-tile-sub-title', [_c('span', [_vm._v(_vm._s(_vm.enrollment(index).enrollmentName))]), _c('span', [_vm._v(" - " + _vm._s(_vm.locations(index).locationName))])])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "light": "",
        "flat": "",
        "icon": "",
        "right": "",
        "ripple": "",
        "to": '/trials/' + item.trialId
      }
    }, [_c('v-icon', {
      attrs: {
        "color": item.active ? 'grey' : 'grey'
      }
    }, [_vm._v("navigate_next")])], 1)], 1), _vm._v(" "), (_vm.userIsAuthenticated) ? _c('v-list-tile-action', {}, [_c('v-btn', {
      attrs: {
        "light": "",
        "icon": "",
        "right": "",
        "flat": "",
        "to": '/trials/' + item.trialId + '/edit'
      }
    }, [_c('v-icon', {
      staticClass: "text--lighten-2",
      attrs: {
        "small": "",
        "light": ""
      }
    }, [_vm._v("edit")])], 1)], 1) : _vm._e()], 1)], 1)], 1)
  })), _vm._v(" "), (_vm.userIsAuthenticated) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "mb-4": ""
    }
  }, [_c('v-card', {
    attrs: {
      "to": '/trial/new'
    }
  }, [(_vm.userIsAuthenticated) ? _c('v-card-text', {
    staticClass: "primaryLight editDialogsRow"
  }, [_vm._v("\n          Add Trial\n          "), _c('v-icon', {
    staticClass: "text-xs-right"
  }, [_vm._v("add")])], 1) : _vm._e()], 1)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 687 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "mt-0"
  }, [(_vm.loading) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": "",
      "sm8": "",
      "md6": ""
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary",
      "width": 7,
      "size": 70
    }
  })], 1)], 1) : _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": "",
      "sm6": "",
      "offset-sm3": ""
    }
  }, [_c('h1', {
    staticClass: "mt-3 text-xs-center"
  }, [_vm._v(_vm._s(_vm.coordinator.coordinatorName))]), _vm._v(" "), _c('v-card', [_c('v-card-text', [_vm._v("\n\t\t\t\t\t\tPhone Number: " + _vm._s(_vm.coordinator.coordinatorPhone) + "\n\t\t\t\t\t")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n\t\t\t\t\t\tEmail Address: " + _vm._s(_vm.coordinator.coordinatorEmail) + "\n\t\t\t\t\t")])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.userIsCreator) ? [_c('v-spacer'), _vm._v(" "), _c('app-edit-coordinator-dialog', {
    attrs: {
      "coordinator": _vm.coordinator
    }
  })] : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "red darken-3",
    attrs: {
      "dark": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.onDeleteCoordinator(_vm.coordinator)
      }
    }
  }, [_c('v-icon', {
    staticClass: "text--lighten-1",
    attrs: {
      "small": "",
      "dark": ""
    }
  }, [_vm._v("delete")])], 1)], 2)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 688 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "mt-0"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "offset-sm3": ""
    }
  }, [_c('h4', [_vm._v("Create a new Location")])])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "offset-sm3": ""
    }
  }, [_c('form', {
    attrs: {
      "action": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onCreateLocation($event)
      }
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "locationName",
      "label": "Name",
      "id": "locationName",
      "single-line": "",
      "required": ""
    },
    model: {
      value: (_vm.locationName),
      callback: function($$v) {
        _vm.locationName = $$v
      },
      expression: "locationName"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "name": "locationStreetAddress",
      "label": "Stree Address",
      "id": "locationStreetAddress",
      "single-line": "",
      "required": ""
    },
    model: {
      value: (_vm.locationStreetAddress),
      callback: function($$v) {
        _vm.locationStreetAddress = $$v
      },
      expression: "locationStreetAddress"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "name": "locationCity",
      "label": "City",
      "id": "locationCity",
      "single-line": "",
      "required": ""
    },
    model: {
      value: (_vm.locationCity),
      callback: function($$v) {
        _vm.locationCity = $$v
      },
      expression: "locationCity"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "name": "locationState",
      "label": "State",
      "id": "locationState",
      "single-line": "",
      "required": ""
    },
    model: {
      value: (_vm.locationState),
      callback: function($$v) {
        _vm.locationState = $$v
      },
      expression: "locationState"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "name": "locationZipcode",
      "label": "Zipcode",
      "id": "locationZipcode",
      "single-line": "",
      "required": ""
    },
    model: {
      value: (_vm.locationZipcode),
      callback: function($$v) {
        _vm.locationZipcode = $$v
      },
      expression: "locationZipcode"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-btn', {
    staticClass: "primary",
    attrs: {
      "disabled": !_vm.formIsValid,
      "type": "submit"
    }
  }, [_vm._v("\n              Create Location\n            ")])], 1)], 1)], 1)])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 689 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "light": ""
    }
  }, [_c('v-navigation-drawer', {
    staticClass: "pb-0",
    attrs: {
      "fixed": "",
      "app": "",
      "right": "",
      "temporary": "",
      "floating": "",
      "light": ""
    },
    model: {
      value: (_vm.sideNav),
      callback: function($$v) {
        _vm.sideNav = $$v
      },
      expression: "sideNav"
    }
  }, [_c('v-container', {
    attrs: {
      "grid-list-xl": "",
      "text-xs-center": "",
      "fill-height": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-content-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-list', [_vm._l((_vm.menuItems), function(item) {
    return _c('v-list-tile', {
      key: item.title,
      attrs: {
        "router": "",
        "to": item.link
      }
    }, [_c('v-list-tile-action', [_c('v-icon', {
      attrs: {
        "right": ""
      }
    }, [_vm._v(_vm._s(item.icon))])], 1), _vm._v(" "), _c('v-list-tile-content', [_vm._v("\n                    " + _vm._s(item.title) + "\n                  ")])], 1)
  }), _vm._v(" "), (_vm.userIsAuthenticate) ? _c('v-list-tile', {
    staticClass: "trialButton primary",
    attrs: {
      "router": "",
      "to": '/trial/new',
      "color": "primary",
      "dark": ""
    }
  }, [_c('v-list-tile-action', {
    staticClass: "white--text"
  }, [_c('v-icon', {
    staticClass: "white--text",
    attrs: {
      "left": ""
    }
  }, [_vm._v("add")])], 1), _vm._v(" "), _c('v-list-tile-content', {
    staticClass: "white--text"
  }, [_vm._v("\n                      New Trial\n                  ")])], 1) : _vm._e(), _vm._v(" "), (_vm.userIsAuthenticate) ? _c('v-list-tile', {
    attrs: {
      "router": "",
      "to": '/alert/new',
      "flat": ""
    }
  }, [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("add")])], 1), _vm._v(" "), _c('v-list-tile-content', [_vm._v("\n                    Update Alert\n                  ")])], 1) : _vm._e(), _vm._v(" "), (!_vm.userIsAuthenticate) ? [_c('app-edit-menu-login-dialog')] : _vm._e()], 2)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-list', [(_vm.userIsAuthenticate) ? _c('v-list-tile', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": _vm.onLogout
    }
  }, [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("exit_to_app")])], 1), _vm._v(" "), _c('v-list-tile-content', [_vm._v("\n                    Log Out\n                  ")])], 1) : _vm._e()], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-toolbar', {
    staticClass: "primary",
    attrs: {
      "fixed": "",
      "dark": ""
    }
  }, [_c('div', {
    staticStyle: {
      "width": "52px"
    },
    attrs: {
      "right": ""
    }
  }, [(!_vm.checkLocations) ? _c('a', {
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_c('v-icon', [_vm._v("keyboard_arrow_left")])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "justify-center",
    staticStyle: {
      "width": "100%",
      "text-align": "center"
    },
    attrs: {
      "center": ""
    }
  }, [_c('router-link', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "to": _vm.menuItems[0].link,
      "tag": "span"
    }
  }, [_c('v-icon', [_vm._v("home")])], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "right": ""
    }
  }, [_c('v-toolbar-side-icon', {
    staticClass: "hidden-xl-and-up mr-0",
    on: {
      "click": function($event) {
        _vm.sideNav = !_vm.sideNav
      }
    }
  })], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-toolbar-items', {
    attrs: {
      "right": ""
    }
  })], 1), _vm._v(" "), _c('main', {
    staticClass: "white"
  }, [_c('router-view', {
    staticClass: "white"
  })], 1), _vm._v(" "), _c('footer', [_c('v-container', {
    staticClass: "mt-0"
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center mb-4"
  }, [_c('span', {
    staticClass: "white--text"
  }, [_vm._v("Copyright 2021 VIP Trials, LLC.")])])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 690 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "mt-0"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "offset-sm3": ""
    }
  }, [_c('h4', [_vm._v("Create a new Coordinator")])])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "offset-sm3": ""
    }
  }, [_c('form', {
    attrs: {
      "action": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onCreateCoordinator($event)
      }
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "coordinatorName",
      "label": "Name",
      "id": "coordinatorName",
      "single-line": "",
      "required": ""
    },
    model: {
      value: (_vm.coordinatorName),
      callback: function($$v) {
        _vm.coordinatorName = $$v
      },
      expression: "coordinatorName"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "name": "coordinatorPhone",
      "label": "Phone Number",
      "id": "coordinatorPhone",
      "single-line": ""
    },
    model: {
      value: (_vm.coordinatorPhone),
      callback: function($$v) {
        _vm.coordinatorPhone = $$v
      },
      expression: "coordinatorPhone"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "name": "coordinatorEmail",
      "label": "Email Address",
      "id": "coordinatorEmail",
      "single-line": "",
      "required": ""
    },
    model: {
      value: (_vm.coordinatorEmail),
      callback: function($$v) {
        _vm.coordinatorEmail = $$v
      },
      expression: "coordinatorEmail"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-btn', {
    staticClass: "primary",
    attrs: {
      "disabled": !_vm.formIsValid,
      "type": "submit"
    }
  }, [_vm._v("\n              Create Coordinator\n            ")])], 1)], 1)], 1)])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 691 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    staticClass: "editDialogsRow",
    attrs: {
      "width": "350px",
      "persistent": ""
    },
    model: {
      value: (_vm.editDialog),
      callback: function($$v) {
        _vm.editDialog = $$v
      },
      expression: "editDialog"
    }
  }, [_c('v-card-text', {
    staticClass: "pa-0",
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_vm._v("\n    Add Location\n    "), _c('v-icon', {
    staticClass: "text-xs-right"
  }, [_vm._v("add")])], 1), _vm._v(" "), _c('v-card', [_c('v-container', [_c('v-layout', {
    attrs: {
      "justify-end": "",
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "mb-2",
    attrs: {
      "xs1": ""
    }
  }, [_c('v-icon', {
    staticClass: "primary--text text--lighten-1",
    attrs: {
      "depressed": ""
    },
    on: {
      "click": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_vm._v("close")])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "mb-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card-title', {
    staticClass: "text-xs-center justify-center"
  }, [_c('h2', [_vm._v("Edit " + _vm._s(_vm.trial.trialName) + " Locations")])])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_vm._l((_vm.editedLocations), function(item) {
    return _c('v-flex', {
      key: item.objectName,
      attrs: {
        "xs12": ""
      }
    }, [_vm._v("\n          " + _vm._s(item.name) + "\n        ")])
  }), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card-text', [_c('h3', [_vm._v("Current Locations:")]), _vm._v(" "), _vm._l((_vm.locationsGetter), function(item) {
    return _c('div', {
      key: item.locationID
    }, [_vm._v("\n              " + _vm._s(item.locationName) + "\n            ")])
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "name": "trial.trialLocations",
      "label": "Add Trial Locations",
      "items": _vm.locations,
      "item-value": "locationId",
      "item-text": "locationName",
      "id": "trial.trialLocations",
      "multiple": "",
      "max-height": "400",
      "hint": "Pick your locations",
      "persistent-hint": ""
    },
    model: {
      value: (_vm.editedLocations),
      callback: function($$v) {
        _vm.editedLocations = $$v
      },
      expression: "editedLocations"
    }
  })], 2), _vm._v(" "), _c('v-btn', {
    staticClass: "grey white--text",
    attrs: {
      "depressed": "",
      "to": "/location/new"
    }
  }, [_vm._v("Create New Location")])], 1)], 2), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card-actions', {
    staticClass: "justify-center"
  }, [_c('v-btn', {
    staticClass: "grey lighten-1 white--text",
    attrs: {
      "depressed": ""
    },
    on: {
      "click": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    staticClass: "white--text primary ",
    attrs: {
      "depressed": ""
    },
    on: {
      "click": _vm.onSaveChanges
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 692 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', [_c('v-layout', {
    staticClass: "mt-3",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center mb-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('h1', [_vm._v("Trials By Location")]), _vm._v(" "), (_vm.locations == false) ? _c('v-alert', {
    attrs: {
      "color": "info",
      "icon": "new_releases",
      "value": true
    }
  }, [_vm._v("\n          There are no locations.\n        ")]) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs10": "",
      "sm11": "",
      "md11": "",
      "align-content-space-between": "",
      "mt-4": "",
      "mb-0": "",
      "ml-0": "",
      "mr-0": ""
    }
  }, _vm._l((_vm.locations), function(item, index) {
    return _c('v-card', {
      key: item.locationId,
      staticClass: "info",
      attrs: {
        "to": '/Trials/locations/' + item.locationId
      }
    }, [_c('v-list', {
      staticClass: "listItems"
    }, [_c('v-list-tile', {
      staticClass: "pb-2 pt-2 pl-2"
    }, [_c('v-list-tile-avatar', [_c('map-icon', {
      staticClass: "icon",
      attrs: {
        "left": ""
      }
    })], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(item.locationName)
      }
    })], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "light": "",
        "flat": "",
        "ripple": ""
      }
    }, [_c('v-icon', {
      attrs: {
        "color": item.active ? 'grey' : 'grey'
      }
    }, [_vm._v("navigate_next")])], 1)], 1)], 1)], 1)], 1)
  })), _vm._v(" "), (_vm.userIsAuthenticated) ? _c('v-flex', {
    attrs: {
      "xs2": "",
      "sm1": "",
      "md1": "",
      "ml-0": "",
      "mr-0": "",
      "mb-0": "",
      "mt-4": "",
      "justify-center": ""
    }
  }, _vm._l((_vm.locations), function(item2, index2) {
    return _c('v-card', {
      key: item2.locationId,
      staticClass: "info"
    }, [_c('v-list', {
      staticClass: "listItems pa-0"
    }, [_c('v-list-tile', {
      staticClass: "pa-2"
    }, [_c('app-edit-location-dialog', {
      attrs: {
        "location": _vm.location(index2)
      }
    })], 1)], 1)], 1)
  })) : _vm._e(), _vm._v(" "), (_vm.userIsAuthenticated) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "mb-4": ""
    }
  }, [_c('v-card', {
    attrs: {
      "to": '/location/new'
    }
  }, [(_vm.userIsAuthenticated) ? _c('v-card-text', {
    staticClass: "cyanLight editDialogsRow"
  }, [_vm._v("\n          Add location\n          "), _c('v-icon', {
    staticClass: "text-xs-right"
  }, [_vm._v("add")])], 1) : _vm._e()], 1)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 693 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "mt-0"
  }, [_c('v-layout', {
    staticClass: "mt-3",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('h1', [_vm._v("Trials By " + _vm._s(_vm.coordinators))]), _vm._v(" "), (_vm.trials == false) ? _c('v-alert', {
    attrs: {
      "color": "info",
      "icon": "new_releases",
      "value": true
    }
  }, [_vm._v("\n          There are no trials for the " + _vm._s(_vm.coordinators) + " coordinator.\n        ")]) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "align-content-space-between": "",
      "mt-4": "",
      "mb-0": "",
      "ml-0": "",
      "mr-0": ""
    }
  }, _vm._l((_vm.trials), function(item, index) {
    return _c('v-card', {
      key: item.trialId,
      staticClass: "info",
      attrs: {
        "to": '/trials/' + item.trialId
      }
    }, [_c('v-list', {
      staticClass: "listItems"
    }, [_c('v-list-tile', {
      staticClass: "pl-2",
      attrs: {
        "avatar": ""
      }
    }, [_c('v-list-tile-avatar', [_c('span', {
      staticClass: "status"
    }, [_c('span', {
      class: _vm.enrollment(index).enrollmentName
    }), _c('br')])]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n                  " + _vm._s(item.trialName) + "\n                ")]), _vm._v(" "), _c('v-list-tile-sub-title', [_c('span', [_vm._v(_vm._s(_vm.enrollment(index).enrollmentName))]), _c('span', [_vm._v(" - " + _vm._s(_vm.locations(index).locationName))])])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "light": "",
        "flat": "",
        "icon": "",
        "right": "",
        "ripple": "",
        "to": '/trials/' + item.trialId
      }
    }, [_c('right-icon', {
      staticClass: "icon",
      attrs: {
        "small": "",
        "color": item.active ? 'primary' : 'grey'
      }
    })], 1)], 1), _vm._v(" "), (_vm.userIsAuthenticated) ? _c('v-list-tile-action', {}, [_c('v-btn', {
      attrs: {
        "light": "",
        "icon": "",
        "right": "",
        "flat": "",
        "to": '/trials/' + item.trialId + '/edit'
      }
    }, [_c('v-icon', {
      staticClass: "text--lighten-2",
      attrs: {
        "small": "",
        "light": ""
      }
    }, [_vm._v("edit")])], 1)], 1) : _vm._e()], 1)], 1)], 1)
  })), _vm._v(" "), (_vm.userIsAuthenticated) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "mb-4": ""
    }
  }, [_c('v-card', {
    attrs: {
      "to": '/trial/new'
    }
  }, [(_vm.userIsAuthenticated) ? _c('v-card-text', {
    staticClass: "cyanLight editDialogsRow"
  }, [_vm._v("\n          Add Trial\n          "), _c('v-icon', {
    staticClass: "text-xs-right"
  }, [_vm._v("add")])], 1) : _vm._e()], 1)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 694 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "mt-0"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "offset-sm3": ""
    }
  }, [_c('h4', [_vm._v("Create a new Indication")])])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "offset-sm3": ""
    }
  }, [_c('form', {
    attrs: {
      "action": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onCreateIndication($event)
      }
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "indicationName",
      "label": "Name",
      "id": "indicationName",
      "single-line": "",
      "required": ""
    },
    model: {
      value: (_vm.indicationName),
      callback: function($$v) {
        _vm.indicationName = $$v
      },
      expression: "indicationName"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-btn', {
    staticClass: "primary",
    attrs: {
      "disabled": !_vm.formIsValid,
      "type": "submit"
    }
  }, [_vm._v("\n                Create Indication\n              ")])], 1)], 1)], 1)])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 695 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "mt-0"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "offset-sm3": ""
    }
  }, [_c('h4', [_vm._v("Update Alert")])])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm11": "",
      "md10": "",
      "offset-sm3": ""
    }
  }, [_c('form', {
    attrs: {
      "action": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onCreateAlert($event)
      }
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "alertName",
      "label": "Alert Text",
      "id": "alertName",
      "multi-line": ""
    },
    model: {
      value: (_vm.alertName),
      callback: function($$v) {
        _vm.alertName = $$v
      },
      expression: "alertName"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-btn', {
    staticClass: "primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n              Update Alert\n            ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    on: {
      "click": _vm.onDeleteAlert
    }
  }, [_vm._v("\n              Delete Alert\n            ")])], 1)], 1)], 1)])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 696 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', [_c('v-layout', {
    staticClass: "mt-3",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('h1', [_vm._v("Trials By " + _vm._s(_vm.enrollments))]), _vm._v(" "), (_vm.trials == false) ? _c('v-alert', {
    attrs: {
      "color": "info",
      "icon": "new_releases",
      "value": true
    }
  }, [_vm._v("\n          There are no trials for the " + _vm._s(_vm.enrollments) + " enrollment.\n        ")]) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "md8": ""
    }
  }, _vm._l((_vm.trials), function(item) {
    return _c('v-card', {
      key: item.trialId,
      staticClass: "info"
    }, [_c('v-list', {
      staticClass: "listItems pa-0"
    }, [_c('v-list-tile', {
      staticClass: "pb-2 pt-2 pl-2"
    }, [_c('v-list-tile-avatar', [_c('v-icon', {
      attrs: {
        "left": ""
      }
    }, [_vm._v("folder")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(item.trialName)
      }
    })], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "light": "",
        "flat": "",
        "ripple": "",
        "to": '/trials/' + item.trialId
      }
    }, [_c('right-icon', {
      attrs: {
        "color": item.active ? 'primary' : 'grey'
      }
    })], 1)], 1), _vm._v(" "), (_vm.userIsAuthenticated) ? _c('v-menu', {
      attrs: {
        "bottom": "",
        "left": ""
      }
    }, [_c('v-btn', {
      attrs: {
        "slot": "activator",
        "icon": ""
      },
      slot: "activator"
    }, [_c('v-icon', [_vm._v("more_vert")])], 1), _vm._v(" "), _c('v-list', [_c('v-list-tile', [_c('v-list-tile-action', [_c('v-btn', {
      staticClass: "red darken-3",
      attrs: {
        "dark": "",
        "flat": ""
      },
      on: {
        "click": function($event) {
          _vm.onDeleteTrial(item)
        }
      }
    }, [_c('v-icon', {
      staticClass: "text--lighten-1",
      attrs: {
        "small": "",
        "dark": ""
      }
    }, [_vm._v("delete")])], 1)], 1)], 1)], 1)], 1) : _vm._e()], 1)], 1)], 1)
  }))], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-0",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    staticClass: "mt-0 cyan--text text--darken-3 text-center",
    attrs: {
      "align-center": "",
      "depressed": "",
      "color": "cyan lighten-5",
      "dark": "",
      "to": '/trial/new'
    }
  }, [_vm._v("New Trial")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 697 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "mt-0"
  }, [(_vm.loading) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": "",
      "sm8": "",
      "md6": ""
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary",
      "width": 7,
      "size": 70
    }
  })], 1)], 1) : _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": "",
      "sm6": "",
      "offset-sm3": ""
    }
  }, [_c('h1', {
    staticClass: "mt-3 text-xs-center"
  }, [_vm._v(_vm._s(_vm.location.locationName))]), _vm._v(" "), _c('v-expansion-panel', {
    attrs: {
      "expand": ""
    }
  }, [_c('v-expansion-panel-content', [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Street Address")]), _vm._v(" "), _c('v-card', [_c('v-card-text', {
    staticClass: "white lighten-3"
  }, [_vm._v(_vm._s(_vm.location.locationStreetAddress))])], 1)], 1)], 1), _vm._v(" "), _c('v-expansion-panel', {
    attrs: {
      "expand": ""
    }
  }, [_c('v-expansion-panel-content', [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("City")]), _vm._v(" "), _c('v-card', [_c('v-card-text', {
    staticClass: "white lighten-3"
  }, [_vm._v(_vm._s(_vm.location.locationCity))])], 1)], 1)], 1), _vm._v(" "), _c('v-expansion-panel', {
    attrs: {
      "expand": ""
    }
  }, [_c('v-expansion-panel-content', [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("State")]), _vm._v(" "), _c('v-card', [_c('v-card-text', {
    staticClass: "white lighten-3"
  }, [_vm._v(_vm._s(_vm.location.locationState))])], 1)], 1)], 1), _vm._v(" "), _c('v-expansion-panel', {
    attrs: {
      "expand": ""
    }
  }, [_c('v-expansion-panel-content', [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Zipcode")]), _vm._v(" "), _c('v-card', [_c('v-card-text', {
    staticClass: "white lighten-3"
  }, [_vm._v(_vm._s(_vm.location.locationZipcode))])], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.userIsAuthenticated) ? [_c('v-spacer'), _vm._v(" "), _c('app-edit-location-dialog', {
    attrs: {
      "location": _vm.location
    }
  })] : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "red darken-3",
    attrs: {
      "dark": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.onDeleteLocation(_vm.location)
      }
    }
  }, [_c('v-icon', {
    staticClass: "text--lighten-1",
    attrs: {
      "small": "",
      "dark": ""
    }
  }, [_vm._v("delete")])], 1)], 2)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 698 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', [_c('v-layout', {
    staticClass: "mt-3",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center mb-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('h1', [_vm._v("Trials By Enrollments")]), _vm._v(" "), (_vm.enrollments == false) ? _c('v-alert', {
    attrs: {
      "color": "info",
      "icon": "new_releases",
      "value": true
    }
  }, [_vm._v("\n          There are no enrollments.\n        ")]) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs10": "",
      "sm11": "",
      "md11": "",
      "align-content-space-between": "",
      "mt-4": "",
      "mb-4": "",
      "ml-0": "",
      "mr-0": ""
    }
  }, _vm._l((_vm.enrollments), function(item, index) {
    return _c('v-card', {
      key: item.enrollmentId,
      staticClass: "info"
    }, [_c('v-list', {
      staticClass: "listItems"
    }, [_c('v-list-tile', {
      staticClass: "pb-2 pt-2 pl-2"
    }, [_c('v-list-tile-avatar', [_c('v-icon', {
      attrs: {
        "left": ""
      }
    }, [_vm._v("bookmark_border")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(item.enrollmentName)
      }
    })], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "light": "",
        "flat": "",
        "ripple": "",
        "to": '/Trials/enrollments/' + item.enrollmentId
      }
    }, [_c('right-icon', {
      attrs: {
        "color": item.active ? 'primary' : 'grey'
      }
    })], 1)], 1), _vm._v(" "), (_vm.userIsAuthenticated) ? _c('v-menu', {
      attrs: {
        "bottom": "",
        "left": ""
      }
    }, [_c('v-btn', {
      attrs: {
        "slot": "activator",
        "icon": ""
      },
      slot: "activator"
    }, [_c('v-icon', [_vm._v("more_vert")])], 1), _vm._v(" "), _c('v-list', [_c('v-list-tile', [_c('v-list-tile-action', [
      [_c('app-edit-enrollment-dialog', {
        attrs: {
          "enrollment": _vm.enrollment(index)
        }
      })]
    ], 2)], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-action', [_c('v-btn', {
      staticClass: "red darken-3",
      attrs: {
        "dark": "",
        "flat": ""
      },
      on: {
        "click": function($event) {
          _vm.onDeleteTrial(item)
        }
      }
    }, [_c('v-icon', {
      staticClass: "text--lighten-1",
      attrs: {
        "small": "",
        "dark": ""
      }
    }, [_vm._v("delete")])], 1)], 1)], 1)], 1)], 1) : _vm._e()], 1)], 1)], 1)
  })), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": "",
      "sm1": "",
      "md1": "",
      "ml-0": "",
      "mr-0": "",
      "mb-0": "",
      "mt-4": "",
      "justify-center": ""
    }
  }, _vm._l((_vm.enrollments), function(item) {
    return _c('v-card', {
      key: item.enrollmentId,
      staticClass: "info"
    }, [_c('v-list', {
      staticClass: "listItems pa-0"
    }, [_c('v-list-tile', {
      staticClass: "pb-2 pt-2 pl-2"
    }, [(_vm.userIsAuthenticated) ? _c('v-menu', {
      attrs: {
        "bottom": "",
        "left": ""
      }
    }, [_c('v-btn', {
      attrs: {
        "slot": "activator",
        "icon": ""
      },
      slot: "activator"
    }, [_c('v-icon', [_vm._v("more_vert")])], 1), _vm._v(" "), _c('v-list', [_c('v-list-tile', [_c('v-list-tile-action', [_c('v-btn', {
      staticClass: "red darken-3",
      attrs: {
        "dark": "",
        "flat": ""
      },
      on: {
        "click": function($event) {
          _vm.onDeleteEnrollment(item)
        }
      }
    }, [_c('v-icon', {
      staticClass: "text--lighten-1",
      attrs: {
        "small": "",
        "dark": ""
      }
    }, [_vm._v("delete")])], 1)], 1)], 1)], 1)], 1) : _vm._e()], 1)], 1)], 1)
  }))], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-0",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    staticClass: "mt-0 cyan--text text--darken-3 text-center",
    attrs: {
      "align-center": "",
      "depressed": "",
      "color": "cyan lighten-5",
      "dark": "",
      "to": '/enrollment/new'
    }
  }, [_vm._v("New Enrollment")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 699 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    staticClass: "editDialogsRow",
    attrs: {
      "width": "350px",
      "persistent": ""
    },
    model: {
      value: (_vm.editDialog),
      callback: function($$v) {
        _vm.editDialog = $$v
      },
      expression: "editDialog"
    }
  }, [_c('v-card-text', {
    staticClass: "pa-0",
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_vm._v("\n    Add Enrollment\n    "), _c('v-icon', {
    staticClass: "text-xs-right"
  }, [_vm._v("add")])], 1), _vm._v(" "), _c('v-card', [_c('v-container', [_c('v-layout', {
    attrs: {
      "justify-end": "",
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "mb-2",
    attrs: {
      "xs1": ""
    }
  }, [_c('v-icon', {
    staticClass: "primary--text text--lighten-1",
    attrs: {
      "depressed": ""
    },
    on: {
      "click": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_vm._v("close")])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "mb-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card-title', {
    staticClass: "text-xs-center justify-center"
  }, [_c('h2', [_vm._v("Edit " + _vm._s(_vm.trial.trialName) + " Enrollments")])])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_vm._l((_vm.editedEnrollments), function(item) {
    return _c('v-flex', {
      key: item.objectName,
      attrs: {
        "xs12": ""
      }
    }, [_vm._v("\n          " + _vm._s(item.name) + "\n        ")])
  }), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card-text', [_c('h3', [_vm._v("Current Enrollments:")]), _vm._v(" "), _vm._l((_vm.editedEnrollments), function(item) {
    return _c('div', {
      key: item.enrollmentID
    }, [_vm._v("\n              " + _vm._s(item.enrollmentName) + "\n            ")])
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "name": "trial.trialEnrollments",
      "label": "Add Trial Enrollments",
      "items": _vm.enrollments,
      "item-value": "enrollmentId",
      "item-text": "enrollmentName",
      "id": "trial.trialEnrollments",
      "multiple": "",
      "max-height": "400",
      "hint": "Pick your enrollments",
      "persistent-hint": ""
    },
    model: {
      value: (_vm.trialEnrollments),
      callback: function($$v) {
        _vm.trialEnrollments = $$v
      },
      expression: "trialEnrollments"
    }
  })], 2), _vm._v(" "), _c('v-btn', {
    staticClass: "grey white--text",
    attrs: {
      "depressed": "",
      "to": "/enrollment/new"
    }
  }, [_vm._v("Create New Enrollment")])], 1)], 2), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card-actions', {
    staticClass: "justify-center"
  }, [_c('v-btn', {
    staticClass: "grey lighten-1 white--text",
    attrs: {
      "depressed": ""
    },
    on: {
      "click": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    staticClass: "white--text primary ",
    attrs: {
      "depressed": ""
    },
    on: {
      "click": _vm.onSaveChanges
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 700 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "trialPage mt-0"
  }, [(_vm.loading) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": "",
      "sm10": "",
      "md10": ""
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary",
      "width": 7,
      "size": 70
    }
  })], 1)], 1) : _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center mb-4",
    attrs: {
      "xs12": "",
      "sm10": "",
      "offset-sm1": "",
      "justify-center": "",
      "align-center": ""
    }
  }, [_c('h1', {
    staticClass: "mt-3 mb-4 text-xs-center trialtitle"
  }, [_c('div', {
    staticClass: "status"
  }, [_c('span', {
    class: _vm.enrollmentsss.enrollmentName
  })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.trial.trialName))])]), _vm._v(" "), _c('div', {
    staticClass: "trialData"
  }, [_c('div', {
    staticClass: "header",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('document-icon', {
    staticClass: "icon mr-2"
  }), _vm._v("Description")], 1), _vm._v(" "), _c('v-card', [_c('v-card-text', {
    staticClass: "white pl-4 pr-4"
  }, [_c('pre', {
    staticClass: "textDescription"
  }, [_vm._v(_vm._s(_vm.trial.trialDescription))])]), _vm._v(" "), _c('v-divider')], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "trialData"
  }, [_c('div', {
    staticClass: "header",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('person-icon', {
    staticClass: "icon mr-2"
  }), _vm._v("Coordinators")], 1), _vm._v(" "), _c('v-card', [_c('v-card-text', {
    staticClass: "white pa-2"
  }, [_c('v-list', _vm._l((_vm.coordinatorsGetter), function(item, index) {
    return _c('v-list-tile', {
      key: ("item-" + index)
    }, [_c('v-list-tile-content', [_vm._v("\n                    " + _vm._s(item.coordinatorName) + "\n                  ")]), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "icon": "",
        "ripple": "",
        "href": 'tel:' + item.coordinatorPhone
      }
    }, [_c('v-icon', {
      attrs: {
        "color": item.active ? 'primary' : 'grey lighten-2'
      }
    }, [_vm._v("phone")])], 1)], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "icon": "",
        "ripple": "",
        "href": 'sms:' + item.coordinatorPhone
      }
    }, [_c('v-icon', {
      attrs: {
        "color": item.active ? 'primary' : 'grey lighten-2'
      }
    }, [_vm._v("textsms")])], 1)], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "icon": "",
        "ripple": "",
        "href": 'mailto:' + item.coordinatorEmail + '?subject=' + _vm.trial.trialName
      }
    }, [_c('v-icon', {
      attrs: {
        "color": item.active ? 'primary' : 'grey lighten-2'
      }
    }, [_vm._v("email")])], 1)], 1)], 1)
  }))], 1), _vm._v(" "), _c('v-divider')], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "trialData"
  }, [_c('div', {
    staticClass: "header",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("person_outline")]), _vm._v("Investigators")], 1), _vm._v(" "), _c('v-card', [_c('v-card-text', {
    staticClass: "white pa-2"
  }, [_c('v-list', _vm._l((_vm.investigatorsGetter), function(item, index) {
    return _c('v-list-tile', {
      key: ("item-" + index)
    }, [_c('v-list-tile-content', [_vm._v("\n                    " + _vm._s(item.investigatorName) + "\n                  ")]), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "icon": "",
        "ripple": "",
        "href": 'tel:' + item.investigatorPhone
      }
    }, [_c('v-icon', {
      attrs: {
        "color": item.active ? 'primary' : 'grey lighten-2'
      }
    }, [_vm._v("phone")])], 1)], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "icon": "",
        "ripple": "",
        "href": 'sms:' + item.investigatorPhone
      }
    }, [_c('v-icon', {
      attrs: {
        "color": item.active ? 'primary' : 'grey lighten-2'
      }
    }, [_vm._v("textsms")])], 1)], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "icon": "",
        "ripple": "",
        "href": 'mailto:' + item.investigatorEmail + '?subject=' + _vm.trial.trialName + '&body=Name: <br>Tel: <br>Email: '
      }
    }, [_c('v-icon', {
      attrs: {
        "color": item.active ? 'primary' : 'grey lighten-2'
      }
    }, [_vm._v("email")])], 1)], 1)], 1)
  }))], 1), _vm._v(" "), _c('v-divider')], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "trialData"
  }, [_c('div', {
    staticClass: "header",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('map-icon', {
    staticClass: "icon mr-2"
  }), _vm._v("Address")], 1), _vm._v(" "), _c('v-card', [_vm._l((_vm.locationsss), function(item) {
    return _c('v-card-text', {
      key: item.locationID,
      staticClass: "white pl-4 pr-4"
    }, [_c('strong', [_vm._v(_vm._s(item.locationName))]), _c('br'), _vm._v("\n              " + _vm._s(item.locationStreetAddress)), _c('br'), _vm._v("\n              " + _vm._s(item.locationCity) + ", " + _vm._s(item.locationState) + " " + _vm._s(item.locationZipcode) + "\n            ")])
  }), _vm._v(" "), _c('v-divider')], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "trialData"
  }, [_c('div', {
    staticClass: "header",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('map-icon', {
    staticClass: "icon mr-2"
  }), _vm._v("Location")], 1), _vm._v(" "), _c('v-card', [_vm._l((_vm.locationsss), function(item, index) {
    return (_vm.trial.trialLocations) ? _c('v-card-text', {
      key: ("item-" + index),
      staticClass: "white pl-4 pr-4"
    }, [_vm._v("\n              " + _vm._s(item.locationName)), _c('br')]) : _vm._e()
  }), _vm._v(" "), _c('v-divider')], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "trialData"
  }, [_c('div', {
    staticClass: "header",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('indication-icon', {
    staticClass: "icon mr-2"
  }), _vm._v("Indications")], 1), _vm._v(" "), _c('v-card', [_vm._l((_vm.indicationsss), function(item, index) {
    return _c('v-card-text', {
      key: ("item-" + index),
      staticClass: "white pl-4 pr-4"
    }, [_vm._v("\n            " + _vm._s(item.indicationName)), _c('br')])
  }), _vm._v(" "), _c('v-divider')], 2)], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mt-4 alt--text text--darken-3",
    attrs: {
      "depressed": "",
      "color": "alt lighten-5",
      "dark": "",
      "href": _vm.trial.trialLink,
      "target": "_blank"
    }
  }, [_vm._v("ClinicalTrials.gov")]), _vm._v(" "), (_vm.userIsAuthenticated) ? _c('v-btn', {
    staticClass: "mt-4 white--text",
    attrs: {
      "depressed": "",
      "color": "primary lighten-5",
      "dark": "",
      "to": '/trials/' + _vm.trial.trialId + '/edit'
    }
  }, [_vm._v("Edit")]) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 701 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "width": "350px",
      "persistent": ""
    },
    model: {
      value: (_vm.editDialog),
      callback: function($$v) {
        _vm.editDialog = $$v
      },
      expression: "editDialog"
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "icon": ""
    },
    slot: "activator"
  }, [_c('v-icon', {
    staticClass: "text--lighten-1",
    attrs: {
      "small": "",
      "light": ""
    }
  }, [_vm._v("edit")])], 1), _vm._v(" "), _c('v-card', [_c('v-container', {
    staticClass: "mt-0"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "mb-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card-title', {
    staticClass: "justify-center"
  }, [_c('h2', [_vm._v("Edit Location")])])], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_vm._l((_vm.editedLocations), function(item) {
    return _c('v-flex', {
      key: item.objectName,
      attrs: {
        "xs12": ""
      }
    }, [_vm._v("\n          " + _vm._s(item.name) + "\n        ")])
  }), _vm._v(" "), _c('v-card-text', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "editedLocations.locationName",
      "label": "Name",
      "id": "locationName",
      "single-line": "",
      "required": ""
    },
    model: {
      value: (_vm.editedLocations.locationName),
      callback: function($$v) {
        _vm.$set(_vm.editedLocations, "locationName", $$v)
      },
      expression: "editedLocations.locationName"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "name": "editedLocations.locationStreetAddress",
      "label": "Stree Address",
      "id": "locationStreetAddress",
      "single-line": "",
      "required": ""
    },
    model: {
      value: (_vm.editedLocations.locationStreetAddress),
      callback: function($$v) {
        _vm.$set(_vm.editedLocations, "locationStreetAddress", $$v)
      },
      expression: "editedLocations.locationStreetAddress"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "name": "editedLocations.locationCity",
      "label": "City",
      "id": "locationCity",
      "single-line": "",
      "required": ""
    },
    model: {
      value: (_vm.editedLocations.locationCity),
      callback: function($$v) {
        _vm.$set(_vm.editedLocations, "locationCity", $$v)
      },
      expression: "editedLocations.locationCity"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "name": "editedLocations.locationState",
      "label": "State",
      "id": "locationState",
      "single-line": "",
      "required": ""
    },
    model: {
      value: (_vm.editedLocations.locationState),
      callback: function($$v) {
        _vm.$set(_vm.editedLocations, "locationState", $$v)
      },
      expression: "editedLocations.locationState"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "name": "editedLocations.locationZipcode",
      "label": "Zipcode",
      "id": "locationZipcode",
      "single-line": "",
      "required": ""
    },
    model: {
      value: (_vm.editedLocations.locationZipcode),
      callback: function($$v) {
        _vm.$set(_vm.editedLocations, "locationZipcode", $$v)
      },
      expression: "editedLocations.locationZipcode"
    }
  })], 1)], 1)], 2), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card-actions', {
    staticClass: "justify-center"
  }, [_c('v-btn', {
    staticClass: "grey lighten-1 white--text",
    attrs: {
      "depressed": ""
    },
    on: {
      "click": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    staticClass: "white--text primary ",
    attrs: {
      "depressed": ""
    },
    on: {
      "click": _vm.onSaveChanges
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('v-btn', {
    staticClass: "red darken-3",
    attrs: {
      "dark": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.onDeleteLocation(_vm.location)
      }
    }
  }, [_c('v-icon', {
    staticClass: "text--lighten-1",
    attrs: {
      "small": "",
      "dark": ""
    }
  }, [_vm._v("delete")])], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 702 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "width": "350px",
      "persistent": ""
    },
    model: {
      value: (_vm.editDialog),
      callback: function($$v) {
        _vm.editDialog = $$v
      },
      expression: "editDialog"
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "icon": ""
    },
    slot: "activator"
  }, [_c('v-icon', {
    staticClass: "text--lighten-1",
    attrs: {
      "small": "",
      "light": ""
    }
  }, [_vm._v("edit")])], 1), _vm._v(" "), _c('v-card', [_c('v-container', {
    staticClass: "mt-0"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "mb-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card-title', {
    staticClass: "justify-center"
  }, [_c('h2', [_vm._v("Edit Trial Coordinators")])])], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_vm._l((_vm.editedCoordinators), function(item) {
    return _c('v-flex', {
      key: item.objectName,
      attrs: {
        "xs12": ""
      }
    }, [_vm._v("\n          " + _vm._s(item.name) + "\n        ")])
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Coordinator",
      "id": "CoordinatorName"
    },
    model: {
      value: (_vm.editedCoordinators),
      callback: function($$v) {
        _vm.editedCoordinators = $$v
      },
      expression: "editedCoordinators"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Coordinator Phone Number",
      "id": "CoordinatorPhone"
    },
    model: {
      value: (_vm.editedCoordinatorsPhone),
      callback: function($$v) {
        _vm.editedCoordinatorsPhone = $$v
      },
      expression: "editedCoordinatorsPhone"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Coordinator Email Address",
      "id": "CoordinatorEmail"
    },
    model: {
      value: (_vm.editedCoordinatorsEmail),
      callback: function($$v) {
        _vm.editedCoordinatorsEmail = $$v
      },
      expression: "editedCoordinatorsEmail"
    }
  })], 1)], 2), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card-actions', {
    staticClass: "justify-center"
  }, [_c('v-btn', {
    staticClass: "grey lighten-1 white--text",
    attrs: {
      "depressed": ""
    },
    on: {
      "click": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    staticClass: "white--text primary ",
    attrs: {
      "depressed": ""
    },
    on: {
      "click": _vm.onSaveChanges
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('v-btn', {
    staticClass: "red darken-3",
    attrs: {
      "dark": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.onDeleteCoordinator(_vm.coordinator)
      }
    }
  }, [_c('v-icon', {
    staticClass: "text--lighten-1",
    attrs: {
      "small": "",
      "dark": ""
    }
  }, [_vm._v("delete")])], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 703 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "mt-0"
  }, [_c('v-layout', {
    staticClass: "mt-3",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('h1', [_vm._v("Alerts")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "md8": ""
    }
  }, _vm._l((_vm.alerts), function(item, index) {
    return _c('v-card', {
      key: ("item-" + index),
      staticClass: "info"
    }, [_c('v-list', [_c('v-list-tile', {
      attrs: {
        "icon": ""
      }
    }, [_c('v-list-tile-avatar', [_c('v-icon', {
      attrs: {
        "left": ""
      }
    }, [_vm._v("alert_on")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(item.alertName)
      }
    }, [_vm._v(_vm._s(item))])], 1), _vm._v(" "), _c('v-list-tile-action', [(_vm.userIsCreator(index)) ? [_c('app-edit-alert-dialog', {
      attrs: {
        "alert": _vm.alert(index)
      }
    })] : _vm._e()], 2), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          _vm.onDeleteAlert(item)
        }
      }
    }, [_c('v-icon', {
      staticClass: "grey--text text--lighten-1"
    }, [_vm._v("delete")])], 1)], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "icon": "",
        "ripple": "",
        "to": '/alerts/' + item.alertId
      }
    }, [_c('v-icon', {
      attrs: {
        "color": item.active ? 'primary' : 'grey'
      }
    }, [_vm._v("navigate_next")])], 1)], 1)], 1)], 1)], 1)
  }))], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 704 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "mt-0"
  }, [_c('v-layout', {
    staticClass: "mt-3",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center mb-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('h1', [_vm._v("All Coordinators")]), _vm._v(" "), (_vm.coordinators == false) ? _c('v-alert', {
    attrs: {
      "color": "info",
      "icon": "new_releases",
      "value": true
    }
  }, [_vm._v("\n          There are no coordinators.\n        ")]) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs10": "",
      "sm11": "",
      "md11": "",
      "align-content-space-between": "",
      "mt-4": "",
      "mb-0": "",
      "ml-0": "",
      "mr-0": ""
    }
  }, _vm._l((_vm.coordinators), function(item, index) {
    return _c('v-card', {
      key: item.coordinatorId,
      staticClass: "info",
      attrs: {
        "to": '/coordinator/' + item.coordinatorId
      }
    }, [_c('v-list', {
      staticClass: "listItems"
    }, [_c('v-list-tile', {
      staticClass: "pb-2 pt-2 pl-2"
    }, [_c('v-list-tile-avatar', [_c('v-icon', {
      attrs: {
        "left": ""
      }
    }, [_vm._v("person_pin")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(item.coordinatorName)
      }
    })], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "light": "",
        "flat": "",
        "ripple": ""
      }
    }, [_c('v-icon', {
      attrs: {
        "color": item.active ? 'primary' : 'grey'
      }
    }, [_vm._v("navigate_next")])], 1)], 1)], 1)], 1)], 1)
  })), _vm._v(" "), (_vm.userIsAuthenticated) ? _c('v-flex', {
    attrs: {
      "xs2": "",
      "sm1": "",
      "md1": "",
      "ml-0": "",
      "mr-0": "",
      "mb-0": "",
      "mt-4": "",
      "justify-center": ""
    }
  }, _vm._l((_vm.coordinators), function(item2, index2) {
    return _c('v-card', {
      key: item2.coordinatorId,
      staticClass: "info"
    }, [_c('v-list', {
      staticClass: "listItems pa-0"
    }, [_c('v-list-tile', {
      staticClass: "pa-2"
    }, [_c('app-edit-coordinator-dialog', {
      attrs: {
        "coordinator": _vm.coordinator(index2)
      }
    })], 1)], 1)], 1)
  })) : _vm._e(), _vm._v(" "), (_vm.userIsAuthenticated) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "mb-4": ""
    }
  }, [_c('v-card', {
    attrs: {
      "to": '/coordinator/new'
    }
  }, [(_vm.userIsAuthenticated) ? _c('v-card-text', {
    staticClass: "primaryLight editDialogsRow"
  }, [_vm._v("\n          Add Coordinator\n          "), _c('v-icon', {
    staticClass: "text-xs-right"
  }, [_vm._v("add")])], 1) : _vm._e()], 1)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 705 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "width": "350px",
      "persistent": ""
    },
    model: {
      value: (_vm.editDialog),
      callback: function($$v) {
        _vm.editDialog = $$v
      },
      expression: "editDialog"
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "icon": ""
    },
    slot: "activator"
  }, [_c('v-icon', {
    staticClass: "text--lighten-1",
    attrs: {
      "small": "",
      "light": ""
    }
  }, [_vm._v("edit")])], 1), _vm._v(" "), _c('v-card', [_c('v-container', {
    staticClass: "mt-0"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "mb-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card-title', {
    staticClass: "justify-center"
  }, [_c('h2', [_vm._v("Edit Trial Investigators")])])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_vm._l((_vm.editedInvestigators), function(item) {
    return _c('v-flex', {
      key: item.objectName,
      attrs: {
        "xs12": ""
      }
    }, [_vm._v("\n          " + _vm._s(item.name) + "\n        ")])
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Investigator",
      "id": "InvestigatorName"
    },
    model: {
      value: (_vm.editedInvestigators),
      callback: function($$v) {
        _vm.editedInvestigators = $$v
      },
      expression: "editedInvestigators"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Investigator Phone Number",
      "id": "InvestigatorPhone"
    },
    model: {
      value: (_vm.editedInvestigatorsPhone),
      callback: function($$v) {
        _vm.editedInvestigatorsPhone = $$v
      },
      expression: "editedInvestigatorsPhone"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Investigator Email Address",
      "id": "InvestigatorEmail"
    },
    model: {
      value: (_vm.editedInvestigatorsEmail),
      callback: function($$v) {
        _vm.editedInvestigatorsEmail = $$v
      },
      expression: "editedInvestigatorsEmail"
    }
  })], 1)], 2), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card-actions', {
    staticClass: "justify-center"
  }, [_c('v-btn', {
    staticClass: "grey lighten-1 white--text",
    attrs: {
      "depressed": ""
    },
    on: {
      "click": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    staticClass: "white--text primary ",
    attrs: {
      "depressed": ""
    },
    on: {
      "click": _vm.onSaveChanges
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('v-btn', {
    staticClass: "red darken-3",
    attrs: {
      "dark": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.onDeleteInvestigator(_vm.investigator)
      }
    }
  }, [_c('v-icon', {
    staticClass: "text--lighten-1",
    attrs: {
      "small": "",
      "dark": ""
    }
  }, [_vm._v("delete")])], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 706 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "mt-0"
  }, [_c('v-layout', {
    staticClass: "mt-3",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center mb-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('h1', [_vm._v("Trials By Coordinators")]), _vm._v(" "), (_vm.coordinators == false) ? _c('v-alert', {
    attrs: {
      "color": "info",
      "icon": "new_releases",
      "value": true
    }
  }, [_vm._v("\n          There are no coordinators.\n        ")]) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs10": "",
      "sm11": "",
      "md11": "",
      "align-content-space-between": "",
      "mt-4": "",
      "mb-0": "",
      "ml-0": "",
      "mr-0": ""
    }
  }, _vm._l((_vm.coordinators), function(item) {
    return _c('v-card', {
      key: item.coordinatorId,
      staticClass: "info",
      attrs: {
        "to": '/Trials/coordinators/' + item.coordinatorId
      }
    }, [_c('v-list', {
      staticClass: "listItems"
    }, [_c('v-list-tile', {
      staticClass: "pb-2 pt-2 pl-2"
    }, [_c('v-list-tile-avatar', [_c('person-icon', {
      staticClass: "icon",
      attrs: {
        "left": ""
      }
    })], 1), _vm._v(" "), _c('v-list-tile-content', {
      staticClass: "pl-2"
    }, [_c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(item.coordinatorName)
      }
    })], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "light": "",
        "flat": "",
        "ripple": ""
      }
    }, [_c('v-icon', {
      attrs: {
        "color": item.active ? 'grey' : 'grey'
      }
    }, [_vm._v("navigate_next")])], 1)], 1)], 1)], 1)], 1)
  })), _vm._v(" "), (_vm.userIsAuthenticated) ? _c('v-flex', {
    attrs: {
      "xs2": "",
      "sm1": "",
      "md1": "",
      "ml-0": "",
      "mr-0": "",
      "mb-0": "",
      "mt-4": "",
      "justify-center": ""
    }
  }, _vm._l((_vm.coordinators), function(item2, index2) {
    return _c('v-card', {
      key: item2.coordinatorId,
      staticClass: "info"
    }, [_c('v-list', {
      staticClass: "listItems pa-0"
    }, [_c('v-list-tile', {
      staticClass: "pa-2"
    }, [_c('app-edit-coordinator-dialog', {
      attrs: {
        "coordinator": _vm.coordinator(index2)
      }
    })], 1)], 1)], 1)
  })) : _vm._e(), _vm._v(" "), (_vm.userIsAuthenticated) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "mb-4": ""
    }
  }, [_c('v-card', {
    attrs: {
      "to": '/coordinator/new'
    }
  }, [(_vm.userIsAuthenticated) ? _c('v-card-text', {
    staticClass: "cyanLight editDialogsRow"
  }, [_vm._v("\n          Add Coordinator\n          "), _c('v-icon', {
    staticClass: "text-xs-right"
  }, [_vm._v("add")])], 1) : _vm._e()], 1)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 707 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    staticClass: "editDialogsRow",
    attrs: {
      "width": "350px",
      "persistent": ""
    },
    model: {
      value: (_vm.editDialog),
      callback: function($$v) {
        _vm.editDialog = $$v
      },
      expression: "editDialog"
    }
  }, [_c('v-card-text', {
    staticClass: "pa-0",
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_vm._v("\n    Add Investigator\n    "), _c('v-icon', {
    staticClass: "text-xs-right"
  }, [_vm._v("add")])], 1), _vm._v(" "), _c('v-card', [_c('v-container', [_c('v-layout', {
    attrs: {
      "justify-end": "",
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "mb-2",
    attrs: {
      "xs1": ""
    }
  }, [_c('v-icon', {
    staticClass: "primary--text text--lighten-1",
    attrs: {
      "depressed": ""
    },
    on: {
      "click": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_vm._v("close")])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "mb-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card-title', {
    staticClass: "text-xs-center justify-center"
  }, [_c('h2', [_vm._v("Edit " + _vm._s(_vm.trial.trialName) + " Investigators")])])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_vm._l((_vm.editedInvestigators), function(item) {
    return _c('v-flex', {
      key: item.objectName,
      attrs: {
        "xs12": ""
      }
    }, [_vm._v("\n          " + _vm._s(item.name) + "\n        ")])
  }), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card-text', [_c('h3', [_vm._v("Current Investigators:")]), _vm._v(" "), _vm._l((_vm.investigatorsGetter), function(item) {
    return _c('div', {
      key: item.investigatorID
    }, [_vm._v("\n              " + _vm._s(item.investigatorName) + "\n            ")])
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "name": "trial.trialInvestigators",
      "label": "Add Trial Investigators",
      "items": _vm.investigators,
      "item-value": "investigatorId",
      "item-text": "investigatorName",
      "id": "trial.trialInvestigators",
      "multiple": "",
      "max-height": "400",
      "hint": "Pick your investigators",
      "persistent-hint": ""
    },
    model: {
      value: (_vm.editedInvestigators),
      callback: function($$v) {
        _vm.editedInvestigators = $$v
      },
      expression: "editedInvestigators"
    }
  })], 2), _vm._v(" "), _c('v-btn', {
    staticClass: "grey white--text",
    attrs: {
      "depressed": "",
      "to": "/investigator/new"
    }
  }, [_vm._v("Create New Investigator")])], 1)], 2), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card-actions', {
    staticClass: "justify-center"
  }, [_c('v-btn', {
    staticClass: "grey lighten-1 white--text",
    attrs: {
      "depressed": ""
    },
    on: {
      "click": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    staticClass: "white--text primary ",
    attrs: {
      "depressed": ""
    },
    on: {
      "click": _vm.onSaveChanges
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 708 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', [_c('v-layout', {
    staticClass: "mt-3",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('h1', [_vm._v("Enrollments")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "md8": ""
    }
  }, _vm._l((_vm.enrollments), function(item, index) {
    return _c('v-card', {
      key: ("item-" + index),
      staticClass: "info"
    }, [_c('v-list', [_c('v-list-tile', {
      attrs: {
        "icon": ""
      }
    }, [_c('v-list-tile-avatar', [_c('v-icon', {
      attrs: {
        "left": ""
      }
    }, [_vm._v("enrollment_on")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(item.enrollmentName)
      }
    })], 1), _vm._v(" "), _c('v-list-tile-action', [(_vm.userIsCreator(index)) ? [_c('app-edit-enrollment-dialog', {
      attrs: {
        "enrollment": _vm.enrollment(index)
      }
    })] : _vm._e()], 2), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          _vm.onDeleteEnrollment(item)
        }
      }
    }, [_c('v-icon', {
      staticClass: "grey--text text--lighten-1"
    }, [_vm._v("delete")])], 1)], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "icon": "",
        "ripple": "",
        "to": '/enrollments/' + item.enrollmentId
      }
    }, [_c('v-icon', {
      attrs: {
        "color": item.active ? 'primary' : 'grey'
      }
    }, [_vm._v("navigate_next")])], 1)], 1)], 1)], 1)], 1)
  }))], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 709 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "mt-0"
  }, [(_vm.loading) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": "",
      "sm8": "",
      "md6": ""
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary",
      "width": 7,
      "size": 70
    }
  })], 1)], 1) : _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": "",
      "sm6": "",
      "offset-sm3": ""
    }
  }, [_c('h1', {
    staticClass: "mt-3 text-xs-center"
  }, [_vm._v(_vm._s(_vm.investigator.investigatorName))]), _vm._v(" "), _c('v-card', [_c('v-card-text', [_vm._v("\n\t\t\t\t\t\tPhone Number: " + _vm._s(_vm.investigator.investigatorPhone) + "\n\t\t\t\t\t")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n\t\t\t\t\t\tEmail Address: " + _vm._s(_vm.investigator.investigatorEmail) + "\n\t\t\t\t\t")])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.userIsCreator) ? [_c('v-spacer'), _vm._v(" "), _c('app-edit-investigator-dialog', {
    attrs: {
      "investigator": _vm.investigator
    }
  })] : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "red darken-3",
    attrs: {
      "dark": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.onDeleteInvestigator(_vm.investigator)
      }
    }
  }, [_c('v-icon', {
    staticClass: "text--lighten-1",
    attrs: {
      "small": "",
      "dark": ""
    }
  }, [_vm._v("delete")])], 1)], 2)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 710 */,
/* 711 */,
/* 712 */
/***/ (function(module, exports) {

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 45 45","xml:space":"preserve","enable-background":"new 0 0 45 45"}},[_c('g',{attrs:{"id":"icons_x2F_close"}},[_c('g',{attrs:{"id":"Mask"}},[_c('path',{attrs:{"id":"path-close_1_","d":"M23 13c5.5 0 10 4.5 10 10s-4.5 10-10 10-10-4.5-10-10 4.5-10 10-10zm0 18.6c2.3 0 4.5-.9 6.1-2.5s2.5-3.8 2.5-6.1c0-4.7-3.8-8.6-8.6-8.6s-8.6 3.8-8.6 8.6 3.9 8.6 8.6 8.6zm2.5-12.1l1 1L24 23l2.5 2.5-1 1L23 24l-2.5 2.5-1-1L22 23l-2.5-2.5 1-1L23 22l2.5-2.5z"}})]),_c('defs',[_c('filter',{attrs:{"id":"Adobe_OpacityMaskFilter","filterUnits":"userSpaceOnUse","x":"0","y":"0","width":"45","height":"45"}},[_c('feColorMatrix',{attrs:{"values":"1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"}})],1)]),_c('mask',{attrs:{"maskUnits":"userSpaceOnUse","x":"0","y":"0","width":"45","height":"45","id":"mask-close_1_"}},[_c('g',{attrs:{"filter":"url(#Adobe_OpacityMaskFilter)"}},[_c('path',{attrs:{"id":"path-close_2_","d":"M23 13c5.5 0 10 4.5 10 10s-4.5 10-10 10-10-4.5-10-10 4.5-10 10-10zm0 18.6c2.3 0 4.5-.9 6.1-2.5s2.5-3.8 2.5-6.1c0-4.7-3.8-8.6-8.6-8.6s-8.6 3.8-8.6 8.6 3.9 8.6 8.6 8.6zm2.5-12.1l1 1L24 23l2.5 2.5-1 1L23 24l-2.5 2.5-1-1L22 23l-2.5-2.5 1-1L23 22l2.5-2.5z","fill-rule":"evenodd","clip-rule":"evenodd","fill":"#fff"}})])]),_c('g',{attrs:{"id":"Color-_x2F_-Primary-_x2F_-Teal","mask":"url(#mask-close_1_)"}},[_c('path',{attrs:{"id":"_x32_FA4C0","fill-rule":"evenodd","clip-rule":"evenodd","fill":"#cba349","d":"M0 0h45v45H0z"}})])])])};var toString = function () {return "/Users/ricky/Sites/Victorium/victorium_v4/src/assets/close.svg"};module.exports = { render: render, toString: toString };

/***/ }),
/* 713 */
/***/ (function(module, exports) {

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 45 45","xml:space":"preserve","enable-background":"new 0 0 45 45"}},[_c('g',{attrs:{"id":"icons_x2F_document"}},[_c('g',{attrs:{"id":"Mask"}},[_c('path',{attrs:{"id":"path-document_1_","d":"M26.9 13H14v20h17.1V17.3L26.9 13zm1.5 3.6h-.8v-.8l.8.8zm-13 15V14.4h10.7V18h3.6v13.6H15.4z"}})]),_c('defs',[_c('filter',{attrs:{"id":"Adobe_OpacityMaskFilter","filterUnits":"userSpaceOnUse","x":"0","y":"0","width":"45","height":"45"}},[_c('feColorMatrix',{attrs:{"values":"1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"}})],1)]),_c('mask',{attrs:{"maskUnits":"userSpaceOnUse","x":"0","y":"0","width":"45","height":"45","id":"mask-document_1_"}},[_c('g',{attrs:{"filter":"url(#Adobe_OpacityMaskFilter)"}},[_c('path',{attrs:{"id":"path-document_2_","d":"M26.9 13H14v20h17.1V17.3L26.9 13zm1.5 3.6h-.8v-.8l.8.8zm-13 15V14.4h10.7V18h3.6v13.6H15.4z","fill-rule":"evenodd","clip-rule":"evenodd","fill":"#fff"}})])]),_c('g',{attrs:{"id":"Color-_x2F_-Primary-_x2F_-Teal","mask":"url(#mask-document_1_)"}},[_c('path',{attrs:{"id":"_x32_FA4C0","fill-rule":"evenodd","clip-rule":"evenodd","fill":"#cba349","d":"M0 0h45v45H0z"}})])])])};var toString = function () {return "/Users/ricky/Sites/Victorium/victorium_v4/src/assets/document.svg"};module.exports = { render: render, toString: toString };

/***/ }),
/* 714 */
/***/ (function(module, exports) {

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 45 45","xml:space":"preserve","enable-background":"new 0 0 45 45"}},[_c('g',{attrs:{"id":"icons_x2F_edit"}},[_c('g',{attrs:{"id":"Mask"}},[_c('path',{attrs:{"id":"path-edit_1_","d":"M13 31.6h18.7V33H13v-1.4zm17.3-13.7L20.1 28.1l-5.1 1 1-5.1 10.2-10.2c.5-.5 1.3-.8 2-.8.8 0 1.5.3 2 .8s.8 1.3.8 2c.1.8-.2 1.6-.7 2.1zm-13.4 9.4l2.6-.5 9.8-9.9c.6-.6.6-1.5 0-2-.6-.6-1.5-.6-2 0l-9.9 9.9-.5 2.5z"}})]),_c('defs',[_c('filter',{attrs:{"id":"Adobe_OpacityMaskFilter","filterUnits":"userSpaceOnUse","x":"0","y":"0","width":"45","height":"45"}},[_c('feColorMatrix',{attrs:{"values":"1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"}})],1)]),_c('mask',{attrs:{"maskUnits":"userSpaceOnUse","x":"0","y":"0","width":"45","height":"45","id":"mask-edit_1_"}},[_c('g',{attrs:{"filter":"url(#Adobe_OpacityMaskFilter)"}},[_c('path',{attrs:{"id":"path-edit_2_","d":"M13 31.6h18.7V33H13v-1.4zm17.3-13.7L20.1 28.1l-5.1 1 1-5.1 10.2-10.2c.5-.5 1.3-.8 2-.8.8 0 1.5.3 2 .8s.8 1.3.8 2c.1.8-.2 1.6-.7 2.1zm-13.4 9.4l2.6-.5 9.8-9.9c.6-.6.6-1.5 0-2-.6-.6-1.5-.6-2 0l-9.9 9.9-.5 2.5z","fill-rule":"evenodd","clip-rule":"evenodd","fill":"#fff"}})])]),_c('g',{attrs:{"id":"Color-_x2F_-Primary-_x2F_-Teal","mask":"url(#mask-edit_1_)"}},[_c('path',{attrs:{"id":"_x32_FA4C0","fill-rule":"evenodd","clip-rule":"evenodd","fill":"#cba349","d":"M0 0h45v45H0z"}})])])])};var toString = function () {return "/Users/ricky/Sites/Victorium/victorium_v4/src/assets/edit.svg"};module.exports = { render: render, toString: toString };

/***/ }),
/* 715 */
/***/ (function(module, exports) {

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 45 45","xml:space":"preserve","enable-background":"new 0 0 45 45"}},[_c('g',{attrs:{"id":"icons_x2F_email"}},[_c('g',{attrs:{"id":"MaskEmail"}},[_c('path',{attrs:{"id":"path-email_1_","d":"M30.1 15H15.9c-1.1 0-1.9.9-1.9 1.9v10.3c0 1.1.9 1.9 1.9 1.9H30c1.1 0 1.9-.9 1.9-1.9V16.9c.1-1-.8-1.9-1.8-1.9zm-1 1.3L23 20.6l-6-4.3h12.1zm1.6 10.9c0 .4-.3.6-.6.6H15.9c-.4 0-.6-.3-.6-.6V16.9v-.2l7.7 5.5 7.7-5.5v10.5z"}})]),_c('defs',[_c('filter',{attrs:{"id":"Adobe_OpacityMaskFilter","filterUnits":"userSpaceOnUse","x":"0","y":"0","width":"45","height":"45"}},[_c('feColorMatrix',{attrs:{"values":"1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"}})],1)]),_c('mask',{attrs:{"maskUnits":"userSpaceOnUse","x":"0","y":"0","width":"45","height":"45","id":"mask-email_1_"}},[_c('g',{attrs:{"filter":"url(#Adobe_OpacityMaskFilter)"}},[_c('path',{attrs:{"id":"path-email_2_","d":"M30.1 15H15.9c-1.1 0-1.9.9-1.9 1.9v10.3c0 1.1.9 1.9 1.9 1.9H30c1.1 0 1.9-.9 1.9-1.9V16.9c.1-1-.8-1.9-1.8-1.9zm-1 1.3L23 20.6l-6-4.3h12.1zm1.6 10.9c0 .4-.3.6-.6.6H15.9c-.4 0-.6-.3-.6-.6V16.9v-.2l7.7 5.5 7.7-5.5v10.5z","fill-rule":"evenodd","clip-rule":"evenodd","fill":"#fff"}})])]),_c('g',{attrs:{"id":"Color-_x2F_-Primary-_x2F_-Teal","mask":"url(#mask-email_1_)"}},[_c('path',{attrs:{"id":"_x32_FA4C0","fill-rule":"evenodd","clip-rule":"evenodd","fill":"#cba349","d":"M0 0h45v45H0z"}})])])])};var toString = function () {return "/Users/ricky/Sites/Victorium/victorium_v4/src/assets/email.svg"};module.exports = { render: render, toString: toString };

/***/ }),
/* 716 */
/***/ (function(module, exports) {

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 45 45","xml:space":"preserve","enable-background":"new 0 0 45 45"}},[_c('g',{attrs:{"id":"icons_x2F_home"}},[_c('g',{attrs:{"id":"Mask"}},[_c('path',{attrs:{"id":"path-home_1_","d":"M34 20.6L22.5 12 11 20.7l.9 1.2 1.7-1.2v11.7c0 .8.7 1.5 1.5 1.5H30c.8 0 1.5-.7 1.5-1.5V20.5l1.7 1.3.8-1.2zm-4 11.8H15.1V19.5l7.4-5.7 7.4 5.5v13.1z"}})]),_c('defs',[_c('filter',{attrs:{"id":"Adobe_OpacityMaskFilter","filterUnits":"userSpaceOnUse","x":"0","y":"0","width":"45","height":"45"}},[_c('feColorMatrix',{attrs:{"values":"1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"}})],1)]),_c('mask',{attrs:{"maskUnits":"userSpaceOnUse","x":"0","y":"0","width":"45","height":"45","id":"mask-home_1_"}},[_c('g',{attrs:{"filter":"url(#Adobe_OpacityMaskFilter)"}},[_c('path',{attrs:{"id":"path-home_2_","d":"M34 20.6L22.5 12 11 20.7l.9 1.2 1.7-1.2v11.7c0 .8.7 1.5 1.5 1.5H30c.8 0 1.5-.7 1.5-1.5V20.5l1.7 1.3.8-1.2zm-4 11.8H15.1V19.5l7.4-5.7 7.4 5.5v13.1z","fill-rule":"evenodd","clip-rule":"evenodd","fill":"#fff"}})])]),_c('g',{attrs:{"id":"Color-_x2F_-Primary-_x2F_-Teal","mask":"url(#mask-home_1_)"}},[_c('path',{attrs:{"id":"_x32_FA4C0","fill-rule":"evenodd","clip-rule":"evenodd","fill":"#cba349","d":"M0 0h45v45H0z"}})])])])};var toString = function () {return "/Users/ricky/Sites/Victorium/victorium_v4/src/assets/home.svg"};module.exports = { render: render, toString: toString };

/***/ }),
/* 717 */
/***/ (function(module, exports) {

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 45 45","xml:space":"preserve","enable-background":"new 0 0 45 45"}},[_c('g',{attrs:{"id":"icons_x2F_indication"}},[_c('g',{attrs:{"id":"Mask"}},[_c('path',{attrs:{"id":"path-indication_1_","d":"M12 15.2v6.7c0 .8.3 1.6.9 2.2l8 8c.6.6 1.4.9 2.2.9s1.6-.3 2.2-.9l6.7-6.7c.6-.6.9-1.4.9-2.2s-.3-1.6-.9-2.2l-8-8c-.6-.6-1.4-.9-2.2-.9h-6.7c-1.7-.1-3.1 1.3-3.1 3.1zm1.6 0c0-.9.7-1.6 1.6-1.6h6.7c.4 0 .8.2 1.1.5l8 8c.6.6.6 1.6 0 2.2L24.3 31c-.6.6-1.6.6-2.2 0l-8-8c-.3-.3-.5-.7-.5-1.1v-6.7zm1 2.6c0 1.7 1.4 3.2 3.2 3.2s3.2-1.4 3.2-3.2-1.4-3.2-3.2-3.2-3.2 1.4-3.2 3.2zm1.6 0c0-.9.7-1.6 1.6-1.6s1.6.7 1.6 1.6-.7 1.6-1.6 1.6-1.6-.8-1.6-1.6z"}})]),_c('defs',[_c('filter',{attrs:{"id":"Adobe_OpacityMaskFilter","filterUnits":"userSpaceOnUse","x":"0","y":"0","width":"45","height":"45"}},[_c('feColorMatrix',{attrs:{"values":"1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"}})],1)]),_c('mask',{attrs:{"maskUnits":"userSpaceOnUse","x":"0","y":"0","width":"45","height":"45","id":"mask-indication_1_"}},[_c('g',{attrs:{"filter":"url(#Adobe_OpacityMaskFilter)"}},[_c('path',{attrs:{"id":"path-indication_2_","d":"M12 15.2v6.7c0 .8.3 1.6.9 2.2l8 8c.6.6 1.4.9 2.2.9s1.6-.3 2.2-.9l6.7-6.7c.6-.6.9-1.4.9-2.2s-.3-1.6-.9-2.2l-8-8c-.6-.6-1.4-.9-2.2-.9h-6.7c-1.7-.1-3.1 1.3-3.1 3.1zm1.6 0c0-.9.7-1.6 1.6-1.6h6.7c.4 0 .8.2 1.1.5l8 8c.6.6.6 1.6 0 2.2L24.3 31c-.6.6-1.6.6-2.2 0l-8-8c-.3-.3-.5-.7-.5-1.1v-6.7zm1 2.6c0 1.7 1.4 3.2 3.2 3.2s3.2-1.4 3.2-3.2-1.4-3.2-3.2-3.2-3.2 1.4-3.2 3.2zm1.6 0c0-.9.7-1.6 1.6-1.6s1.6.7 1.6 1.6-.7 1.6-1.6 1.6-1.6-.8-1.6-1.6z","fill-rule":"evenodd","clip-rule":"evenodd","fill":"#fff"}})])]),_c('g',{attrs:{"id":"Color-_x2F_-Primary-_x2F_-Teal","mask":"url(#mask-indication_1_)"}},[_c('path',{attrs:{"id":"_x32_FA4C0","fill-rule":"evenodd","clip-rule":"evenodd","fill":"#cba349","d":"M0 0h45v45H0z"}})])])])};var toString = function () {return "/Users/ricky/Sites/Victorium/victorium_v4/src/assets/indication.svg"};module.exports = { render: render, toString: toString };

/***/ }),
/* 718 */
/***/ (function(module, exports) {

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"188","height":"188"}},[_c('image',{attrs:{"x":"49","y":"49","width":"90","height":"90","xlink:href":"data:img/png;base64,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"}})])};var toString = function () {return "/Users/ricky/Sites/Victorium/victorium_v4/src/assets/investigator.svg"};module.exports = { render: render, toString: toString };

/***/ }),
/* 719 */
/***/ (function(module, exports) {

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 45 45","xml:space":"preserve","enable-background":"new 0 0 45 45"}},[_c('g',{attrs:{"id":"icons_x2F_map"}},[_c('g',{attrs:{"id":"MaskMap","transform":"matrix(-1 0 0 1 46.007 0)"}},[_c('path',{attrs:{"id":"path-map_1_","d":"M16.1 12.2c1.8-1.8 4.3-2.8 6.9-2.7 2.6-.1 5.1.9 6.9 2.7 1.8 1.9 2.7 4.5 2.6 7.1 0 4.7-3.1 10.1-8.8 16.2l-.7.6-.7-.7c-5.8-6.1-8.8-11.4-8.8-16.2-.1-2.6.8-5.1 2.6-7zM23 33.4c5-5.4 7.6-10.1 7.6-14.2.1-2.1-.6-4.2-2-5.7-1.5-1.4-3.5-2.2-5.6-2.1-2.1-.1-4.1.7-5.6 2.2-1.5 1.5-2.2 3.6-2.1 5.7.1 3.9 2.7 8.7 7.7 14.1zM23 15c2.2 0 4 1.8 4 4s-1.8 4-4 4-4-1.8-4-4 1.8-4 4-4zm0 5.7c.7 0 1.3-.4 1.6-1.1.3-.6.1-1.4-.4-1.9s-1.2-.6-1.9-.4c-.6.3-1.1.9-1 1.6 0 1 .8 1.8 1.7 1.8z"}})]),_c('defs',[_c('filter',{attrs:{"id":"Adobe_OpacityMaskFilter","filterUnits":"userSpaceOnUse","x":"0","y":"0","width":"45","height":"45"}},[_c('feColorMatrix',{attrs:{"values":"1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"}})],1)]),_c('mask',{attrs:{"maskUnits":"userSpaceOnUse","x":"0","y":"0","width":"45","height":"45","id":"mask-map_1_"}},[_c('g',{attrs:{"filter":"url(#Adobe_OpacityMaskFilter)"}},[_c('path',{attrs:{"id":"path-map_2_","d":"M29.9 12.2C28 10.4 25.6 9.4 23 9.5c-2.6-.1-5.1.9-6.9 2.7-1.8 1.9-2.7 4.5-2.6 7.1 0 4.7 3.1 10.1 8.8 16.2l.7.7.7-.7c5.8-6.1 8.8-11.4 8.8-16.2.2-2.7-.8-5.2-2.6-7.1zM23 33.4c-5-5.4-7.6-10.1-7.6-14.2-.1-2.1.6-4.2 2-5.7 1.5-1.4 3.5-2.2 5.6-2.1 2.1-.1 4.1.7 5.6 2.2 1.5 1.5 2.2 3.6 2.1 5.7-.1 3.9-2.7 8.7-7.7 14.1zM23 15c-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4zm0 5.7c-.7 0-1.3-.4-1.6-1.1-.3-.6-.1-1.4.4-1.9s1.2-.6 1.9-.4c.6.3 1.1.9 1 1.6 0 1-.8 1.8-1.7 1.8z","fill-rule":"evenodd","clip-rule":"evenodd","fill":"#fff"}})])]),_c('g',{attrs:{"id":"Color-_x2F_-Primary-_x2F_-Teal","mask":"url(#mask-map_1_)"}},[_c('path',{attrs:{"id":"_x32_FA4C0","fill-rule":"evenodd","clip-rule":"evenodd","fill":"#cba349","d":"M0 0h45v45H0z"}})])])])};var toString = function () {return "/Users/ricky/Sites/Victorium/victorium_v4/src/assets/map.svg"};module.exports = { render: render, toString: toString };

/***/ }),
/* 720 */
/***/ (function(module, exports) {

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 45 45","xml:space":"preserve","enable-background":"new 0 0 45 45"}},[_c('g',{attrs:{"id":"icons_x2F_Person"}},[_c('g',{attrs:{"id":"Mask"}},[_c('path',{attrs:{"id":"path-person_1_","d":"M23 16.7c-2.2 0-3.9 1.8-3.9 3.9s1.8 3.9 3.9 3.9 3.9-1.8 3.9-3.9-1.7-3.9-3.9-3.9zm0 6.3c-1.3 0-2.4-1.1-2.4-2.4 0-1.3 1.1-2.4 2.4-2.4s2.4 1.1 2.4 2.4c0 1.3-1.1 2.4-2.4 2.4zm0-11c-6.1 0-11 4.9-11 11s4.9 11 11 11 11-4.9 11-11-4.9-11-11-11zm-5.3 18.8c.1-.3.2-.6.3-.8 1-1.9 2.9-3 5-3s4 1.2 5 3.1c.1.2.2.5.3.7-1.6 1.1-3.4 1.6-5.3 1.6s-3.8-.6-5.3-1.6zm11.9-1.1c0-.1-.1-.3-.2-.4-1.2-2.4-3.6-3.9-6.3-3.9-2.7 0-5.1 1.4-6.4 3.7-.1.2-.2.4-.2.6-2.7-2.7-3.6-6.8-2.1-10.3s4.9-5.9 8.7-5.9 7.3 2.3 8.7 5.9c1.4 3.6.6 7.6-2.2 10.3z"}})]),_c('defs',[_c('filter',{attrs:{"id":"Adobe_OpacityMaskFilter","filterUnits":"userSpaceOnUse","x":"0","y":"0","width":"45","height":"45"}},[_c('feColorMatrix',{attrs:{"values":"1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"}})],1)]),_c('mask',{attrs:{"maskUnits":"userSpaceOnUse","x":"0","y":"0","width":"45","height":"45","id":"mask-person_1_"}},[_c('g',{attrs:{"filter":"url(#Adobe_OpacityMaskFilter)"}},[_c('path',{attrs:{"id":"path-person_2_","d":"M23 16.7c-2.2 0-3.9 1.8-3.9 3.9s1.8 3.9 3.9 3.9 3.9-1.8 3.9-3.9-1.7-3.9-3.9-3.9zm0 6.3c-1.3 0-2.4-1.1-2.4-2.4 0-1.3 1.1-2.4 2.4-2.4s2.4 1.1 2.4 2.4c0 1.3-1.1 2.4-2.4 2.4zm0-11c-6.1 0-11 4.9-11 11s4.9 11 11 11 11-4.9 11-11-4.9-11-11-11zm-5.3 18.8c.1-.3.2-.6.3-.8 1-1.9 2.9-3 5-3s4 1.2 5 3.1c.1.2.2.5.3.7-1.6 1.1-3.4 1.6-5.3 1.6s-3.8-.6-5.3-1.6zm11.9-1.1c0-.1-.1-.3-.2-.4-1.2-2.4-3.6-3.9-6.3-3.9-2.7 0-5.1 1.4-6.4 3.7-.1.2-.2.4-.2.6-2.7-2.7-3.6-6.8-2.1-10.3s4.9-5.9 8.7-5.9 7.3 2.3 8.7 5.9c1.4 3.6.6 7.6-2.2 10.3z","fill-rule":"evenodd","clip-rule":"evenodd","fill":"#fff"}})])]),_c('g',{attrs:{"id":"Color-_x2F_-Primary-_x2F_-Teal","mask":"url(#mask-person_1_)"}},[_c('path',{attrs:{"id":"_x32_FA4C0","fill-rule":"evenodd","clip-rule":"evenodd","fill":"#cba349","d":"M0 0h45v45H0z"}})])])])};var toString = function () {return "/Users/ricky/Sites/Victorium/victorium_v4/src/assets/person.svg"};module.exports = { render: render, toString: toString };

/***/ }),
/* 721 */
/***/ (function(module, exports) {

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 45 45","xml:space":"preserve","enable-background":"new 0 0 45 45"}},[_c('g',{attrs:{"id":"icons_x2F_phone"}},[_c('g',{attrs:{"id":"Mask"}},[_c('path',{attrs:{"id":"path-phone_1_","d":"M29.6 25c-.8-.1-1.6-.3-2.4-.6-.6-.2-1.3-.1-1.8.4l-1.1 1.1c-2.1-1.2-3.9-3-5.1-5.1l1.1-1.1c.5-.5.6-1.2.4-1.8-.3-.8-.5-1.6-.7-2.5-.2-.8-.9-1.4-1.7-1.4h-2.5c-.5 0-.9.2-1.3.6-.3.4-.5.8-.4 1.3.3 2.6 1.2 5.2 2.6 7.4 1.3 2.1 3.1 3.8 5.1 5.1 2.2 1.4 4.8 2.3 7.4 2.6h.1c.4 0 .8-.2 1.2-.5.4-.3.6-.8.6-1.3v-2.5c-.1-.8-.7-1.6-1.5-1.7zm0 4.2c0 .1 0 .2-.1.2-.1.1-.1.1-.2.1-2.4-.2-4.7-1-6.8-2.3-1.9-1.2-3.5-2.8-4.7-4.7-1.3-2-2.1-4.4-2.4-6.8v-.2c.1-.1.2-.1.3-.1h2.5c.1 0 .3.1.3.2.1.9.4 1.8.7 2.7.1.1.1.2 0 .3l-1.9 1.9.5.9c1.3 2.4 3.3 4.3 5.7 5.7l.9.5 1.8-1.8c.1-.1.2-.1.3 0 .9.3 1.8.6 2.7.7.1 0 .2.2.2.3v2.4z"}})]),_c('defs',[_c('filter',{attrs:{"id":"Adobe_OpacityMaskFilter","filterUnits":"userSpaceOnUse","x":"0","y":"0","width":"45","height":"45"}},[_c('feColorMatrix',{attrs:{"values":"1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"}})],1)]),_c('mask',{attrs:{"maskUnits":"userSpaceOnUse","x":"0","y":"0","width":"45","height":"45","id":"mask-phone_1_"}},[_c('g',{attrs:{"filter":"url(#Adobe_OpacityMaskFilter)"}},[_c('path',{attrs:{"id":"path-phone_2_","d":"M29.6 25c-.8-.1-1.6-.3-2.4-.6-.6-.2-1.3-.1-1.8.4l-1.1 1.1c-2.1-1.2-3.9-3-5.1-5.1l1.1-1.1c.5-.5.6-1.2.4-1.8-.3-.8-.5-1.6-.7-2.5-.2-.8-.9-1.4-1.7-1.4h-2.5c-.5 0-.9.2-1.3.6-.3.4-.5.8-.4 1.3.3 2.6 1.2 5.2 2.6 7.4 1.3 2.1 3.1 3.8 5.1 5.1 2.2 1.4 4.8 2.3 7.4 2.6h.1c.4 0 .8-.2 1.2-.5.4-.3.6-.8.6-1.3v-2.5c-.1-.8-.7-1.6-1.5-1.7zm0 4.2c0 .1 0 .2-.1.2-.1.1-.1.1-.2.1-2.4-.2-4.7-1-6.8-2.3-1.9-1.2-3.5-2.8-4.7-4.7-1.3-2-2.1-4.4-2.4-6.8v-.2c.1-.1.2-.1.3-.1h2.5c.1 0 .3.1.3.2.1.9.4 1.8.7 2.7.1.1.1.2 0 .3l-1.9 1.9.5.9c1.3 2.4 3.3 4.3 5.7 5.7l.9.5 1.8-1.8c.1-.1.2-.1.3 0 .9.3 1.8.6 2.7.7.1 0 .2.2.2.3v2.4z","fill-rule":"evenodd","clip-rule":"evenodd","fill":"#fff"}})])]),_c('g',{attrs:{"id":"Color-_x2F_-Primary-_x2F_-Teal","mask":"url(#mask-phone_1_)"}},[_c('path',{attrs:{"id":"_x32_FA4C0","fill-rule":"evenodd","clip-rule":"evenodd","fill":"#cba349","d":"M0 0h45v45H0z"}})])])])};var toString = function () {return "/Users/ricky/Sites/Victorium/victorium_v4/src/assets/phone.svg"};module.exports = { render: render, toString: toString };

/***/ }),
/* 722 */
/***/ (function(module, exports) {

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 45 45","xml:space":"preserve","enable-background":"new 0 0 45 45"}},[_c('g',{attrs:{"id":"icons_x2F_right-chevron"}},[_c('g',{attrs:{"id":"_x2665__xFE0F_-icon"}}),_c('defs',[_c('filter',{attrs:{"id":"Adobe_OpacityMaskFilter","filterUnits":"userSpaceOnUse","x":"0","y":"0","width":"45","height":"45"}},[_c('feColorMatrix',{attrs:{"values":"1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"}})],1)]),_c('mask',{attrs:{"maskUnits":"userSpaceOnUse","x":"0","y":"0","width":"45","height":"45","id":"mask-right_1_"}},[_c('g',{attrs:{"filter":"url(#Adobe_OpacityMaskFilter)"}},[_c('path',{attrs:{"id":"path-right_1_","fill-rule":"evenodd","clip-rule":"evenodd","fill":"#fff","d":"M19.1 14L17 16.1l6.9 6.9-6.9 6.9 2.1 2.1 9-9z"}})])]),_c('g',{attrs:{"id":"Color-_x2F_-Primary-_x2F_-Teal","mask":"url(#mask-right_1_)"}},[_c('path',{attrs:{"id":"_x32_FA4C0","fill-rule":"evenodd","clip-rule":"evenodd","fill":"#cba349","d":"M0 0h45v45H0z"}})])])])};var toString = function () {return "/Users/ricky/Sites/Victorium/victorium_v4/src/assets/right_chevron.svg"};module.exports = { render: render, toString: toString };

/***/ }),
/* 723 */
/***/ (function(module, exports) {

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 45 45","xml:space":"preserve","enable-background":"new 0 0 45 45"}},[_c('g',{attrs:{"id":"icons_x2F_trash"}},[_c('g',{attrs:{"id":"Mask"}},[_c('path',{attrs:{"id":"path-trash_1_","d":"M31.1 15.9h-5.9v-.6C25 14 23.9 13 22.6 13s-2.4 1-2.6 2.3v.6h-6v1.4h1.5l1.2 14.4c.1.7.7 1.3 1.4 1.3H27c.7 0 1.4-.6 1.4-1.3l1.2-14.4h1.5v-1.4zM27 31.6h-8.8L17 17.3h11.2L27 31.6zm-5.6-16.1c.1-.6.6-1 1.1-1s1 .4 1.1 1v.5h-2.3l.1-.5zm-1.7 4.7h1.4v8.6h-1.4v-8.6zm4.3 0h1.4v8.6H24v-8.6z"}})]),_c('defs',[_c('filter',{attrs:{"id":"Adobe_OpacityMaskFilter","filterUnits":"userSpaceOnUse","x":"0","y":"0","width":"45","height":"45"}},[_c('feColorMatrix',{attrs:{"values":"1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"}})],1)]),_c('mask',{attrs:{"maskUnits":"userSpaceOnUse","x":"0","y":"0","width":"45","height":"45","id":"mask-trash_1_"}},[_c('g',{attrs:{"filter":"url(#Adobe_OpacityMaskFilter)"}},[_c('path',{attrs:{"id":"path-trash_2_","d":"M31.1 15.9h-5.9v-.6C25 14 23.9 13 22.6 13s-2.4 1-2.6 2.3v.6h-6v1.4h1.5l1.2 14.4c.1.7.7 1.3 1.4 1.3H27c.7 0 1.4-.6 1.4-1.3l1.2-14.4h1.5v-1.4zM27 31.6h-8.8L17 17.3h11.2L27 31.6zm-5.6-16.1c.1-.6.6-1 1.1-1s1 .4 1.1 1v.5h-2.3l.1-.5zm-1.7 4.7h1.4v8.6h-1.4v-8.6zm4.3 0h1.4v8.6H24v-8.6z","fill-rule":"evenodd","clip-rule":"evenodd","fill":"#fff"}})])]),_c('g',{attrs:{"id":"Color-_x2F_-Primary-_x2F_-Teal","mask":"url(#mask-trash_1_)"}},[_c('path',{attrs:{"id":"_x32_FA4C0","fill-rule":"evenodd","clip-rule":"evenodd","fill":"#cba349","d":"M0 0h45v45H0z"}})])])])};var toString = function () {return "/Users/ricky/Sites/Victorium/victorium_v4/src/assets/trash.svg"};module.exports = { render: render, toString: toString };

/***/ }),
/* 724 */
/***/ (function(module, exports) {

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 45 45","xml:space":"preserve","enable-background":"new 0 0 45 45"}},[_c('g',{attrs:{"id":"icons_x2F_trial"}},[_c('g',{attrs:{"id":"Mask"}},[_c('path',{attrs:{"id":"path-trial_1_","d":"M31.8 17.5H23L20.5 15H13v13.8c0 .7.6 1.2 1.2 1.2h17.5c.7 0 1.2-.6 1.2-1.2v-10c.1-.7-.5-1.3-1.1-1.3zm-17.6-1.3H20l1.2 1.2h-7v-1.2zm17.6 12.6H14.2v-10h17.5v10z"}})]),_c('defs',[_c('filter',{attrs:{"id":"Adobe_OpacityMaskFilter","filterUnits":"userSpaceOnUse","x":"0","y":"0","width":"45","height":"45"}},[_c('feColorMatrix',{attrs:{"values":"1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"}})],1)]),_c('mask',{attrs:{"maskUnits":"userSpaceOnUse","x":"0","y":"0","width":"45","height":"45","id":"mask-trial_1_"}},[_c('g',{attrs:{"filter":"url(#Adobe_OpacityMaskFilter)"}},[_c('path',{attrs:{"id":"path-trial_2_","d":"M31.8 17.5H23L20.5 15H13v13.8c0 .7.6 1.2 1.2 1.2h17.5c.7 0 1.2-.6 1.2-1.2v-10c.1-.7-.5-1.3-1.1-1.3zm-17.6-1.3H20l1.2 1.2h-7v-1.2zm17.6 12.6H14.2v-10h17.5v10z","fill-rule":"evenodd","clip-rule":"evenodd","fill":"#fff"}})])]),_c('g',{attrs:{"id":"Color-_x2F_-Primary-_x2F_-Teal","mask":"url(#mask-trial_1_)"}},[_c('path',{attrs:{"id":"_x32_FA4C0","fill-rule":"evenodd","clip-rule":"evenodd","fill":"#cba349","d":"M0 0h45v45H0z"}})])])])};var toString = function () {return "/Users/ricky/Sites/Victorium/victorium_v4/src/assets/trial.svg"};module.exports = { render: render, toString: toString };

/***/ }),
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(222);
module.exports = __webpack_require__(221);


/***/ })
]),[728]);


// WEBPACK FOOTER //
// static/js/app.323a23701477035d7a99.js